<template>
  <loading :active="releaseType"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="true"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots"
            :style="style">
            <!-- <div class="text-center text-blue-50 text-4xl" style="background-color:red;word-wrap:break-word; width:300px;">建立關鍵字...</div>
            <div class="w-2/4" style="background-color:blue;display: flex; justify-content: center; align-items: center; width:300px; ">
              <div style="margin: auto"> -->
                <!-- <circle-progress :percent="releasePercent" :show-percent="true" :class="'text-blue-50 text-4xl'"/> -->
                <div id="myItem5" class="ldBar label-center" data-type="fill" data-img="https://private.autoturn.net/autoturn_logo_v04.svg" style="width:300px;height:300px;" ></div>
              <!-- </div>
            </div> -->
  </loading>
  <loading :active="allPageLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="true"
          :color="'#fff'"
          :background-color="'#000'"
          :opacity="'0.8'"
          :loader=" dots">
  </loading>
  <div class="flex-1 flex flex-col overflow-hidden mb-16">
    <loading :active="!showCampaignData"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="true"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <loading :active="releaseLoading"
              :can-cancel="true"
              :on-cancel="onCancel"
              :is-full-page="true"
              :color="'#fff'"
              :background-color="'#000'"
              :opacity="'0.8'"
              :loader=" dots">
              <div class="text-center">{{releaseText}}</div><circle-progress :percent="releasePercent" :show-percent="true"/>
    </loading>
    <Header :title="'自定義活動修改頁'" @childLang="useLang" @toggleSidebar="$emit('toggleSidebar')">
      <div class="mx-2 lg:mx-4 text-gray-700 text-sm lg:text-base">
        {{showLang[selectLang]['views']['Event']['advertising_source']}}
      </div>
      <div class="flex items-center mx-1 text-sm text-gray-400 leading-7 border-2 rounded-md px-1 ml-2" style="border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);">
        <img width="28" src="https://private.autoturn.net/img/facebook_icon.png"/>
        <div class="mx-1 text-sm leading-7">
          {{ adaccount_name }}
        </div>
      </div>
      <div v-show="false" class="flex items-center mx-1 text-sm text-gray-400 leading-7 border-2 rounded-md px-1 ml-2" style="border: 2px solid #111827; color: #111827;">
        <img width="25" src="https://private.autoturn.net/img/tiktok_icon.png"/>
        {{ tiktok_adaccount_name }}
      </div>
    </Header>
    <main class="flex overflow-x-hidden d2-evt-main">
      <div class="d2-evt-nav">
        <div v-if="false" class="w-full rounded-xl bg-white p-4" :style="{height: `520px`}">
          <div v-show="false" class="h-16">
            <span v-if="!isEdit" class="h-16 break-all" @click="campaignNameEdit(true)">{{campaign_name}}</span>
            <span v-if="!isEdit && campaign_name == ''" class="h-16 text-gray-400 break-all" @click="campaignNameEdit(true)">{{showLang[selectLang]['views']['Event']['campaign_name_text']}}</span>
            <textarea v-if="isEdit" id="campaignName" class="w-full border p-1" v-model="campaign_name" @blur="campaignNameEdit(false)"></textarea>
            <i class="pi pi-pencil cursor-pointer float-right" style="fontSize: 0.8rem" @click="isEdit=!isEdit"></i>
          </div>
          <hr v-show="false" class="mb-4 border-b-1 border-blueGray-200">
          <div class="space-y-4 overflow-y-auto" :style="{height: `480px`}">
            <div v-for="(item, index) in menu" :key="index">
              <div
                v-if="item?.show"
                @click="getHere(item?.target)"
                :class="[
                  item?.open? 'text-gray-700 p-1 cursor-pointer h-8 -mb-6' : 'text-gray-300',
                  item?.target === target? 'bg-gray-100 rounded-xl' : ''
                ]">
                <!-- <i class="pi pi-chevron-down"></i> -->
                <i class="pi pi-chevron-down block float-left mt-1.5"></i>
                <!-- <span class="mx-2">{{ item.title }}</span> -->
                <span class="mx-2 block float-left w-auto" style="max-width: 85%">{{ item?.title }}</span>
                <i class="pi pi-lock float-right" v-if="!item?.open"></i>
              </div>
              <div class="space-y-2 ml-4 my-2 mt-7" style="clear: both" v-if="item?.open">
                <div
                  class="text-gray-700 cursor-pointer ml-1"
                  @click="getHere(item?.target)"
                  v-for="(sub, idx) in item?.submenu" :key="idx">
                  <span v-if="sub.show" class="mx-2 block w-auto" style="max-width: 85%">{{ sub.title }}</span>
                  <i class="pi pi-check-circle float-right" v-if="sub.checked"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full rounded-xl bg-white space-y-4 overflow-x-hidden scrollbar-y p-4" :style="{height: `660px`}">
          <div v-for="(group, groupIndex) in rawData" :key="groupIndex" class="border rounded-md bg-gray-50">
            <!-- 每個群組的標題 -->
            <!-- <h3 class="text-sm font-bold mb-4">分組 {{ groupIndex + 1 }}</h3> -->
            <!-- 每個群組中的每一條數據 -->
            <div v-for="(item, itemIndex) in group" :key="itemIndex" class="m-2 border p-2 rounded-md">
              <!--  @click="switchArea(item.area, groupIndex, itemIndex)" -->
              <div class="flex justify-between items-center pb-2">
                <p class="text-gray-800 font-bold text-md">
                  {{ getMethodLabel(item.method) }} <span v-if="item.platform != null">({{ item.platform }})</span>
                </p>
                <!-- 是否可以前進的箭頭樣式 -->
                <span
                  v-if="item.isGoAhead === true"
                  class="text-sm font-bold text-blue-500"
                  v-tooltip.top="'為前進條件'"
                >
                  →
                </span>
              </div>
              <div class="space-y-1">
                <p v-for="(itemList, itemListIndex) in item.list" :key="itemListIndex" class="text-sm text-gray-600 ml-4 cursor-pointer" @click="switchItem(item.area, groupIndex, itemIndex, itemList.refName, itemList.groupType)">
                  <span v-if="itemList.showStatus === true">{{itemList.title}}</span>
                </p>
                <!-- <p v-if="item.method === 'META_KW'" class="text-sm text-gray-600">精準興趣廣告組合與關鍵字</p>
                <p v-if="item.method === 'META_LA'" class="text-sm text-gray-600">前進規則</p> -->
              </div>
            </div>
          </div>
        </div>


      </div>
      <div id="edit_content" ref="scrollcontent" class="d2-evt-editor">
        <div v-show="target == 1">
          <CampaignName ref="childCampaignName" v-bind:editPage="cancelEdit" v-model:viewDatalist="campaign_name" @childCampaignName="campaignData" v-bind:lang="showLang[selectLang]" />
          <MarketingMethod ref="childMarketingMethod" v-bind:editPage="cancelEdit" v-model:viewDatalist="methodData" v-bind:goalsObjective="getGoalsObjective" v-bind:currencyList="currencyData" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:otherCustomTitle="otherCustomTitle" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childTargetKW="methodTargetKW" @childTargetDM="methodTargetDM" @childTargetLA="methodTargetLA" @childTargetRT="methodTargetRT" @childTargetCF="methodTargetCF" @childTargetAD="methodTargetAD" @childTargetCR="methodTargetCR" @childBudgetKWTotal="methodBudgetKWTotal"  @childObjective="goalsObjective" @childOtherCustom="getOtherCustom" @childHideCustom="setHideCustom"/>
          <BenefitsAndInvestment :locale="selectLang" ref="childBenefitsAndInvestment" v-bind:editPage="cancelEdit" v-bind:viewDatalist="benefitsAndInvestmentData" v-bind:lang="showLang[selectLang]" />
          <CustomRules v-if="false" v-bind:editPage="cancelEdit" v-bind:viewDatalist="keywordData" v-bind:defaultStage="defaultStage" v-bind:stageMenu="stageMenu" v-bind:tiktokDefaultStage="tiktokDefaultStage" v-bind:tiktokStageMenu="tiktokStageMenu" v-bind:menu="menu" v-model:customRulesDataList="customRulesData" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:pixelId="this.goalsData.pixel_id" v-bind:productUrl="this.productUrl" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childKeywordUrl="keywordUrl" @childHaveTest="haveTest"  @childUseASC="useASC"/>
          <StageTreeComponent v-if="showTargetCR == true || showOtherTargetCR == true" ref="childStageTreeComponent" v-bind:editPage="cancelEdit" v-bind:defaultStage="defaultStage" v-bind:treeMenu="treeMenu" v-bind:stageTreeHaveTest="stageTreeHaveTest" v-bind:stageTreeList="stageTreeList" v-bind:stageTreeContent="stageTreeContent" @childStageTreeHaveTest="updateStageTreeHaveTest" @childStageTreeList="updateStageTreeList"/>
          <StageDynamicBudget v-if="false" v-bind:editPage="cancelEdit" v-bind:viewDatalist="dynBudgetData" v-bind:lang="showLang[selectLang]" />
          <StageDoForward v-if="false" v-bind:editPage="cancelEdit" v-bind:viewDatalist="doForwardData" v-bind:lang="showLang[selectLang]" />
          <KeywordMix v-if="showTargetAD || showTargetKW || showTargetLA" v-bind:editPage="cancelEdit" v-bind:targetKW="showTargetKW" v-bind:targetAD="showTargetAD" v-bind:viewDatalist="keywordData" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childKeywordUrl="keywordUrl" />
          <AdvertisingMix v-if="showTargetLA" v-bind:showAdvertisingMix="showAdvertisingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="lookData" v-bind:adaccountId="adaccount_id" v-bind:pixelId="formPixelId" v-bind:productUrl="productUrl" v-bind:lang="showLang[selectLang]" />
          <RemarketingMix v-if="showTargetRT" v-bind:showRemarketingMix="showRemarketingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="audiencesData" v-bind:adaccountId="adaccount_id" v-bind:pixelId="formPixelId" v-bind:productUrl="productUrl" v-bind:lang="showLang[selectLang]" />
          <ConfidentialAudience v-if="showTargetCF" v-bind:showMarketingDate="showMarketingDate" v-bind:editPage="cancelEdit" v-bind:viewDatalist="dateData" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" />
          <MarketingDate ref="childMarketingDate" v-bind:showMarketingDate="showMarketingDate" v-bind:editPage="cancelEdit" v-bind:viewDatalist="dateData" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:efficientAi="efficientAi" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childGapTime="dateGapTime" @childEndTime="dateEndTime" @childUseEndDate="dateUseEndDate" />
        </div>
       <!--  <div v-show="target == 2">
          <KeywordMix v-if="showTargetKW || showTargetLA" v-bind:editPage="cancelEdit" v-bind:targetKW="showTargetKW" v-bind:viewDatalist="keywordData" @childKeywordUrl="keywordUrl" />
          <AdvertisingMix v-if="showTargetLA" v-bind:showAdvertisingMix="showAdvertisingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="lookData" v-bind:adaccountId="adaccount_id" v-bind:pageId="formPageId" v-bind:productUrl="productUrl" />
        </div> -->
        <div v-show="target == 2">
          <div v-show="showTargetCR == true || showOtherTargetCR == true">
            <div v-if="useTree === true">
              <StageTreeBlock v-bind:editPage="cancelEdit" v-bind:activeStageTreeNodeIndex="activeStageTreeNodeIndex" v-bind:activeStageTreeItemIndex="activeStageTreeItemIndex" v-bind:treeUpdateStatus="treeUpdateStatus" v-bind:stageTreeList="stageTreeList" v-model:viewDatalist="campaign_name" v-model:customRulesDataList="customRulesData"  @childCampaignName="campaignData" v-bind:lang="showLang[selectLang]" @childSwitchPhase="switchPhase"/>

              <StageTreeKeywordMix ref="childStageKeywordMix" v-bind:editPage="cancelEdit" v-bind:targetKW="showTargetKW" v-bind:targetAD="showTargetAD" v-bind:viewDatalist="stageTreeContent[activeStageTreeNodeIndex][activeStageTreeItemIndex]?.keywordData" v-bind:stageContent="stageTreeContent[activeStageTreeNodeIndex][activeStageTreeItemIndex]" v-bind:stageTreeList="stageTreeList[activeStageTreeNodeIndex][activeStageTreeItemIndex]" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childKeywordUrl="keywordUrl" />
              <StageTreeAdvertisingMix ref="childStageAdvertisingMix" v-bind:showAdvertisingMix="showAdvertisingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="stageTreeContent[activeStageTreeNodeIndex][activeStageTreeItemIndex]?.lookData" v-bind:stageContent="stageTreeContent[activeStageTreeNodeIndex][activeStageTreeItemIndex]" v-bind:stageTreeList="stageTreeList[activeStageTreeNodeIndex][activeStageTreeItemIndex]" v-bind:adaccountId="adaccount_id" v-bind:pixelId="formPixelId" v-bind:productUrl="productUrl" v-bind:lang="showLang[selectLang]" />
              <StageTreeRemarketingMix ref="childStargeRemarketingMix" v-bind:showRemarketingMix="showRemarketingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="stageTreeContent[activeStageTreeNodeIndex][activeStageTreeItemIndex]?.audiencesData" v-bind:stageContent="stageTreeContent[activeStageTreeNodeIndex][activeStageTreeItemIndex]" v-bind:stageTreeList="stageTreeList[activeStageTreeNodeIndex][activeStageTreeItemIndex]" v-bind:adaccountId="adaccount_id" v-bind:pixelId="formPixelId" v-bind:productUrl="productUrl" v-bind:lang="showLang[selectLang]" />
              <StageTreeGoalsAndBudget ref="childStageGoalsAndBudget" v-bind:showGoalsAndBudget="showGoalsAndBudget" v-bind:stageContentAll="stageTreeContent" v-bind:stageContent="stageTreeContent[activeStageTreeNodeIndex][activeStageTreeItemIndex]" v-bind:stageContentLength="stageTreeContent.length" v-bind:stageIndex="activeStageTreeNodeIndex" v-bind:stageItemIndex="activeStageTreeItemIndex" v-bind:stageTreeHaveTest="stageTreeHaveTest" v-bind:stageTreeList="stageTreeList[activeStageTreeNodeIndex][activeStageTreeItemIndex]" v-bind:editPage="cancelEdit" v-bind:viewDatalist="goalsData" v-bind:getDate="returnGapTime" v-bind:budgetKWTotal="budgetKW" v-bind:useEndDate="returnUseEndDate" v-bind:formMinAddition="updateMinAddition" v-bind:currencyList="currencyData" v-bind:lang="showLang[selectLang]" v-bind:useLang="selectLang" v-bind:youtubeClose="youtubeClose" v-bind:haveASC="haveASC" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childObjective="goalsObjective" @childObjectiveOption="objectiveOption"/>
              <StageTreeRegions ref="childStageRegions" v-bind:editPage="cancelEdit" v-bind:viewDatalist="regionsData" v-bind:stageContentAll="stageTreeContent" v-bind:stageContent="stageTreeContent[activeStageTreeNodeIndex][activeStageTreeItemIndex]" v-bind:stageTreeList="stageTreeList[activeStageTreeNodeIndex][activeStageTreeItemIndex]" v-bind:stageIndex="activeStageTreeNodeIndex" v-bind:stageItemIndex="activeStageTreeItemIndex" v-bind:viewRelationshipDatalist="exAudiencesData" v-bind:campaignId="campaign_id" v-bind:targetDM="showTargetDM" v-model:selectCountries="selectCountries" v-model:selectLangs="selectLangs" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" />
              <StageTreePositionDeviceIdentity ref="childStagePositionDeviceIdentity" v-bind:editPage="cancelEdit" v-bind:viewDatalist="pdData" v-bind:stageContentAll="stageTreeContent" v-bind:stageContent="stageTreeContent[activeStageTreeNodeIndex][activeStageTreeItemIndex]" v-bind:stageIndex="activeStageTreeNodeIndex" v-bind:stageItemIndex="activeStageTreeItemIndex" v-bind:stageTreeHaveTest="stageTreeHaveTest" v-bind:stageTreeList="stageTreeList[activeStageTreeNodeIndex][activeStageTreeItemIndex]" v-bind:autoPublisher="auto_publisher" v-bind:publisherPlatforms="publisher_platforms" v-bind:lang="showLang[selectLang]" v-bind:showIdentity="showIdentity" v-bind:viewIdentityDatalist="idData" @checkClose="changeYoutubeType" @childYoutube="childYoutube" v-bind:youtubeClose="youtubeClose" @childPageId="eventPageId" />
              <StageTreeMaterial ref="childStageMaterial" v-bind:showStageMaterial="showStageMaterial" v-bind:showStageAdvertisingMaterial="showStageAdvertisingMaterial" v-bind:showStageForm="showStageForm" v-bind:showStageMsg="showStageMsg" v-bind:editPage="cancelEdit" v-bind:viewDatalist="stageTreeContent[activeStageTreeNodeIndex][activeStageTreeItemIndex]?.postData" v-model:viewAdMaterialDatalist="viewAdMaterialDatalist" v-bind:viewFormDatalist="idData" v-bind:stageContentAll="stageTreeContent" v-bind:stageContent="stageTreeContent[activeStageTreeNodeIndex][activeStageTreeItemIndex]" v-bind:stageIndex="activeStageTreeNodeIndex" v-bind:stageItemIndex="activeStageTreeItemIndex" v-bind:stageTreeHaveTest="stageTreeHaveTest" v-bind:stageTreeList="stageTreeList[activeStageTreeNodeIndex][activeStageTreeItemIndex]" v-bind:pageId="formPageId" v-bind:goalsObjective="stageTreeContent[activeStageTreeNodeIndex][activeStageTreeItemIndex]?.goalsData.campaign_objective" v-bind:optimizationAction="currentOptimizationAction" v-bind:campaignId="campaign_id" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:changeFormId="changeFormId" v-bind:changeMessageId="changeMessageId" v-bind:firstFormId="first_form_id" v-bind:formStatus="form_status" v-bind:formId="formId" v-bind:firstMessageId="first_message_id" v-bind:messageStatus="message_status" v-bind:messageId="messageId" v-bind:useTeachDetail="use_teach_detail" v-bind:showTargetCR="showTargetCR" v-bind:showOtherTargetCR="showOtherTargetCR" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childActiveScroll="activeScroll" @childFormId="eventFormId" @childMessageId="eventMessageId" @childContent="adMaterialContent" @childChangeMessageId="formChangeMessageId"/>
            </div>

            <div v-if="useTree === false">
              <StageBlock v-bind:editPage="cancelEdit" v-model:viewDatalist="campaign_name" v-model:customRulesDataList="customRulesData"  @childCampaignName="campaignData" v-bind:lang="showLang[selectLang]" @childChangeEdit="changeEdit"/> 
              <div v-show="customRulesData.subCampaignsContent[customRulesData.editIndex].method != 'TIKTOK_KW' && customRulesData.subCampaignsContent[customRulesData.editIndex].method != 'TIKTOK_RT'">
                <StageKeywordMix v-bind:editPage="cancelEdit" v-bind:targetKW="showTargetKW" v-bind:targetAD="showTargetAD" v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].keywordData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childKeywordUrl="keywordUrl" />
                <StageAdvertisingMix v-bind:showAdvertisingMix="showAdvertisingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].lookData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:adaccountId="adaccount_id" v-bind:pixelId="formPixelId" v-bind:productUrl="productUrl" v-bind:lang="showLang[selectLang]" />
                <StageRemarketingMix v-bind:showRemarketingMix="showRemarketingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].audiencesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:adaccountId="adaccount_id" v-bind:pixelId="formPixelId" v-bind:productUrl="productUrl" v-bind:lang="showLang[selectLang]" />
                <StageGoalsAndBudget v-bind:showGoalsAndBudget="showGoalsAndBudget" v-bind:stageContentAll="customRulesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:stageContentLength="customRulesData.subCampaignsContent.length" v-bind:stageIndex="customRulesData.editIndex" v-bind:editPage="cancelEdit" v-bind:viewDatalist="goalsData" v-bind:getDate="returnGapTime" v-bind:budgetKWTotal="budgetKW" v-bind:useEndDate="returnUseEndDate" v-bind:formMinAddition="updateMinAddition" v-bind:currencyList="currencyData" v-bind:lang="showLang[selectLang]" v-bind:useLang="selectLang" v-bind:youtubeClose="youtubeClose" v-bind:haveASC="haveASC" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childObjective="goalsObjective" @childObjectiveOption="objectiveOption"/>
                <StageRegions v-bind:editPage="cancelEdit" v-bind:viewDatalist="regionsData" v-bind:stageContentAll="customRulesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:stageIndex="customRulesData.editIndex" v-bind:viewRelationshipDatalist="exAudiencesData" v-bind:campaignId="campaign_id" v-bind:targetDM="showTargetDM" v-model:selectCountries="selectCountries" v-model:selectLangs="selectLangs" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" />
                <StagePositionDeviceIdentity v-bind:editPage="cancelEdit" v-bind:viewDatalist="pdData" v-bind:stageContentAll="customRulesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:stageIndex="customRulesData.editIndex" v-bind:autoPublisher="auto_publisher" v-bind:publisherPlatforms="publisher_platforms" v-bind:lang="showLang[selectLang]" v-bind:showIdentity="showIdentity" v-bind:viewIdentityDatalist="idData" @checkClose="changeYoutubeType" @childYoutube="childYoutube" v-bind:youtubeClose="youtubeClose" @childPageId="eventPageId" />
                <StageMaterial v-bind:showStageMaterial="showStageMaterial" v-bind:showStageAdvertisingMaterial="showStageAdvertisingMaterial" v-bind:showStageForm="showStageForm" v-bind:showStageMsg="showStageMsg" v-bind:editPage="cancelEdit" v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].postData" v-model:viewAdMaterialDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].adMaterialData" v-bind:viewFormDatalist="idData" v-bind:stageContentAll="customRulesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:stageIndex="customRulesData.editIndex" v-bind:pageId="formPageId" v-bind:goalsObjective="customRulesData.subCampaignsContent[customRulesData.editIndex].goalsData.campaign_objective" v-bind:optimizationAction="currentOptimizationAction" v-bind:campaignId="campaign_id" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:changeFormId="changeFormId" v-bind:changeMessageId="changeMessageId" v-bind:firstFormId="first_form_id" v-bind:formStatus="form_status" v-bind:formId="formId" v-bind:firstMessageId="first_message_id" v-bind:messageStatus="message_status" v-bind:messageId="messageId" v-bind:useTeachDetail="use_teach_detail" v-bind:showTargetCR="showTargetCR" v-bind:showOtherTargetCR="showOtherTargetCR" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childActiveScroll="activeScroll" @childFormId="eventFormId" @childMessageId="eventMessageId" @childContent="adMaterialContent" @childChangeMessageId="formChangeMessageId"/>
              </div>
              <div v-show="customRulesData.subCampaignsContent[customRulesData.editIndex].method == 'TIKTOK_KW' || customRulesData.subCampaignsContent[customRulesData.editIndex].method == 'TIKTOK_RT'">
                <StageTikTokKeywordMix v-bind:editPage="cancelEdit" v-bind:targetKW="showTargetKW" v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].keywordData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:lang="showTiktokLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:returnKeywordsList="returnKeywordsList" v-bind:noTiktokData="noTiktokStatus" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childKeywordUrl="keywordUrl" @childSelectedCategories="childSelectedCategories" />
                <StageTikTokGoalsAndBudget v-bind:showGoalsAndBudget="showGoalsAndBudget" v-bind:editPage="cancelEdit" v-bind:viewGoalsDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].goalsData" v-bind:viewBudgetDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].budgetData" v-bind:stageContentAll="customRulesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:stageContentLength="customRulesData.subCampaignsContent.length" v-bind:stageIndex="customRulesData.editIndex" v-bind:getDate="returnGapTime" v-bind:budgetKWTotal="budgetKW" v-bind:useEndDate="returnUseEndDate" v-bind:formMinAddition="updateMinAddition" v-bind:currencyList="currencyData" v-bind:lang="showTiktokLang[selectLang]" v-bind:useLang="selectLang" v-bind:youtubeClose="youtubeClose" v-bind:efficientAi="efficientAi" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childObjective="goalsObjective" @childObjectiveOption="objectiveOption"/>
                <StageTikTokRegions v-bind:editPage="cancelEdit" v-bind:viewLocalDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].localData" v-bind:viewDemoDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].demoData" v-bind:stageContentAll="customRulesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:stageIndex="customRulesData.editIndex" v-bind:targetDM="showTargetDM" v-model:selectCountries="selectCountries" v-model:selectLangs="selectLangs" v-bind:lang="showTiktokLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:efficientAi="efficientAi" @checkClose="changeYoutubeType" @childYoutube="childYoutube" />
                <StageTikTokRelationship v-bind:showRelationship="showRelationship" v-bind:editPage="cancelEdit" v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].exAudiencesData" v-bind:stageContentAll="customRulesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:stageContentLength="customRulesData.subCampaignsContent.length" v-bind:stageIndex="customRulesData.editIndex" v-bind:campaignId="campaign_id" v-bind:lang="showTiktokLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" />
                <StageTikTokPositionAndDevice v-bind:editPage="cancelEdit" v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].pdData" v-bind:method="customRulesData.subCampaignsContent[customRulesData.editIndex].method" v-bind:keywordViewDatalist="keywordData" v-bind:stageContentAll="customRulesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:stageIndex="customRulesData.editIndex" v-bind:autoPublisher="auto_publisher" v-bind:publisherPlatforms="publisher_platforms" v-bind:keywordsSelectedList="keywordsSelectedCategories" v-bind:lang="showTiktokLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childReturnKeywords="childReturnKeywords" @childNoTiktok="childNoTiktok"/>
                <!-- <StageTikTokIdentity v-bind:showIdentity="showIdentity" v-bind:editPage="cancelEdit" v-bind:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].pdData" v-bind:stageContentAll="customRulesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:stageIndex="customRulesData.editIndex" v-bind:lang="showTiktokLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childPageId="eventPageId" /> -->
                <StageTikTokAdvertisingMaterial v-bind:editPage="cancelEdit" v-model:viewDatalist="customRulesData.subCampaignsContent[customRulesData.editIndex].adMaterialData" v-bind:stageContentAll="customRulesData" v-bind:stageContent="customRulesData.subCampaignsContent[customRulesData.editIndex]" v-bind:stageIndex="customRulesData.editIndex" v-bind:pageId="formPageId" v-bind:goalsObjective="customRulesData.subCampaignsContent[customRulesData.editIndex].goalsData.objective_type" v-bind:changeFormId="changeFormId" v-bind:changeMessageId="changeMessageId" v-bind:lang="showTiktokLang[selectLang]" @childFormId="eventFormId" @childMessageId="eventMessageId" @childContent="adMaterialContent" :style="showAdvertisingMaterial ? '' : 'display:none;'" />
              </div>
            </div>
          </div>

          <div v-show="showTargetCR != true && showOtherTargetCR != true">
            <!-- <GoalsAndBudget v-bind:showGoalsAndBudget="showGoalsAndBudget" v-bind:editPage="cancelEdit" v-bind:viewDatalist="goalsData" v-bind:getDate="returnGapTime" v-bind:budgetKWTotal="budgetKW" v-bind:useEndDate="returnUseEndDate" v-bind:formMinAddition="updateMinAddition" v-bind:currencyList="currencyData" v-bind:lang="showLang[selectLang]" v-bind:useLang="selectLang" v-bind:youtubeClose="youtubeClose" v-bind:efficientAi="efficientAi" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childObjective="goalsObjective" @childObjectiveOption="objectiveOption"/>
            <Regions v-bind:editPage="cancelEdit" v-bind:viewDatalist="regionsData" v-bind:targetDM="showTargetDM" v-model:selectCountries="selectCountries" v-model:selectLangs="selectLangs" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:efficientAi="efficientAi" @checkClose="changeYoutubeType" @childYoutube="childYoutube" />
            <Relationship v-bind:showRelationship="showRelationship" v-bind:editPage="cancelEdit" v-bind:viewDatalist="exAudiencesData" v-bind:campaignId="campaign_id" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" /> -->
          </div>
        </div>
        <div v-show="target == 3">
          <div v-show="showTargetCR != true && showOtherTargetCR != true">
            <PositionAndDevice v-bind:editPage="cancelEdit" v-bind:viewDatalist="pdData" v-bind:autoPublisher="auto_publisher" v-bind:publisherPlatforms="publisher_platforms" v-bind:lang="showLang[selectLang]" @checkClose="changeYoutubeType" @childYoutube="childYoutube" v-bind:youtubeClose="youtubeClose" />
            <Identity v-bind:showIdentity="showIdentity" v-bind:editPage="cancelEdit" v-bind:viewDatalist="idData" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childPageId="eventPageId" />
            <Material v-if="showMaterial" v-bind:editPage="cancelEdit" v-bind:viewDatalist="postData" v-bind:pageId="formPageId" v-bind:goalsObjective="getGoalsObjective" v-bind:optimizationAction="currentOptimizationAction" v-bind:campaignId="campaign_id" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:efficientAi="efficientAi" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childActiveScroll="activeScroll" />
            <AdvertisingMaterial v-bind:editPage="cancelEdit" v-model:viewDatalist="adMaterialDataNew" v-bind:pageId="formPageId" v-bind:goalsObjective="getGoalsObjective" v-bind:optimizationAction="currentOptimizationAction" v-bind:changeFormId="changeFormId" v-bind:changeMessageId="changeMessageId" v-bind:lang="showLang[selectLang]" @childFormId="eventFormId" @childMessageId="eventMessageId" @childContent="adMaterialContent" :style="showAdvertisingMaterial ? '' : 'display:none;'" />
            <Form v-if="showForm" v-bind:editPage="cancelEdit" v-bind:viewDatalist="idData" v-bind:pageId="formPageId" v-bind:firstFormId="first_form_id" v-bind:formStatus="form_status" v-bind:formId="formId" v-bind:useTeachDetail="use_teach_detail" v-bind:selectLang="selectLang" v-bind:lang="showLang[selectLang]" @childChangeFormId="formChangeFormId" />
            <Msg v-if="showMsg" v-bind:editPage="cancelEdit" v-bind:viewDatalist="idData" v-bind:pageId="formPageId" v-bind:firstMessageId="first_message_id" v-bind:messageStatus="message_status" v-bind:messageId="messageId" v-bind:useTeachDetail="use_teach_detail" v-bind:lang="showLang[selectLang]" @childChangeMessageId="formChangeMessageId" />
          </div>
        </div>
      </div>
    </main>
    <footer class="d2-bottom-bar">
      <div class="d2-progress-wrap">
        <div class="d2-progress-track"><div class="d2-progress-fill" :style="{width: `${process}%`}"></div></div>
        <span class="d2-progress-text">{{showLang[selectLang]['views']['Event']['process_text_a']}} {{process}} % {{showLang[selectLang]['views']['Event']['process_text_b']}}</span>
      </div>
      <div class="d2-progress-mobile">{{showLang[selectLang]['views']['Event']['process_text_a']}} {{process}} % {{showLang[selectLang]['views']['Event']['process_text_b']}}</div>
      <div class="d2-bottom-btns">
          <button
            class="d2-btn-evt outline"
            @click="form_update()"
            ><i class="fas fa-save"></i> {{showLang[selectLang]['views']['Event']['save_button']}}</button>
          <!-- <button
            v-if="this.db_writing_status == 'draft' && this.db_status == 'N'"
            class="text-sm lg:text-base bg-yellow-300 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out border-2 border-yellow-400"
            @click="release()"
            >{{showLang[selectLang]['views']['Event']['release_button']}}</button> -->
          <button
            v-if="this.target != 1"
            class="d2-btn-evt ghost"
            @click="prev()"
            :disabled="process <= 0"
          ><i class="fas fa-chevron-left"></i> {{showLang[selectLang]['views']['Event']['prev_text']}}</button>
          <button
            class="d2-btn-evt primary"
            @click="next()"
          >{{showLang[selectLang]['views']['Event']['next_text']}} <i class="fas fa-chevron-right"></i></button>
          <div v-if="!editPageType" class="flex items-center">
            <InputSwitch v-model="saveToStrategy" class="flex-shrink-0" />
            <div class="flex flex-col w-11/12 break-words" >
              <div class="flex ml-2 text-gray-700 my-2">
                <span class="my-2 text-sm">將設定儲存為範本</span>
              </div>
            </div>
          </div>
      </div>
    </footer>
  </div>
</template>

<script>
import validateRegulatedCountries from '@/utils/validateRegulatedCountries'
  import Header from '@/components/Header.vue'
  import CampaignName from '@/components/CustomizeTreeEvent/CampaignName.vue'
  import MarketingMethod from '@/components/CustomizeTreeEvent/MarketingMethod.vue'
  import BenefitsAndInvestment from '@/components/CustomizeTreeEvent/BenefitsAndInvestment.vue'
  import MarketingDate from '@/components/CustomizeTreeEvent/MarketingDate.vue'
  import ConfidentialAudience from '@/components/CustomizeTreeEvent/ConfidentialAudience.vue'
  import CustomRules from '@/components/CustomizeTreeEvent/CustomRules.vue'
  import KeywordMix from '@/components/CustomizeTreeEvent/KeywordMix.vue'
  import AdvertisingMix from '@/components/CustomizeTreeEvent/AdvertisingMix.vue'
  import RemarketingMix from '@/components/CustomizeTreeEvent/RemarketingMix.vue'
  //-----------------自定義-meta tree
  import StageTreeBlock from '@/components/CustomizeTreeEvent/StageTreeBlock.vue'
  import StageTreeComponent from '@/components/CustomizeTreeEvent/StageTreeComponent.vue'
  import StageTreeKeywordMix from '@/components/CustomizeTreeEvent/StageKeywordMix.vue'
  import StageTreeAdvertisingMix from '@/components/CustomizeTreeEvent/StageAdvertisingMix.vue'
  import StageTreeRemarketingMix from '@/components/CustomizeTreeEvent/StargeRemarketingMix.vue'
  import StageTreeGoalsAndBudget from '@/components/CustomizeTreeEvent/StageGoalsAndBudget.vue'
  import StageTreeRegions from '@/components/CustomizeTreeEvent/StageRegions.vue'
  import StageTreePositionDeviceIdentity from '@/components/CustomizeTreeEvent/StagePositionDeviceIdentity.vue'
  import StageTreeMaterial from '@/components/CustomizeTreeEvent/StageMaterial.vue'
  //-----------------自定義-meta tree
  //-----------------自定義-meta
  import StageDynamicBudget from '@/components/CustomizeEvent/StageDynamicBudget.vue'
  import StageDoForward from '@/components/CustomizeEvent/StageDoForward.vue'
  import StageKeywordMix from '@/components/CustomizeEvent/StageKeywordMix.vue'
  import StageAdvertisingMix from '@/components/CustomizeEvent/StageAdvertisingMix.vue'
  import StageRemarketingMix from '@/components/CustomizeEvent/StargeRemarketingMix.vue'
  import StageBlock from '@/components/CustomizeEvent/StageBlock.vue'
  import StageGoalsAndBudget from '@/components/CustomizeEvent/StageGoalsAndBudget.vue'
  import StageRegions from '@/components/CustomizeEvent/StageRegions.vue'
  import StagePositionDeviceIdentity from '@/components/CustomizeEvent/StagePositionDeviceIdentity.vue'
  import StageMaterial from '@/components/CustomizeEvent/StageMaterial.vue'
  //-----------------自定義-meta
  //-----------------自定義-tiktok
  import StageTikTokKeywordMix from '@/components/CustomizeTikTokEvent/KeywordMix.vue'
  import StageTikTokAdvertisingMix from '@/components/CustomizeTikTokEvent/AdvertisingMix.vue'
  import StageTikTokGoalsAndBudget from '@/components/CustomizeTikTokEvent/GoalsAndBudget.vue'
  import StageTikTokRegions from '@/components/CustomizeTikTokEvent/Regions.vue'
  // import StageTikTokIdentity from '@/components/CustomizeTikTokEvent/Identity.vue'
  import StageTikTokRelationship from '@/components/CustomizeTikTokEvent/Relationship.vue'
  import StageTikTokPositionAndDevice from '@/components/CustomizeTikTokEvent/PositionAndDevice.vue'
  import StageTikTokMaterial from '@/components/CustomizeTikTokEvent/Material.vue'
  import StageTikTokAdvertisingMaterial from '@/components/CustomizeTikTokEvent/AdvertisingMaterial.vue'
  //-----------------自定義-tiktok
  import GoalsAndBudget from '@/components/CustomizeEvent/GoalsAndBudget.vue'
  import Regions from '@/components/CustomizeEvent/Regions.vue'
  import Identity from '@/components/CustomizeEvent/Identity.vue'
  import Relationship from '@/components/CustomizeEvent/Relationship.vue'
  import PositionAndDevice from '@/components/CustomizeEvent/PositionAndDevice.vue'
  import Material from '@/components/CustomizeEvent/Material.vue'
  import AdvertisingMaterial from '@/components/CustomizeEvent/AdvertisingMaterial.vue'
  import Form from '@/views/Form.vue'
  import Msg from '@/views/Msg.vue'
  import InputSwitch from 'primevue/inputswitch';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import CircleProgress from "vue3-circle-progress";
  import axios from 'axios'
  import Qs from 'qs'
  import lang from '@/language/lang.json'
  import tiktokLang from '@/language/tiktok_lang.json'
  import { reactive, toRaw } from 'vue';

  export default {
    name: 'Home',
    components: {
      Header,
      CampaignName,
      MarketingMethod,
      BenefitsAndInvestment,
      MarketingDate,
      ConfidentialAudience,
      CustomRules,
      KeywordMix,
      AdvertisingMix,
      RemarketingMix,
      StageTreeBlock,
      StageTreeComponent,
      StageTreeKeywordMix,
      StageTreeAdvertisingMix,
      StageTreeRemarketingMix,
      StageTreeGoalsAndBudget,
      StageTreeRegions,
      StageTreePositionDeviceIdentity,
      StageTreeMaterial,
      StageDynamicBudget,
      StageDoForward,
      StageKeywordMix,
      StageAdvertisingMix,
      StageRemarketingMix,
      StageBlock,
      StageGoalsAndBudget,
      StageRegions,
      StagePositionDeviceIdentity,
      StageMaterial,
      StageTikTokKeywordMix,
      StageTikTokAdvertisingMix,
      StageTikTokGoalsAndBudget,
      StageTikTokRegions,
      // StageTikTokIdentity,
      StageTikTokRelationship,
      StageTikTokPositionAndDevice,
      StageTikTokMaterial,
      StageTikTokAdvertisingMaterial,
      GoalsAndBudget,
      Regions,
      Identity,
      Relationship,
      PositionAndDevice,
      Material,
      AdvertisingMaterial,
      Form,
      Msg,
      InputSwitch,
      Loading,
      CircleProgress
    },
    data() {
      return {
        selectLang: 'zh-TW',
        showLang: lang,
        showTiktokLang: tiktokLang,
        use_teach_detail: false, // <!-- 新手教學 -->
        showCampaignData: false,
        showMarketingDate: true,
        showAdvertisingMix: 'true_0000',
        showRemarketingMix: 'true_0000',
        showGoalsAndBudget: true,
        showRelationship: true,
        showIdentity: true,
        db_writing_status: 'key',
        db_status: 'N',
        display: false,
        cancelEdit: false,
        process: 0,
        showTargetKW: true,
        showTargetDM: true,
        showTargetLA: true,
        showTargetRT: true,
        showTargetCF: true,
        showTargetAD: true,
        showTargetCR: true,
        showOtherTargetCR: false,
        returnGapTime: null,
        returnEndTime: null,
        returnUseEndDate: null,
        budgetKW:null,
        updateMinAddition: 0,
        getGoalsObjective: null,
        showMaterial:true,
        showStageMaterial:null,
        showAdvertisingMaterial:true,
        showStageAdvertisingMaterial:null,
        showForm:true,
        showStageForm:null,
        showMsg:true,
        showStageMsg:null,
        isEdit: false,
        campaign_id: null,
        campaign_name: null,
        adaccount_id: null,
        productUrl: null,
        adaccount_name: null,
        tiktok_adaccount_name: null,
        target: 1,
        formPixelId: null,
        currentOptimizationAction: '',
        formPageId: null,
        formId: null,
        messageId: null,
        changeFormId: null,
        changeMessageId: null,
        menu: [],
        _tmpMenu: [],
        Budget_KW_result: null,
        total_budget: null,
        saveToStrategy: false,
        currencyData: {
                      currency: '',
                      currency_name: null,
                      currency_symbol: null,
                      currency_min_price: null,
                      currency_video_min_price: null,
                      currency_suggest_price: null,
                      currency_remarketing_price: null,
                      currency_offset: 1,
                    },
        methodData: {
                    Target_KW:null,
                    Budget_KW:null,
                    Target_DM:null,
                    Budget_DM:null,
                    Target_LA:null,
                    Budget_LA:null,
                    Target_RT:null,
                    Budget_RT:null,
                    use_similar_audience_status:0,
                    use_confldential_audience_status:0,
                    Target_CF:null,
                    Budget_CF:null,
                    Target_AD:null,
                    Budget_AD_min:null,
                    Budget_AD_max:null,
                    Target_CR:null,
                    Other_Target_CR:null,
                    retargeting:null,
                    daily_budget:null
                  },
        benefitsAndInvestmentData: {
          useFinance: false,
          toTaiwan: false,
          regulated_countries: [],
          country_options: [],
          benefits: null,
          benefits_list: [],
          investment: null,
          investment_list: [],
          person_or_business: {label : '個人或商家驗證', value : 1},
          beneficiary_id: null,
          payer_id: null,
          beneficiary_name: null,
          payer_name: null,
          beneOrPayerPersonalList:[],
          selectedBeneficiary: null,
          selectedPayer: null,
          showKeyinBeneficiary: null,
          showKeyinPayer: null,
        },
        treeMenu: [],
        useTree: true,
        treeUpdateStatus: 'false_',
        activeStageTreeNodeIndex: 0,
        activeStageTreeItemIndex: 0,
        stageTreeHaveTest: null,
        stageTreeList: [
          [{ method: "META_TEST", platform: "facebook", isGoAhead: true, isHold: false }],
          [{ method: "META_KW", platform: "facebook", isGoAhead: false, isHold: false }],
        ],
        stageTreeContent:[
          [
            {
              method : 'META_TEST',
              release : {
                sr_i : 0,
                status : ''
              },
              goalsData: {
                showBlock: true,
                campaign_objective: null,
                objective_option:null,
                objective_list:null,
                product_catalog_list:null,
                product_set_list:null,
                optimization_action:null,
                optimization_goal:null,
                product_catalog_id:null,
                product_set_id:null,
                pixel_id:null,
                pixel_event:null,
                conversion_domain:null,
                domain_list:null,
              },
              budgetData: {
                showBlock: true,
                daily_budget:0,
                effect:null,
                currency_video_min_price:null,
                form_addition:null,
                use_addition:null,
                risk_automatic:null,
                risk_index:null,
                risk_level_list:null,
                risk_level:null
              },
              forwardData: {
                showBlock: true,
                ditto_forward: '0',
                frequency: '1d',
                rule_frequency: [],
              },
              stopData: {
                showBlock: true,
                ditto_stop: '0',
                rule_stop: [],
              },
              budgetExtraData: {
                showBlock: true,
                ditto_budget_extra: '0',
                amount: 0,
                frequency: 0,
                budget_extra_list: [],
              },
              localData: {
                showBlock: true,
                ditto_local: '0',
                location_types:null,
                locations:null,
                location_range:null,
                locales:null
              },
              demoData: {
                showBlock: true,
                ditto_demo: '0',
                gender:null,
                age_min:null,
                age_max:null
              },
              exAudiencesData: {
                showBlock: true,
                ditto_connect: '0',
                excluded_audiences:null,
                default_excluded_audiences:null,
                custom_excluded_audiences:null,
                custom_excluded_audiences_selected:null,
              },
              pdData: {
                showBlock: true,
                ditto_identity: '0',
                auto_publisher:null,
                publisher_platforms:['facebook', 'instagram', 'audience_network', 'messenger'],
                publisher_platforms_list:null,
                device_platforms: null,
                user_os:null,
                user_os_list:null,
                page_id:null,
                ig_id:null,
                ig_username:null,
                adpages_list:null,
                ig_list:null,
              },
              postData: {
                showBlock: true,
                ditto_creative: '0',
                page_id:null,
                special_ad_category:null,
                disabled_creative_optimize:false,
                creative_optimize:false,
                select_article:null,
                db_select_article:null,
                select_creatives:null,
                db_select_creatives:null,
                select_creatives_message:null,
                db_select_creatives_message:null,
                select_creatives_adset_ads:null,
                db_select_creatives_adset_ads:null,
                select_creatives_adset_ads_message:null,
                db_select_creatives_adset_ads_message:null,
              },
              adMaterialData: {
                showBlock: true,
                ditto_creative: '0',
                disabled_creative_optimize:false,
                creative_optimize:false,
                creative_array:null,
              },
            },
          ]
        ],
        customRulesData: {
          editIndex: 0,
          haveTest: true,
          platformTest: 'facebook',
          stageList: [
            { marketingValue: 'META_KW'},
          ],
          subCampaignsContent: [
            {
              method : 'META_TEST',
              release : {
                sr_i : 0,
                status : ''
              },
              goalsData: {
                showBlock: true,
                campaign_objective: null,
                objective_option:null,
                objective_list:null,
                product_catalog_list:null,
                product_set_list:null,
                optimization_action:null,
                optimization_goal:null,
                product_catalog_id:null,
                product_set_id:null,
                pixel_id:null,
                pixel_event:null,
                conversion_domain:null,
                domain_list:null,
              },
              budgetData: {
                showBlock: true,
                daily_budget:0,
                effect:null,
                currency_video_min_price:null,
                form_addition:null,
                use_addition:null,
                risk_automatic:null,
                risk_index:null,
                risk_level_list:null,
                risk_level:null
              },
              forwardData: {
                showBlock: true,
                ditto_forward: '0',
                frequency: '1d',
                rule_frequency: [],
              },
              stopData: {
                showBlock: true,
                ditto_stop: '0',
                rule_stop: [],
              },
              budgetExtraData: {
                showBlock: true,
                ditto_budget_extra: '0',
                amount: 0,
                frequency: 0,
                budget_extra_list: [],
              },
              localData: {
                showBlock: true,
                ditto_local: '0',
                location_types:null,
                locations:null,
                location_range:null,
                locales:null
              },
              demoData: {
                showBlock: true,
                ditto_demo: '0',
                gender:null,
                age_min:null,
                age_max:null
              },
              exAudiencesData: {
                showBlock: true,
                ditto_connect: '0',
                excluded_audiences:null,
                default_excluded_audiences:null,
                custom_excluded_audiences:null,
                custom_excluded_audiences_selected:null,
              },
              pdData: {
                showBlock: true,
                ditto_identity: '0',
                auto_publisher:null,
                publisher_platforms:['facebook', 'instagram', 'audience_network', 'messenger'],
                publisher_platforms_list:null,
                device_platforms: null,
                user_os:null,
                user_os_list:null,
                page_id:null,
                ig_id:null,
                ig_username:null,
                adpages_list:null,
                ig_list:null,
              },
              postData: {
                showBlock: true,
                ditto_creative: '0',
                page_id:null,
                special_ad_category:null,
                disabled_creative_optimize:false,
                creative_optimize:false,
                select_article:null,
                db_select_article:null,
                select_creatives:null,
                db_select_creatives:null,
                select_creatives_message:null,
                db_select_creatives_message:null,
                select_creatives_adset_ads:null,
                db_select_creatives_adset_ads:null,
                select_creatives_adset_ads_message:null,
                db_select_creatives_adset_ads_message:null,
              },
              adMaterialData: {
                showBlock: true,
                ditto_creative: '0',
                disabled_creative_optimize:false,
                creative_optimize:false,
                creative_array:null,
              },
            },
          ]
        },
        otherCustomTitle:[],
        defaultStage: [],
        stageMenu: [],
        tiktokDefaultStage: [],
        tiktokStageMenu: [],
        formCampaignHaveTest: true,
        dynBudgetData: {
          useDynamicBudget: false
        },
        doForwardData: {
          useDoForward: false
        },
        dateData: {
                    start_date:null,
                    end_date:null,
                    use_end_date:null,
                  },
        keywordData: {
                      product_url:null,
                      keywords:null,
                      base_keyword_list: [],
                      select_keywords:null
                    },
        lookData: {
                    default_lookalikes:null,
                    custom_lookalikes:null,
                    custom_lookalikes_selected:null,
                    default_lookalikes_list:null,
                    custom_lookalikes_list:null
                  },
        audiencesData: {
                    default_audiences:null,
                    custom_audiences:null,
                    custom_audiences_selected:null,
                    default_audiences_list:null,
                    custom_audiences_list:null
                  },
        goalsData: {
                    campaign_objective:null,
                    objective_option:null,
                    objective_list:null,
                    product_catalog_list:null,
                    product_set_list:null,
                    optimization_action:null,
                    optimization_goal:null,
                    product_catalog_id:null,
                    product_set_id:null,
                    pixel_id:null,
                    pixel_event:null,
                    conversion_domain:null,
                    domain_list:null,
                    useAppEvent: false,
                    appItemsSelected: null,
                    appItemsList: [],
                    effect:null,
                    currency_video_min_price:null,
                    form_addition:null,
                    use_addition:null,
                    risk_automatic:null,
                    risk_index:null,
                    risk_level_list:null,
                    risk_level:null
                  },
        regionsData: {
                      location_types:null,
                      locations:null,
                      location_range:null,
                      locales:null,
                      gender:null,
                      age_min:null,
                      age_max:null
                    },
        selectCountries: null,
        selectLangs: null,
        exAudiencesData: {
                      excluded_audiences:null,
                      default_excluded_audiences:null,
                      custom_excluded_audiences:null,
                      custom_excluded_audiences_selected:null,
                    },
        pdData: {
                  auto_publisher:null,
                  publisher_platforms:['facebook', 'instagram', 'audience_network', 'messenger'],
                  publisher_platforms_list:null,
                  device_platforms: null,
                  user_os:null,
                  user_os_list:null,
                },
        auto_publisher: null,
        publisher_platforms: ['facebook', 'instagram', 'audience_network', 'messenger'],
        idData: {
                  page_id:null,
                  ig_id:null,
                  ig_username:null,
                  adpages_list:null,
                  ig_list:null,
                },
        postData: {
                  page_id:null,
                  special_ad_category:null,
                  disabled_creative_optimize:false,
                  creative_optimize:false,
                  select_article:null,
                  db_select_article:null,
                  select_creatives:null,
                  db_select_creatives:null,
                  select_creatives_message:null,
                  db_select_creatives_message:null,
                  select_creatives_adset_ads:null,
                  db_select_creatives_adset_ads:null,
                  select_creatives_adset_ads_message:null,
                  db_select_creatives_adset_ads_message:null,
                },
        adMaterialData: {
                          disabled_creative_optimize:false,
                          creative_optimize:false,
                          creative_array:null,
                        },
        tmpAdMaterialDataNew:{
                            disabled_creative_optimize:false,
                            creative_optimize:false,
                            creative_array:null,
                          },
        adMaterialDataNew:{
                            disabled_creative_optimize:false,
                            creative_optimize:false,
                            creative_array:null,
                          },
        formData: {
                    pageId: null,
                    formId: null
                  },
        msgData: {
                    pageId: null,
                    msgId: null
                  },
        first_form_id: null,
        form_status: null,
        first_message_id: null,
        message_status: null,
        AdvertisingMaterialStatus: undefined,
        releaseType: true,
        efficientAi: null,
        style: 'z-index: -1;',
        releaseText: '發佈中...',
        releasePercent: 0,
        allPageLoading: false,
        youtubeClose: false,
        isClass: 'n',
        haveASC: 'false_',
        otherCustomCampaignId: null,
        subCampaignList: [],
        keywordsSelectedCategories:{},
        strategyId: null,
        nextLoading: false,
        toSaveTreeData: [],
        toSaveTreeStrategyData: [],
        rawData: [],
        defaultTreeMenu: [
          [
            { 
              method: "FIRST", 
              area: 1,
              platform: null, 
              isGoAhead: null,
              list: {
                CampaignName:{ title: "行銷活動名稱", type: 'name', groupType: 'CampaignName', showStatus: true, refName: 'campaignName'},
                Method:{ title: "行銷方式", type: 'method', groupType: 'MarketingMethod', showStatus: true, refName: 'method'},
                BeAndCon:{ title: "廣告資訊透明度", type: 'payer', groupType: 'BenefitsAndInvestment', showStatus: true, refName: 'BeAndCon'},
                AdStrategy:{ title: "廣告策略", type: 'customize', groupType: 'StageTreeComponent', showStatus: true, refName: 'adStrategy'},
                DateBlock:{ title: "行銷日期", type: 'date', groupType: 'MarketingDate', showStatus: true, refName: 'campaignDate'},
              }
            },
          ],
        ],
        useExperienceCustomize: false,
      }
    },
    created() {
      // console.log('id:'+this.$route.params.id);
      // console.log('adaccount_id:'+this.$route.params.adaccount_id);
      // console.log('campaign_id:'+this.$route.params.campaign_id);

      let hash = this.$route.params.id;

      if(hash != '' && hash != null && typeof hash != 'undefined'){
        axios
          .post('https://www.autoturn.net/api/member_info.php', Qs.stringify({
            s_code: this.$route.params.id,
          }), {withCredentials: true})
          .then((adResponse) => {
            // console.log('adResponse:'+adResponse.data.selecded_data);
          //  console.log('sidebar member_info.php');
            if(adResponse.data.status == 'success'){

              this.useExperienceCustomize = adResponse.data.return_data.use_experience_customize;

              if(adResponse.data.return_data.source == 6 && (adResponse.data.return_data.payment_plan_id == 1 || adResponse.data.return_data.account_status == 's')){
                this.isClass = 'y';
              }

            } else {
              Swal.fire({
                icon: 'error',
                title: this.showLang[this.selectLang]['views']['Event']['created']['no_hash_swal_title'],
                text: adResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['created']['no_hash_swal_confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                }
              })
            }
          });

        // this.initializeData();

        axios
          .post('https://www.autoturn.net/api/lib/customize_default_stage_of_tree.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
          }))
          .then((dsResponse) => {
            // console.log('dsResponse:'+dsResponse.data.selecded_data);
          //  console.log('lib customize_default_stage.php');
          //  console.log(dsResponse.data);
            if(dsResponse.data.status == 'success'){
              this.defaultStage = dsResponse.data.return_data;
              this.stageMenu = dsResponse.data.menu;
              this.tiktokDefaultStage = dsResponse.data.tiktok_return_data;
              this.tiktokStageMenu = dsResponse.data.tiktok_menu;

            //  console.log('this.defaultStage');
            //  console.log(this.defaultStage);
            //  console.log('this.stageMenu');
            //  console.log(this.stageMenu);

              axios
                .post('https://www.autoturn.net/api/customize/campaign/campaign_of_tree.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adaccount_id: this.$route.params.adaccount_id,
                  campaign_id: this.$route.params.campaign_id
                }))
                .then((response) => {
                  if(response.data.status == 'success'){
                    this.campaign_id = this.$route.params.campaign_id
                    this.campaign_name = response.data.return_data.campaign_name
                    this.adaccount_id = response.data.return_data.adaccount_id
                    this.adaccount_name = response.data.return_data.adaccount_name
                    this.tiktok_adaccount_name = response.data.return_data.tiktok_adaccount_name
                    this.productUrl = response.data.return_data.product_url

                    document.title = response.data.return_data.campaign_name+' - '+this.showLang[this.selectLang]['views']['Event']['created']['page_title']+' - AutoTurn';

                  //  console.log('b this.showTargetCR');
                  //  console.log(this.showTargetCR);

                    this.showTargetKW = response.data.return_data.Target_KW;
                    // this.showTargetLA = response.data.return_data.Target_LA
                    this.showTargetLA = false;
                    this.showTargetRT = response.data.return_data.Target_RT;
                    this.showTargetAD = response.data.return_data.Target_AD;
                    this.showTargetCR = response.data.return_data.Target_CR;
                    this.formCampaignHaveTest = response.data.return_data.haveTest;
                    this.stageTreeHaveTest = response.data.return_data.haveTest;

                  //  console.log('response.data.return_data.Target_CR');
                  //  console.log(response.data.return_data.Target_CR);
                  //  console.log('a this.showTargetCR');
                  //  console.log(this.showTargetCR);

                    this.treeMenu = response.data.return_data.tree_menu;

                    this.benefitsAndInvestmentData = {
                      toTaiwan: response.data.return_data.toTaiwan,
                      regulated_countries: response.data.return_data.regulated_countries,
                      country_options: response.data.return_data.country_options,
                      useFinance: response.data.return_data.useFinance,
                      benefits: response.data.return_data.benefits,
                      benefits_list: response.data.return_data.benefits_list,
                      investment: response.data.return_data.investment,
                      investment_list: response.data.return_data.investment_list,
                      person_or_business: response.data.return_data.person_or_business,
                      beneficiary_id: response.data.return_data.beneficiary_id,
                      payer_id: response.data.return_data.payer_id,
                      beneficiary_name: response.data.return_data.beneficiary_name,
                      payer_name: response.data.return_data.payer_name,
                      beneOrPayerPersonalList: response.data.return_data.beneficiary_or_payer_personal_list,
                      selectedBeneficiary: response.data.return_data.selected_beneficiary,
                      selectedPayer: response.data.return_data.selected_payer,
                      showKeyinBeneficiary: response.data.return_data.show_keyin_beneficiary,
                      showKeyinPayer: response.data.return_data.show_keyin_payer,
                    };

                    if(this.showTargetCR == true){
                    //  console.log('#00');
                      let subCampaigns = response.data.return_data.sub_campaigns;
                      this.subCampaignList = response.data.return_data.sub_campaigns;
                      this.stageTreeList = response.data.return_data.stage_tree_list;

                      this.stageTreeList = response.data.return_data.stage_tree_list;

                    //  console.log('a this.stageTreeList', this.stageTreeList);

                      this.menu = [
                        {
                          title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_title'],
                          submenu: [
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_0_title'], show: true, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_1_title'], show: true, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_2_title'], show: true, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_3_title'], show: false, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_4_title'], show: false, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_7_title'], show: false, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_6_title'], show: true, checked: false},
                          ],
                          open: true,
                          show: true,
                          target: 1
                        },
                      ];

                      if(subCampaigns != '' && subCampaigns != null && typeof subCampaigns != 'undefined'){
                        if(subCampaigns.length > 0){
                        //  console.log('#01');

                          // this.customRulesData.stageList = [];
                          // this.customRulesData.subCampaignsContent = [];

                        //  console.log('before db this.customRulesData');
                        //  console.log(this.customRulesData);

                          // subCampaigns.forEach((value, index) => {
                          // //  console.log(index+':'+value);
                          // //  console.log(index+ 'before this.customRulesData');
                          // //  console.log(this.customRulesData);

                          //   let _toMenuIndex = index + parseInt(1);
                          // //  console.log(_toMenuIndex);

                          //   let responseReceived = false;

                          //   axios
                          //     .post('https://www.autoturn.net/api/customize/campaign/campaign_subset.php', Qs.stringify({
                          //       s_code: this.$route.params.id,
                          //       adaccount_id: this.$route.params.adaccount_id,
                          //       haveTest: response.data.return_data.haveTest,
                          //       itemIndex: index,
                          //       campaign_id: value
                          //     }))
                          //     .then((subResponse) => {
                          //     //  console.log('subResponse');
                          //     //  console.log(subResponse);

                          //       responseReceived = true;

                          //       if(subResponse.data.status == 'success'){
                          //         let _tmpReturnMenu = JSON.stringify(subResponse.data.return_menu);
                          //       //  console.log(_tmpReturnMenu);
                          //         this.menu[_toMenuIndex] = JSON.parse(_tmpReturnMenu);
                          //         this.customRulesData.haveTest = response.data.return_data.haveTest;

                          //         if(subResponse.data.subset_method != 'META_TEST'){
                          //           let _toStageListIndex = index;
                          //           if(this.customRulesData.haveTest == true){
                          //             _toStageListIndex = index - parseInt(1);
                          //           }

                          //         //  console.log(typeof subResponse.data.return_stage_list);
                          //         //  console.log(subResponse.data.return_stage_list);
                          //           let _tmpReturnStageList = JSON.stringify(subResponse.data.return_stage_list);
                          //           this.customRulesData.stageList[_toStageListIndex] = JSON.parse(_tmpReturnStageList)
                          //         }

                          //         if(subResponse.data.subset_method == 'META_ASC'){
                          //           var todayForm = new Date();
                          //           var yearForm = todayForm.getFullYear();
                          //           var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          //           var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          //           var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          //           todayForm = yearForm + monthForm + dateForm + timeForm;

                          //           this.haveASC = 'true_'+todayForm;
                          //         }

                          //       //  console.log(typeof subResponse.data.return_data);
                          //       //  console.log(subResponse.data.return_data);
                          //         // console.log('this.customRulesData.subCampaignsContent['+index+'] = JSON.parse(JSON.stringify('+subResponse.data.return_data+')');
                          //         let _tmpReturnData = JSON.stringify(subResponse.data.return_data);
                          //         // console.log(_tmpReturnData);
                          //         // this.customRulesData.subCampaignsContent[index] = JSON.parse(_tmpReturnData);

                          //         try {
                          //           JSON.parse(_tmpReturnData);
                          //         //  console.log("JSON 格式正确");
                          //         } catch (error) {
                          //           console.error("JSON 格式错误:", error.message);
                          //         }

                          //         // this.customRulesData.subCampaignsContent.splice(index, 1, JSON.parse(_tmpReturnData));

                          //         // if (!this.customRulesData.subCampaignsContent[index]) {
                          //         //   this.customRulesData.subCampaignsContent.splice(index, 1, this.ensureReactive({}));
                          //         // } else {
                          //         //   // 确保对象是响应式的
                          //         //   this.customRulesData.subCampaignsContent[index] = this.ensureReactive(this.customRulesData.subCampaignsContent[index]);
                          //         // }

                          //         if (!this.customRulesData.subCampaignsContent[index]) {
                          //           this.customRulesData.subCampaignsContent[index] = reactive({});
                          //         }

                          //       //  console.log('before db+ this.customRulesData');
                          //       //  console.log(this.customRulesData);

                          //         if (this.customRulesData.subCampaignsContent && index != null) {
                          //           const parsedData = JSON.parse(_tmpReturnData);

                          //         //  console.log('Index:', index);
                          //         //  console.log('Original Object:', this.customRulesData.subCampaignsContent[index]);
                          //         //  console.log('Data to Assign:', parsedData);

                          //           if(this.customRulesData.subCampaignsContent[index] != null && parsedData != null){
                          //             Object.assign(this.customRulesData.subCampaignsContent[index], parsedData);
                          //           }

                          //           // this.customRulesData.subCampaignsContent[index] = {
                          //           //     ...this.customRulesData.subCampaignsContent[index],
                          //           //     ...parsedData
                          //           // };

                          //           if(!this.customRulesData.subCampaignsContent[index]){
                          //           //  console.log('資料沒更新成功');
                          //           } else {
                          //           //  console.log("有資料");
                          //           }

                          //         //  console.log('this.customRulesData.subCampaignsContent['+index+']');
                          //         //  console.log(this.customRulesData.subCampaignsContent[index]);
                          //         //  console.log(this.customRulesData.subCampaignsContent);
                          //         //  console.log(this.customRulesData);
                          //         } else {
                          //           console.error('subCampaignsContent 或 index 無效');
                          //         }

                          //         // console.log('check subCampaignsContent');
                          //         // this.customRulesData.subCampaignsContent.forEach((checkValue, checkIndex) => {
                          //         // //  console.log(checkIndex);
                          //         // //  console.log(checkValue);
                          //         // });

                          //       //  console.log(index+ ' db+ this.customRulesData');
                          //       //  console.log(this.customRulesData);

                          //       //  console.log(index+ ' campaign_subset this.menu');
                          //       //  console.log(this.menu);
                          //       }

                          //       if(_toMenuIndex == subCampaigns.length){
                          //       //  console.log('db end this.showTargetCR');
                          //       //  console.log(this.showTargetCR);
                          //       //  console.log('campaign_subset done');
                          //         this.showCampaignData = true;
                          //       }
                          //     });

                          // //  console.log('開始延遲');
                          //   // while (!responseReceived) {
                          //   // //  console.log('等100毫秒');
                          //   //   this.delay(100); // 延遲 100 毫秒
                          //   // }
                          // //  console.log('延遲結束');

                          // //  console.log('all db this.customRulesData');
                          // //  console.log(this.customRulesData);
                          // //  console.log('all this.menu');
                          // //  console.log(this.menu);
                          // });

                        //  console.log('this.fetchData');
                          this.fetchData(subCampaigns, response, '');

                        } else {
                        //  console.log('#1 this.methodTargetCR');
                          // this.methodTargetCR(true);
                          this.stageTreeContent = [];

                          this.stageTreeHaveTest = true;

                        //  console.log('b this.stageTreeContent', this.stageTreeContent);

                          this.stageTreeContent.push(
                            [ this.defaultStage['USE_TEST']['META_TEST'], ],
                            [ this.defaultStage['USE_TEST']['META_KW'], ]
                          );
                          this.showCampaignData = true;
                        }
                      } else {
                      //  console.log('#2 this.methodTargetCR');
                        // this.methodTargetCR(true);
                        this.stageTreeContent = [];
                        
                        this.stageTreeHaveTest = true;

                      //  console.log('b this.stageTreeContent', this.stageTreeContent);

                        this.stageTreeContent.push(
                          [ this.defaultStage['USE_TEST']['META_TEST'], ],
                          [ this.defaultStage['USE_TEST']['META_KW'], ]
                        );
                        this.showCampaignData = true;
                      }

                      this.otherCustomTitle = response.data.return_data.other_subset_data;
                    }

                    let startTime = response.data.return_data.start_date;
                    let endTime = response.data.return_data.end_date;
                    let diffType = 'day';

                    let gapTime = 0;

                    if(startTime != '' && startTime != '0000-00-00' && startTime != null && endTime != '' && endTime != '0000-00-00' && endTime != null){
                      diffType = diffType.toLowerCase();
                      var sTime =new Date(startTime); //開始時間
                      var eTime =new Date(endTime); //結束時間
                      //作為除數的數字
                      var timeType = 1;
                      switch (diffType) {
                          case"second":
                              timeType =1000;
                          break;
                          case"minute":
                              timeType =1000*60;
                          break;
                          case"hour":
                              timeType =1000*3600;
                          break;
                          case"day":
                              timeType =1000*3600*24;
                          break;
                          default:
                          break;
                      }
                      gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
                    }

                    this.budgetKW = response.data.return_data.Budget_KW;
                    this.returnGapTime = gapTime;
                    this.returnEndTime = response.data.return_data.end_date;
                    this.returnUseEndDate = response.data.return_data.use_end_date;
                    this.Budget_KW_result = response.data.return_data.Budget_KW_result;
                    this.total_budget = response.data.return_data.total_budget;

                    this.currencyData = {
                                          currency: response.data.return_data.currency,
                                          currency_name: response.data.return_data.currency_name,
                                          currency_symbol: response.data.return_data.currency_symbol,
                                          currency_min_price: response.data.return_data.currency_min_price,
                                          currency_video_min_price: response.data.return_data.currency_video_min_price,
                                          currency_suggest_price: response.data.return_data.currency_suggest_price,
                                          currency_remarketing_price: response.data.return_data.currency_remarketing_price,
                                          KW_min_price: response.data.return_data.KW_min_price,
                                          DM_min_price: response.data.return_data.DM_min_price,
                                          LA_min_price: response.data.return_data.LA_min_price,
                                          RT_min_price: response.data.return_data.RT_min_price,
                                          AC_min_price: response.data.return_data.AC_min_price,
                                          currency_offset: response.data.return_data.offset,
                                        }

                    let _tmp_Target_LA = response.data.return_data.Target_LA;
                    let _tmp_Budget_LA = response.data.return_data.Budget_LA;
                    // if(_tmp_Target_LA == '1'){
                    //   _tmp_Target_LA = false;
                    //   _tmp_Budget_LA = 0;

                    //   Swal.fire(
                    //               this.showLang[this.selectLang]['views']['Event']['created']['LA_swal_title'],
                    //               this.showLang[this.selectLang]['views']['Event']['created']['LA_swal_text'],
                    //               'warning'
                    //             )
                    // }

                  //  console.log('response.data.return_data.daily_budget');
                  //  console.log(response.data.return_data.daily_budget);

                    this.methodData = {
                                        Target_KW : response.data.return_data.Target_KW,
                                        Budget_KW : response.data.return_data.Budget_KW,
                                        Target_DM : response.data.return_data.Target_DM,
                                        Budget_DM : response.data.return_data.Budget_DM,
                                        Target_LA : response.data.return_data.Target_LA,
                                        Budget_LA : response.data.return_data.Budget_LA,
                                        Target_RT : response.data.return_data.Target_RT,
                                        Budget_RT : response.data.return_data.Budget_RT,
                                        Target_CF : response.data.return_data.Target_CF,
                                        Budget_CF : response.data.return_data.Budget_CF,
                                        Target_AD : response.data.return_data.Target_AD,
                                        Budget_AD_min : response.data.return_data.Budget_AD_min,
                                        Budget_AD_max : response.data.return_data.Budget_AD_max,
                                        Target_CR : response.data.return_data.Target_CR,
                                        Other_Target_CR : false,
                                        use_similar_audience_status : response.data.return_data.use_similar_audience_status,
                                        use_confldential_audience_status : response.data.return_data.use_confldential_audience_status,
                                        retargeting : response.data.return_data.retargeting,
                                        daily_budget : response.data.return_data.daily_budget
                                      }

                  //  console.log('this.methodData');
                  //  console.log(this.methodData);
                  //  console.log('response.data.return_data.Target_LA');
                  //  console.log(response.data.return_data.Target_LA);
                  //  console.log('b showAdvertisingMix');
                  //  console.log(this.showAdvertisingMix);

                    if(response.data.return_data.Target_LA == '1'){

                      var todayForm = new Date();
                      var yearForm = todayForm.getFullYear();
                      var dateForm = String(todayForm.getDate()).padStart(2, '0');
                      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                      let get_value_la = 'false_'+yearForm + monthForm + dateForm + timeForm;

                      this.showAdvertisingMix = get_value_la;
                    }

                  //  console.log('a showAdvertisingMix');
                  //  console.log(this.showAdvertisingMix);

                    if(response.data.return_data.Target_RT == '1'){

                      var todayForm = new Date();
                      var yearForm = todayForm.getFullYear();
                      var dateForm = String(todayForm.getDate()).padStart(2, '0');
                      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                      let get_value_rt = 'false_'+yearForm + monthForm + dateForm + timeForm;

                      this.showRemarketingMix = get_value_rt;
                    }

                    this.dynBudgetData = {
                      useDynamicBudget: response.data.return_data.use_dynamic_budget,
                    }

                    this.doForwardData = {
                      useDoForward: response.data.return_data.use_do_forward,
                    }

                    this.dateData = {
                                      start_date : response.data.return_data.start_date,
                                      end_date : response.data.return_data.end_date,
                                      use_end_date : response.data.return_data.use_end_date
                                    }

                    this.keywordData = {
                                          product_url : response.data.return_data.product_url,
                                          keywords : response.data.return_data.keywords,
                                          base_keyword_list: response.data.return_data.base_keyword_list,
                                          select_keywords : response.data.return_data.keywords
                                        }

                  //  console.log('this.keywordData');
                  //  console.log(this.keywordData);

                    this.lookData = {
                                      default_lookalikes : response.data.return_data.default_lookalikes,
                                      custom_lookalikes : response.data.return_data.custom_lookalikes,
                                      custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
                                      default_lookalikes_list : response.data.return_data.default_lookalikes_list,
                                      custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
                                    }

                  //  console.log('this.lookData');
                  //  console.log(this.lookData);

                    this.audiencesData = {
                                      default_audiences : response.data.return_data.default_audiences,
                                      custom_audiences : response.data.return_data.custom_audiences,
                                      custom_audiences_selected : response.data.return_data.custom_audiences_selected,
                                      default_audiences_list : response.data.return_data.default_audiences_list,
                                      custom_audiences_list : response.data.return_data.custom_audiences_list
                                    }

                  //  console.log('this.audiencesData');
                  //  console.log(this.audiencesData);

                    this.goalsData = {
                                        campaign_objective : response.data.return_data.campaign_objective,
                                        objective_option : response.data.return_data.objective_option,
                                        objective_list : response.data.return_data.objective_list,
                                        product_catalog_list : response.data.return_data.product_catalog_list,
                                        product_set_list : response.data.return_data.product_set_list,
                                        optimization_action : response.data.return_data.optimization_action,
                                        optimization_goal : response.data.return_data.optimization_goal,
                                        product_catalog_id : response.data.return_data.product_catalog_id,
                                        product_set_id : response.data.return_data.product_set_id,
                                        useAppEvent: response.data.return_data.useAppEvent,
                                        appItemsSelected: response.data.return_data.appItemsSelected,
                                        appItemsList: response.data.return_data.appItemsList,
                                        pixel_id : response.data.return_data.pixel_id,
                                        pixel_event : response.data.return_data.pixel_event,
                                        conversion_domain : response.data.return_data.conversion_domain,
                                        domain_list: response.data.return_data.domain_list,
                                        effect : response.data.return_data.effect,
                                        currency_video_min_price: response.data.return_data.currency_video_min_price,
                                        form_addition : response.data.return_data.form_addition,
                                        use_addition : response.data.return_data.use_addition,
                                        risk_automatic : response.data.return_data.risk_automatic,
                                        risk_index : response.data.return_data.risk_index,
                                        risk_level_list: response.data.return_data.risk_level_list,
                                        risk_level: response.data.return_data.risk_level
                                      }

                    this.currentOptimizationAction = response.data.return_data.optimization_action || '';

                    this.getGoalsObjective = response.data.return_data.campaign_objective;

                  //  console.log('this.goalsData');
                  //  console.log(this.goalsData);

                    this.regionsData = {
                                          location_types : response.data.return_data.location_types,
                                          location_item : response.data.return_data.location_item,
                                          locations : response.data.return_data.locations,
                                          location_range : response.data.return_data.location_range,
                                          locales : response.data.return_data.locales,
                                          gender : response.data.return_data.gender
                                        }

                  //  console.log('b this.regionsData');
                  //  console.log(this.regionsData);

                  //  console.log('response.data.return_data.Target_DM');
                  //  console.log(response.data.return_data.Target_DM);
                    if(response.data.return_data.Target_DM == true){
                    //  console.log('13~65');
                      this.regionsData.age_min = 18;
                      this.regionsData.age_max = 65;
                    } else {
                    //  console.log('no 13~65');
                      this.regionsData.age_min = response.data.return_data.age_min;
                      this.regionsData.age_max = response.data.return_data.age_max;
                    }

                  //  console.log('a this.regionsData');
                  //  console.log(this.regionsData);

                    this.selectCountries = response.data.return_data.locations

                    this.selectLangs = response.data.return_data.locales

                    this.exAudiencesData = {
                                              excluded_audiences : response.data.return_data.excluded_audiences,
                                              default_excluded_audiences : response.data.return_data.default_excluded_audiences,
                                              custom_excluded_audiences : response.data.return_data.custom_excluded_audiences,
                                              custom_excluded_audiences_selected : response.data.return_data.custom_excluded_audiences_selected,
                                            }

                    this.pdData = {
                                    auto_publisher : response.data.return_data.auto_publisher,
                                    publisher_platforms : response.data.return_data.publisher_platforms,
                                    publisher_platforms_list : response.data.return_data.publisher_platforms_list,
                                    device_platforms: response.data.return_data.device_platforms,
                                    user_os : response.data.return_data.user_os,
                                    user_os_list : response.data.return_data.user_os_list
                                  }

                    this.auto_publisher = response.data.return_data.auto_publisher
                    this.publisher_platforms = response.data.return_data.publisher_platforms

                    this.idData = {
                                    page_id : response.data.return_data.page_id,
                                    ig_id : response.data.return_data.ig_id,
                                    ig_username : response.data.return_data.ig_username,
                                    adpages_list : response.data.return_data.adpages_list,
                                    ig_list : response.data.return_data.ig_list,
                                  }

                    this.postData = {
                                      page_id : response.data.return_data.page_id,
                                      special_ad_category : response.data.return_data.special_ad_category,
                                      disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                      creative_optimize : response.data.return_data.creative_optimize,
                                      creative_optimize: response.data.return_data.creative_optimize,
                                      db_select_article : response.data.return_data.post_ids,
                                      db_select_creatives : response.data.return_data.creatives_ids,
                                      db_select_creatives_message : response.data.return_data.creatives_message_ids,
                                      db_select_creatives_adset_ads : response.data.return_data.creatives_ids_adset_ads,
                                      db_select_creatives_adset_ads_message : response.data.return_data.creatives_adset_ads_message,
                                    }

                  //  console.log('db_select_creatives_adset_ads_message');
                  //  console.log(response.data.return_data.creatives_adset_ads_message);
                    // console.log('b this.postData');
                    // console.log(this.postData);

                    // if(response.data.return_data.campaign_objective == 'PRODUCT_CATALOG_SALES'){
                    //   this.postData.db_select_creatives_adset_ads = response.data.return_data.creatives_ids_adset_ads;
                    // } else {
                    //   this.postData.db_select_creatives = response.data.return_data.creatives_ids;
                    // }

                  //  console.log('a this.postData');
                  //  console.log(this.postData);

                    this.adMaterialData = {
                                            disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                            creative_optimize: response.data.return_data.creative_optimize,
                                            creative_array : response.data.return_data.creative_array,
                                          }

                    this.tmpAdMaterialDataNew = {
                                                  disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                                  creative_optimize: response.data.return_data.creative_optimize,
                                                  creative_array : response.data.return_data.creative_array
                                                }

                    this.formPixelId = response.data.return_data.pixel_id

                    this.formPageId = response.data.return_data.page_id

                    this.first_form_id = response.data.return_data.first_form_id

                    this.form_status = response.data.return_data.form_status

                    this.first_message_id = response.data.return_data.first_message_id

                    this.message_status = response.data.return_data.message_status

                    this.db_writing_status = response.data.return_data.writing_status

                    this.db_status = response.data.return_data.status

                  //  console.log('load this.adMaterialData');
                  //  console.log(this.adMaterialData);
                  //  console.log('load this.tmpAdMaterialDataNew');
                  //  console.log(this.tmpAdMaterialDataNew);

                    // if(response.data.return_data.creative_array.length > 0){
                    //   this.showAdvertisingMaterial = true;
                    //   this.showMsg = true;
                    // } else {
                    //   this.showAdvertisingMaterial = false;
                    //   this.showMsg = false;
                    // }

                    // console.log('response.data.return_data.form_addition:'+response.data.return_data.form_addition);
                    // console.log('b this.goalsData:'+this.goalsData.form_addition);
                    this.minAddition(response.data.return_data.form_addition, gapTime, response.data.return_data.Budget_KW, this.returnUseEndDate);
                    // console.log('a this.goalsData:'+this.goalsData.form_addition);
                  }

                  if(response.data.status == 'login'){
                    Swal.fire({
                      icon: 'error',
                      title: this.showLang[this.selectLang]['views']['Event']['created']['login']['swal_title'],
                      text: this.showLang[this.selectLang]['views']['Event']['created']['login']['swal_text'],
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['Event']['created']['login']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        // this.allPageLoading = true
                        window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                      }
                    })
                  }

                //  console.log('return this.showTargetCR');
                //  console.log(this.showTargetCR);
                  if(this.showTargetCR == false){
                    this.showCampaignData = true;
                  }
                });
            }
          });
      } else {
        Swal.fire({
          icon: 'error',
          title: this.showLang[this.selectLang]['views']['Event']['created']['no_hash_swal_title'],
          text: this.showLang[this.selectLang]['views']['Event']['created']['no_hash_swal_text'],
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: this.showLang[this.selectLang]['views']['Event']['created']['no_hash_swal_confirm_button']
          // denyButtonText: `Don't save`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            // Swal.fire('Saved!', '', 'success')
            // this.allPageLoading = true
            window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
          } else if (result.isDenied) {
            // Swal.fire('Changes are not saved', '', 'info')
            // this.allPageLoading = true
            window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
          }
        })
      }
    },
    watch:{
      // 'formPageId': function(v){
      // //  console.log('event formPageId');
      // //  console.log(v);
      // },
      // 'idData.page_id': function(v){
      // //  console.log('event idData.page_id');
      // //  console.log(v);
      // }
      stageTreeHaveTest(newVal, oldVal) {
      //  console.log('stageTreeHaveTest changed:', oldVal, '->', newVal);
      },
      stageTreeList(newVal, oldVal) {
      //  console.log('stageTreeList changed:', oldVal, '->', newVal);
      },
      stageTreeContent(newVal, oldVal) {
      //  console.log('stageTreeContent changed:', oldVal, '->', newVal);
      },
      AdvertisingMaterialStatus(status) {
        // console.log('watch AdvertisingMaterialStatus');
        // console.log(status);
        if (status) {
          // console.log(status);
          this.$nextTick().then(() =>
            this.$refs.scrollcontent.scrollTo({
              top: 1505,
              behavior: 'smooth'
            })
          );
        }
      },
      sub_campaigns(v){
      //  console.log('sub_campaigns');
      //  console.log(v);
      },
      'customRulesData': function(v){
      //  console.log('customRulesData');
      //  console.log(this.customRulesData)
      },
      'menu':function(v){
      //  console.log('menu content');
      //  console.log(v);
      },
      'customRulesData.haveTest':function(v){
      //  console.log('StrategyEvent customRulesData.haveTest')
      //  console.log(v);

        let subCampaignsContentLength = this.customRulesData.subCampaignsContent.length;

        if(this.doForwardData.useDoForward == true){
          if(v == true){
            for (var i = 0; i < subCampaignsContentLength; i++) {
              if(i >= 2){
                this.customRulesData.subCampaignsContent[i].forwardData.showBlock = false;
              } else {
                this.customRulesData.subCampaignsContent[i].forwardData.showBlock = true;
              }
            }
          } else {
            for (var i = 0; i < subCampaignsContentLength; i++) {
              if(i >= 1){
                this.customRulesData.subCampaignsContent[i].forwardData.showBlock = false;
              } else {
                this.customRulesData.subCampaignsContent[i].forwardData.showBlock = true;
              }
            }
          }
        } else {
          for (var i = 0; i < subCampaignsContentLength; i++) {
            this.customRulesData.subCampaignsContent[i].forwardData.showBlock = true;
          }
        }

      //  console.log(this.customRulesData);
      },
      'doForwardData.useDoForward':function(v){
      //  console.log('doForwardData.useDoForward');
      //  console.log(v);

        let subCampaignsContentLength = this.customRulesData.subCampaignsContent.length;

        if(v == true){
          if(this.customRulesData.haveTest == true){
            for (var i = 0; i < subCampaignsContentLength; i++) {
              if(i >= 2){
                this.customRulesData.subCampaignsContent[i].forwardData.showBlock = false;
              } else {
                this.customRulesData.subCampaignsContent[i].forwardData.showBlock = true;
              }
            }
          } else {
            for (var i = 0; i < subCampaignsContentLength; i++) {
              if(i >= 1){
                this.customRulesData.subCampaignsContent[i].forwardData.showBlock = false;
              } else {
                this.customRulesData.subCampaignsContent[i].forwardData.showBlock = true;
              }
            }
          }
        } else {
          for (var i = 0; i < subCampaignsContentLength; i++) {
            this.customRulesData.subCampaignsContent[i].forwardData.showBlock = true;
          }
        }

      //  console.log(this.customRulesData);
      },
      "customRulesData.stageTreeList": {
        handler(newVal, oldVal) {
        //  console.log("customRulesData.stageTreeList updated:", newVal);
          // 在此處執行需要的操作
          this.handleStageTreeUpdate(newVal);
        },
        deep: true, // 深度監聽，確保監控到數組或對象內部的變化
        immediate: true, // 如果需要在組件初始化時立即觸發
      },
    },
    methods: {
      getMethodLabel(method) {
        const labels = {
          FIRST: "行銷目標",
          META_TEST: "測試階段",
          META_KW: "精準興趣",
          META_LA: "類似受眾",
          META_RT: "再行銷",
          META_ASC: "ASC",
        };
        return labels[method] || "未知方法";
      },
      updateStageTreeHaveTest(value){
      //  console.log('updateStageTreeHaveTest', value);
      //  console.log('b stageTreeHaveTest', this.stageTreeHaveTest);
        this.stageTreeHaveTest = value;
      //  console.log('a stageTreeHaveTest', this.stageTreeHaveTest);

        this.activeStageTreeNodeIndex = 0;
        this.activeStageTreeItemIndex = 0;
      },
      updateStageTreeList(value){
      //  console.log('updateStageTreeList', value);
      //  console.log('b stageTreeList', this.stageTreeList);
        this.stageTreeList = value;
      //  console.log('a stageTreeList', this.stageTreeList);

      //  console.log('b rawData', this.rawData);
        this.rawData = this.defaultTreeMenu.concat(this.stageTreeList);
      //  console.log('a rawData', this.rawData);

      //  console.log('b activeStageTreeNodeIndex', this.activeStageTreeNodeIndex);
      //  console.log('b activeStageTreeItemIndex', this.activeStageTreeItemIndex);
        this.activeStageTreeNodeIndex = 0;
        this.activeStageTreeItemIndex = 0;
      //  console.log('a activeStageTreeNodeIndex', this.activeStageTreeNodeIndex);
      //  console.log('a activeStageTreeItemIndex', this.activeStageTreeItemIndex);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        todayForm = yearForm + monthForm + dateForm + timeForm;

        this.treeUpdateStatus = 'true_'+todayForm;

      //  console.log('b this.stageTreeContent', this.stageTreeContent);
        // if (
        //   this.stageTreeList.length === this.stageTreeContent.length &&
        //   this.stageTreeList.every(
        //     (group, i) => group.length === this.stageTreeContent[i].length
        //   )
        // ) {
        // //  console.log('同步forwardData showBlock');
        //   this.stageTreeList.forEach((group, groupIndex) => {
        //     group.forEach((item, itemIndex) => {
        //       this.stageTreeContent[groupIndex][itemIndex].forwardData.showBlock = item.isGoAhead;

        //       if(item.isGoAhead === false){
        //         this.stageTreeContent[groupIndex][itemIndex].forwardData.frequency = "1d";
        //         this.stageTreeContent[groupIndex][itemIndex].forwardData.rule_frequency = [];
        //       }
        //     });
        //   });
        // }

        let _tmpStageTreeListLength = this.stageTreeList.length;
        let _tmpStageTreeList = JSON.parse(JSON.stringify(this.stageTreeList));
        let _tmpStageTreeContent = JSON.parse(JSON.stringify(this.stageTreeContent));

      //  console.log('b _tmpStageTreeList', _tmpStageTreeList);
      //  console.log('b this.stageTreeHaveTest', this.stageTreeHaveTest);

        for(let i = 0; i < _tmpStageTreeListLength; i++){
          let _tmpStageTreeItemListLength = this.stageTreeList[i].length;
          for(let j = 0; j < _tmpStageTreeItemListLength; j++){
            // console.log('b _tmpStageTreeContent['+i+']['+j+'].forwardData', _tmpStageTreeContent[i][j].forwardData);
            // console.log('this.stageTreeList['+i+']['+j+'].isGoAhead', this.stageTreeList[i][j].isGoAhead);

            if(_tmpStageTreeContent[i] && _tmpStageTreeContent[i][j] && _tmpStageTreeContent[i][j].forwardData){
              _tmpStageTreeContent[i][j].forwardData.showBlock = this.stageTreeList[i][j].isGoAhead;
            }

            if(_tmpStageTreeContent[i] && _tmpStageTreeContent[i][j] && _tmpStageTreeContent[i][j].release){
              _tmpStageTreeContent[i][j].release.is_hold = this.stageTreeList[i][j].isHold;
            }

            // console.log('a _tmpStageTreeContent['+i+']['+j+'].forwardData', _tmpStageTreeContent[i][j].forwardData);
            // console.log('a _tmpStageTreeContent['+i+']['+j+']', _tmpStageTreeContent[i][j]);
            // console.log('a _tmpStageTreeContent['+i+']', _tmpStageTreeContent[i]);
            // console.log('a _tmpStageTreeContent', _tmpStageTreeContent);

            if(_tmpStageTreeList[i] && _tmpStageTreeList[i][j] && _tmpStageTreeList[i][j].list && _tmpStageTreeList[i][j].list.Forward){
              if(this.stageTreeHaveTest === true){
                if(_tmpStageTreeContent[i] && _tmpStageTreeContent[i][j] && _tmpStageTreeContent[i][j].method){
                  if(_tmpStageTreeContent[i][j].method != 'META_TEST'){
                    _tmpStageTreeList[i][j].list.Objective.showStatus = false;
                  }
                }
              } else {
                _tmpStageTreeList[i][j].list.Objective.showStatus = true;
              }

              _tmpStageTreeList[i][j].list.Forward.showStatus = this.stageTreeList[i][j].isGoAhead;
            }

            if(this.stageTreeList[i] && this.stageTreeList[i][j]){
              if(this.stageTreeList[i][j].isGoAhead == false){
              //  console.log('in');
                if(_tmpStageTreeContent[i] && _tmpStageTreeContent[i][j] && _tmpStageTreeContent[i][j].forwardData){
                  _tmpStageTreeContent[i][j].forwardData.frequency = "1d";
                  _tmpStageTreeContent[i][j].forwardData.rule_frequency = [];
                }
              }
            }
          }
        }

      //  console.log('f _tmpStageTreeList', _tmpStageTreeList);
      //  console.log('f _tmpStageTreeContent', _tmpStageTreeContent);

        this.stageTreeList = [..._tmpStageTreeList];
        this.stageTreeContent = [..._tmpStageTreeContent];

      //  console.log('f this.stageTreeList', this.stageTreeList);
      //  console.log('f this.stageTreeContent', this.stageTreeContent);
      },
      handleStageTreeUpdate(updatedData) {
        // 這裡是監測到變化後的處理邏輯
      //  console.log("處理更新後的數據:", updatedData);
      },
      childSelectedCategories(value){
        this.keywordsSelectedCategories = value;
      },
      delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      async fetchData(subCampaigns, response, method) {
        if (!response || !response.data || !response.data.return_data) {
          console.error('Invalid response data');
          return;
        }

        const haveTest = response.data.return_data.haveTest;

        const resultData = [];
        const resultStrategyData = [];

        try {
          // 遍歷 stageTreeContent，每個 group 處理

          let _tmpStageTreeContentLength = subCampaigns.length;

        //  console.log("b this.stageTreeContent:", this.stageTreeContent);

          for (const group of subCampaigns) {
            const validGroup = Array.isArray(group) ? group : [group];

            const groupResult = [];
            const groupStrategyResult = [];

          //  console.log("處理新的一組資料開始");

            // 遍歷每個 group 的 item
            for (const [index, item] of validGroup.entries()) {
            //  console.log(`開始處理第 ${index + 1} 個項目:`, item);

              const response = await this.treeSubDataToPHP(item, index, haveTest, method);
              if (response && response.data) {
                // if (item.release && typeof item.release.sr_i !== 'undefined') {
                //   item.release.sr_i = response.data.campaign_id;
                //   item.release.strategy_id = response.data.strategy_sub_id;
                // //  console.log(`更新 release.sr_i 為: ${response.data.campaign_id}`);
                // //  console.log(`更新 release.strategy_id 為: ${response.data.strategy_sub_id}`);
                // }

                // groupResult.push(parseInt(response.data.campaign_id));
                // groupStrategyResult.push(parseInt(response.data.strategy_sub_id));

                groupResult.push(response.data.return_data);
              }

            //  console.log(`第 ${index + 1} 個項目處理完成:`, item);
            }

          //  console.log("該組資料處理完成:", groupResult);

            // 收集每個 group 的結果
            // resultData.push(groupResult.length === 1 ? groupResult[0] : groupResult);

            if (groupResult.length === 1) {
              resultData.push([groupResult[0]]);
            } else {
              resultData.push(groupResult);
            }
          }

          // 更新最終資料
          this.stageTreeContent = resultData;
          // this.toSaveTreeStrategyData = resultStrategyData;
          // console.log("全部資料已成功傳送並更新:", this.toSaveTreeData);
          // console.log("全部資料已成功傳送並更新:", this.toSaveTreeStrategyData);
        //  console.log("this.stageTreeList:", this.stageTreeList);
        //  console.log("b this.rawData:", this.rawData);
          this.rawData = this.defaultTreeMenu.concat(this.stageTreeList);
          //console.log("a this.rawData:", this.rawData);
          //console.log("全部資料已成功後的this.stageTreeContent:", this.stageTreeContent);

          if(this.stageTreeContent[0][0].adMaterialData.creative_array[0] != null && this.stageTreeContent[0][0].adMaterialData.creative_array[0] != '' && typeof this.stageTreeContent[0][0].adMaterialData.creative_array[0] != 'undefined'){
            let first_form_id = this.stageTreeContent[0][0].adMaterialData.creative_array[0].form_sr_i;
            if(first_form_id != '' && first_form_id != null && typeof first_form_id != 'undefined'){
              this.first_form_id = first_form_id;
            }

            let first_message_id = this.stageTreeContent[0][0].adMaterialData.creative_array[0].message_sr_i;
            if(first_message_id != '' && first_message_id != null && typeof first_message_id != 'undefined'){
              this.first_message_id = first_message_id;
            }
          }

          this.showCampaignData = true;
        } catch (error) {
          console.error("傳送資料過程中發生錯誤:", error);
        }

        // 使用 reduce 按顺序执行请求
        // subCampaigns.reduce((promiseChain, value, index) => {
        //   let _toMenuIndex = index + parseInt(1);

        //   return promiseChain
        //     .then(() => {
        //     //  console.log(`Making request for item: ${value} at index: ${index}`);
        //       return axios.post('https://www.autoturn.net/api/customize/campaign/campaign_subset_dev_01.php', Qs.stringify({
        //         s_code: this.$route.params.id,
        //         adaccount_id: this.$route.params.adaccount_id,
        //         haveTest: haveTest,
        //         useDoForward: this.doForwardData.useDoForward,
        //         itemIndex: index,
        //         campaign_id: value,
        //         useOtherCustom: method
        //       }));
        //     })
        //     .then(subResponse => {
        //     //  console.log(`Fetched data for item: ${value}`);
        //     //  console.log('response.data:', subResponse.data);

        //       if(subResponse.data.status == 'success'){
        //         let _tmpReturnMenu = JSON.stringify(subResponse.data.return_menu);
        //         this.menu[_toMenuIndex] = JSON.parse(_tmpReturnMenu);
        //         this.customRulesData.haveTest = response.data.return_data.haveTest;

        //         if(subResponse.data.subset_method != 'META_TEST'){
        //           let _toStageListIndex = index;
        //           if(this.customRulesData.haveTest == true){
        //             _toStageListIndex = index - parseInt(1);
        //           }

        //         //  console.log(typeof subResponse.data.return_stage_list);
        //         //  console.log(subResponse.data.return_stage_list);
        //           let _tmpReturnStageList = JSON.stringify(subResponse.data.return_stage_list);
        //           this.customRulesData.stageList[_toStageListIndex] = JSON.parse(_tmpReturnStageList)
        //         }

        //         if(subResponse.data.subset_method == 'META_ASC'){
        //           var todayForm = new Date();
        //           var yearForm = todayForm.getFullYear();
        //           var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //           var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //           var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //           todayForm = yearForm + monthForm + dateForm + timeForm;

        //           this.haveASC = 'true_'+todayForm;
        //         }

        //       //  console.log(typeof subResponse.data.return_data);
        //       //  console.log(subResponse.data.return_data);
        //         // console.log('this.customRulesData.subCampaignsContent['+index+'] = JSON.parse(JSON.stringify('+subResponse.data.return_data+')');
        //         let _tmpReturnData = JSON.stringify(subResponse.data.return_data);
        //         // console.log(_tmpReturnData);
        //         // this.customRulesData.subCampaignsContent[index] = JSON.parse(_tmpReturnData);

        //         try {
        //           JSON.parse(_tmpReturnData);
        //         //  console.log("JSON 格式正确");
        //         } catch (error) {
        //           console.error("JSON 格式错误:", error.message);
        //         }

        //         // this.customRulesData.subCampaignsContent.splice(index, 1, JSON.parse(_tmpReturnData));

        //         // if (!this.customRulesData.subCampaignsContent[index]) {
        //         //   this.customRulesData.subCampaignsContent.splice(index, 1, this.ensureReactive({}));
        //         // } else {
        //         //   // 确保对象是响应式的
        //         //   this.customRulesData.subCampaignsContent[index] = this.ensureReactive(this.customRulesData.subCampaignsContent[index]);
        //         // }

        //         if (!this.customRulesData.subCampaignsContent[index]) {
        //           this.customRulesData.subCampaignsContent[index] = reactive({});
        //         }

        //       //  console.log('before db+ this.customRulesData');
        //       //  console.log(this.customRulesData);

        //         if (this.customRulesData.subCampaignsContent && index != null) {
        //           const parsedData = JSON.parse(_tmpReturnData);

        //         //  console.log('Index:', index);
        //         //  console.log('Original Object:', this.customRulesData.subCampaignsContent[index]);
        //         //  console.log('Data to Assign:', parsedData);

        //           if(this.customRulesData.subCampaignsContent[index] != null && parsedData != null){
        //             Object.assign(this.customRulesData.subCampaignsContent[index], parsedData);
        //           }

        //           // this.customRulesData.subCampaignsContent[index] = {
        //           //     ...this.customRulesData.subCampaignsContent[index],
        //           //     ...parsedData
        //           // };

        //           if(!this.customRulesData.subCampaignsContent[index]){
        //           //  console.log('資料沒更新成功');
        //           } else {
        //           //  console.log("有資料");
        //           }

        //         //  console.log('this.customRulesData.subCampaignsContent['+index+']');
        //         //  console.log(this.customRulesData.subCampaignsContent[index]);
        //         //  console.log(this.customRulesData.subCampaignsContent);
        //         //  console.log(this.customRulesData);
        //         } else {
        //           console.error('subCampaignsContent 或 index 無效');
        //         }

        //         // console.log('check subCampaignsContent');
        //         // this.customRulesData.subCampaignsContent.forEach((checkValue, checkIndex) => {
        //         // //  console.log(checkIndex);
        //         // //  console.log(checkValue);
        //         // });

        //       //  console.log(index+ ' db+ this.customRulesData');
        //       //  console.log(this.customRulesData);

        //       //  console.log(index+ ' campaign_subset this.menu');
        //       //  console.log(this.menu);
        //       }

        //       if(_toMenuIndex == subCampaigns.length){
        //       //  console.log('db end this.showTargetCR');
        //       //  console.log(this.showTargetCR);
        //       //  console.log('campaign_subset done');
        //         this._tmpMenu = this.menu;
        //       //  console.log('fetchData this._tmpMenu');
        //       //  console.log(this._tmpMenu);

        //         if(this.doForwardData.useDoForward == true){
        //           if(this.customRulesData.haveTest == true){
        //           //  console.log('#1');
        //             for (var i = 0; i < subCampaigns.length; i++) {
        //               if(i >= 2){
        //                 this.customRulesData.subCampaignsContent[i].forwardData.showBlock = false;
        //               }
        //             }
        //           } else {
        //           //  console.log('#2');
        //             for (var i = 0; i < subCampaigns.length; i++) {
        //               if(i >= 1){
        //                 this.customRulesData.subCampaignsContent[i].forwardData.showBlock = false;
        //               }
        //             }
        //           }
        //         } else {
        //         //  console.log('#3');
        //           for (var i = 0; i < subCampaigns.length; i++) {
        //             this.customRulesData.subCampaignsContent[i].forwardData.showBlock = true;
        //           }
        //         }

        //         this.showCampaignData = true;
        //       }
        //     })
        //     .catch(error => {
        //       console.error(`Error fetching data for item: ${value}`, error.subResponse ? error.subResponse.data : error.message);
        //     });
        // }, Promise.resolve());
      },
      async treeSubDataToPHP(item, index, haveTest, method) {
        try {
          // 模擬 PHP API 的 URL
          const apiUrl = "https://www.autoturn.net/api/customize/campaign/campaign_subset_of_tree.php";

        //  console.log('treeSendDataToPHP item', item);

          // 將資料轉換為表單格式
          const formData = new URLSearchParams();
          Object.keys(item).forEach((key) => {
            formData.append(key, item[key]);
          });

          // 傳送資料
          // const response = await axios.post(apiUrl, formData, {
          //   headers: {
          //     'Content-Type': 'application/json',
          //   },
          // });

          const response = await axios.post(apiUrl, Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            haveTest: haveTest,
            useDoForward: this.doForwardData.useDoForward,
            itemIndex: index,
            campaign_id: item,
            useOtherCustom: method
          }));

        //  console.log('treeSendDataToPHP response', response);

          // 回傳 PHP 的結果 (假設返回結構為 { id: 編號 })
          return response;
        } catch (error) {
          console.error("傳送資料失敗:", error);
          throw error; // 重新拋出錯誤
        }
      },
      changeYoutubeType(){
        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        todayForm = yearForm + monthForm + dateForm + timeForm;

        this.youtubeClose = 'false_'+todayForm;

      //  console.log('eventadd changeYoutubeType');
      //  console.log(this.youtubeClose);
      },
      childYoutube(v){
        this.youtubeClose = v;
      },
      useLang(v){
      //  console.log('event methods useLang');
      //  console.log(v);

        if(v == '' || v == null || typeof v == 'undefined'){
          v = 'zh-TW';
        }

        this.selectLang = v

        this.$emit('childLang', v);

      //  console.log('this.selectLang');
      //  console.log(this.selectLang);
      //  console.log(this.menu);
        // console.log('showLang['+v+'][msg]');
        // console.log(this.showLang[v]['msg']);

        if(this.showTargetCR != true && this.showOtherTargetCR != true){
          this.menu = [
            {
              title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_0_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_1_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_2_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_3_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_4_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_7_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_6_title'], show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 1
            },
            // {
            //   title: '關鍵字與受眾',
            //   submenu: [
            //     {title: '精準興趣關鍵字', show: true, checked: false},
            //     {title: '類似受眾廣告組合', show: true, checked: false},
            //   ],
            //   open: true,
            //   show: true,
            //   target: 2
            // },
            {
              title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_1_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_2_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_3_title'], show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 2
            },
            {
              title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_1_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_2_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_3_title'], show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 3
            },
          ];
        } else {
          this.menu = [
            {
              title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_0_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_1_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_2_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_3_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_4_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_7_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_6_title'], show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 1
            },
            // {
            //   title: '關鍵字與受眾',
            //   submenu: [
            //     {title: '精準興趣關鍵字', show: true, checked: false},
            //     {title: '類似受眾廣告組合', show: true, checked: false},
            //   ],
            //   open: true,
            //   show: true,
            //   target: 2
            // },
            {
              title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_1_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_2_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_3_title'], show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 2
            },
            {
              title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_1_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_2_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_3_title'], show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 3
            },
          ];
        }
      },
      campaignData(value){
      //  console.log('campaignData'+value);
        this.campaign_name = value
      },
      campaignNameEdit(type){
        // console.log('campaignNameEdit');

        this.isEdit = type;

        // if(type == true){
        // //  console.log('鎖定');
        //   document.getElementById("campaignName").focus();
        //   this.$refs.campaignName.focus();
        // }
      },
      haveTest(value){
        let get_value = value.split('_');

        if(get_value[0] == 'false'){
        //  console.log('event haveTest false');
          let subCampaignsContentLength = this.customRulesData.subCampaignsContent.length;
          let _tmpSubCampaignsContent = [];

          for(let i = 0; i < subCampaignsContentLength; i++){
            if(this.customRulesData.subCampaignsContent[i].method != null && this.customRulesData.subCampaignsContent[i].method != '' && typeof this.customRulesData.subCampaignsContent[i].method != 'undefined'){
              if(this.customRulesData.subCampaignsContent[i].method != 'META_TEST'){
                this.customRulesData.subCampaignsContent[i].goalsData.showBlock = true;
                this.customRulesData.subCampaignsContent[i].pdData.showBlock = true;
                this.customRulesData.subCampaignsContent[i].postData.showBlock = true;
                _tmpSubCampaignsContent.push(this.customRulesData.subCampaignsContent[i]);
              }
            }
          }

        //  console.log('_tmpSubCampaignsContent');
        //  console.log(_tmpSubCampaignsContent);

          this.customRulesData.subCampaignsContent = _tmpSubCampaignsContent;
          this.customRulesData.editIndex = 0;

          let _tmpMenu = [];
          for(let i = 0; i < this.menu.length; i++){
            if(this.menu[i].title != '測試素材（Facebook）'){
              _tmpMenu.push(this.menu[i]);
            }
          }

          this.menu = _tmpMenu;
        } else {
        //  console.log('event haveTest true');
          if(this.customRulesData.subCampaignsContent[0].method != 'META_TEST'){
            this.customRulesData.subCampaignsContent.unshift(this.defaultStage['USE_TEST']['META_TEST']);

            this.menu.splice(1, 0, this.stageMenu['USE_TEST']['META_TEST']);

            let subCampaignsContentLength = this.customRulesData.subCampaignsContent.length;
            let _tmpSubCampaignsContent = [];

            for(let i = 0; i < subCampaignsContentLength; i++){
              if(this.customRulesData.subCampaignsContent[i].method != null && this.customRulesData.subCampaignsContent[i].method != '' && typeof this.customRulesData.subCampaignsContent[i].method != 'undefined'){
                if(this.customRulesData.subCampaignsContent[i].method != 'META_TEST'){
                  this.customRulesData.subCampaignsContent[i].goalsData.showBlock = false;
                  this.customRulesData.subCampaignsContent[i].pdData.showBlock = false;
                  this.customRulesData.subCampaignsContent[i].postData.showBlock = false;
                }
              }

              _tmpSubCampaignsContent.push(this.customRulesData.subCampaignsContent[i]);
            }

            this.customRulesData.subCampaignsContent = _tmpSubCampaignsContent;
            this.customRulesData.editIndex = 0;
          }
        }

        let subCampaignsContentLength = this.customRulesData.subCampaignsContent.length;
        if(this.doForwardData.useDoForward == true){
        //  console.log('#1');
          if(this.customRulesData.haveTest == true){
          //  console.log('#1-1');
            for (var i = 0; i < subCampaignsContentLength; i++) {
              if(i >= 2){
              //  console.log('#1-1-1');
                this.customRulesData.subCampaignsContent[i].forwardData.showBlock = false;
              } else {
              //  console.log('#1-1-2');
                this.customRulesData.subCampaignsContent[i].forwardData.showBlock = true;
              }
            }
          } else {
          //  console.log('#1-2');
            for (var i = 0; i < subCampaignsContentLength; i++) {
              if(i >= 1){
              //  console.log('#1-2-1');
                this.customRulesData.subCampaignsContent[i].forwardData.showBlock = false;
              } else {
              //  console.log('#1-2-2');
                this.customRulesData.subCampaignsContent[i].forwardData.showBlock = true;
              }
            }
          }
        } else {
        //  console.log('#2');
          for (var i = 0; i < subCampaignsContentLength; i++) {
            this.customRulesData.subCampaignsContent[i].forwardData.showBlock = true;
          }
        }

      //  console.log('event haveTest');
      //  console.log(this.customRulesData);
      //  console.log(this.menu);
      },
      changeEdit(value){
        let get_value = value.split('_');
        let index = parseInt(get_value[0]);

      //  console.log('b changeEdit this.customRulesData');
      //  console.log(this.customRulesData);

        this.customRulesData.editIndex = index;

        // console.log('a changeEdit this.customRulesData');
        // console.log(index);
        // console.log(typeof index);
        // console.log(this.customRulesData);
        // console.log(this.customRulesData.subCampaignsContent);
        // console.log(this.customRulesData.subCampaignsContent[index]);

        // if(this.customRulesData.subCampaignsContent[index].method == 'TIKTOK_KW'){
        // //  console.log('this.customRulesData.subCampaignsContent['+index+'].keywordData');
        // //  console.log(this.customRulesData.subCampaignsContent[index].keywordData);
        // //  console.log('this.tiktokDefaultStage');
        // //  console.log(this.tiktokDefaultStage);
        // //  console.log('this.customRulesData.subCampaignsContent['+index+'].keywordData.creator_action_categories');
        // //  console.log(this.customRulesData.subCampaignsContent[index].keywordData.creator_action_categories);
        // //  console.log('this.customRulesData.subCampaignsContent['+index+'].keywordData.creator_action_categories.length');
        // //  console.log(this.customRulesData.subCampaignsContent[index].keywordData.creator_action_categories.length);
        //   if(this.customRulesData.subCampaignsContent[index].keywordData.creator_action_categories.length <= 0){
        //     let _tmpCreatorActionCategories = JSON.stringify(this.tiktokDefaultStage['USE_TEST']['TIKTOK_KW'].keywordData.creator_action_categories);
        //   //  console.log('_tmpCreatorActionCategories');
        //   //  console.log(_tmpCreatorActionCategories);
        //     this.customRulesData.subCampaignsContent[index].keywordData.creator_action_categories = JSON.parse(_tmpCreatorActionCategories);
        //   //  console.log('this.customRulesData.subCampaignsContent[index].keywordData.creator_action_categories');
        //   //  console.log(this.customRulesData.subCampaignsContent[index].keywordData.creator_action_categories);
        //   }
        // }

        // console.log('end changeEdit this.customRulesData');
        // console.log(index);
        // console.log(typeof index);
        // console.log(this.customRulesData);
        // console.log(this.customRulesData.subCampaignsContent);
        // console.log(this.customRulesData.subCampaignsContent[index]);
        // console.log(this.customRulesData.subCampaignsContent[index].keywordData);
        // console.log(this.customRulesData.subCampaignsContent[index].keywordData.creator_action_categories);
      },
      switchPhase(value){
      //  console.log('switchPhase', value);
        let _tmpdata = value.split('_');

        this.activeStageTreeNodeIndex = _tmpdata[0];
        this.activeStageTreeItemIndex = _tmpdata[1];

        //console.log(this.stageTreeContent);
        //console.log(this.stageTreeContent[this.activeStageTreeNodeIndex][this.activeStageTreeItemIndex]);

        let first_form_id = this.stageTreeContent[this.activeStageTreeNodeIndex][this.activeStageTreeItemIndex].adMaterialData.creative_array[0].form_sr_i;
        this.first_form_id = null;
        if(first_form_id != '' && first_form_id != null && typeof first_form_id != 'undefined'){
          this.first_form_id = first_form_id;
        }

        let first_message_id = this.stageTreeContent[this.activeStageTreeNodeIndex][this.activeStageTreeItemIndex].adMaterialData.creative_array[0].message_sr_i;
        this.first_message_id = null;
        if(first_message_id != '' && first_message_id != null && typeof first_message_id != 'undefined'){
          this.first_message_id = first_message_id;
        }
      },
      switchArea(value, groupIndex, itemIndex){
      //  console.log('switchArea', value, groupIndex, itemIndex);

        let switchGroupIndex = groupIndex;
        if(switchGroupIndex > 0 && (switchGroupIndex != '' && switchGroupIndex != null && typeof switchGroupIndex !== 'undefined')){
          switchGroupIndex = groupIndex - parseInt(1);
        }

        this.target = value;

        this.activeStageTreeNodeIndex = switchGroupIndex;
        this.activeStageTreeItemIndex = itemIndex;
      },
      switchItem(value, groupIndex, itemIndex, refName, groupType){
      //  console.log('switchItem', value, groupIndex, itemIndex, refName, groupType);

        let switchGroupIndex = groupIndex;
      //  console.log('b switchGroupIndex', switchGroupIndex);
      //  console.log(switchGroupIndex != '');
      //  console.log(switchGroupIndex != null);
      //  console.log(typeof switchGroupIndex !== 'undefined');
      //  console.log(switchGroupIndex != '' && switchGroupIndex != null && typeof switchGroupIndex !== 'undefined');
        if(switchGroupIndex > 0 && (switchGroupIndex != '' && switchGroupIndex != null && typeof switchGroupIndex !== 'undefined')){
        //  console.log('change switchGroupIndex');
          switchGroupIndex = groupIndex - parseInt(1);
        }
      //  console.log('a switchGroupIndex', switchGroupIndex);

        this.target = value;

        this.activeStageTreeNodeIndex = switchGroupIndex;
        this.activeStageTreeItemIndex = itemIndex;

      //  console.log('this.stageTreeList', this.stageTreeList);
      //  console.log('this.stageTreeList['+this.activeStageTreeNodeIndex+']['+this.activeStageTreeItemIndex+']', this.stageTreeList[this.activeStageTreeNodeIndex][this.activeStageTreeItemIndex]);

        this.$nextTick(() => {
          if(typeof groupType !== 'undefined'){
            let childComponent = this.$refs.childCampaignName;
            if(groupType === 'MarketingMethod'){
              childComponent = this.$refs.childMarketingMethod;
            }
            if(groupType === 'BenefitsAndInvestment'){
              childComponent = this.$refs.childBenefitsAndInvestment;
            }
            if(groupType === 'StageTreeComponent'){
              childComponent = this.$refs.childStageTreeComponent;
            }
            if(groupType === 'MarketingDate'){
              childComponent = this.$refs.childMarketingDate;
            }
            if(groupType === 'StageKeywordMix'){
              childComponent = this.$refs.childStageKeywordMix;
            }
            if(groupType === 'StageAdvertisingMix'){
              childComponent = this.$refs.childStageAdvertisingMix;
            }
            if(groupType === 'StargeRemarketingMix'){
              childComponent = this.$refs.childStargeRemarketingMix;
            }
            if(groupType === 'StageGoalsAndBudget'){
              childComponent = this.$refs.childStageGoalsAndBudget;
            }
            if(groupType === 'StageRegions'){
              childComponent = this.$refs.childStageRegions;
            }
            if(groupType === 'StagePositionDeviceIdentity'){
              childComponent = this.$refs.childStagePositionDeviceIdentity;
            }
            if(groupType === 'StageMaterial'){
              childComponent = this.$refs.childStageMaterial;
            }
            if (childComponent && childComponent.$refs[refName]) {
            //  console.log('移動');
              childComponent.$refs[refName].scrollIntoView({ behavior: "smooth", block: "start" });
            }
          }
        });
      },
      minAddition(budgetAddition, day, budgetKW, useEndDate){
        // console.log('value budgetAddition:'+budgetAddition);

        // console.log('getDate budgetAddition:'+day);
        // console.log('budgetKWTotal budgetAddition:'+budgetKW);
        // console.log('useEndDate budgetAddition:'+useEndDate);

        // if(useEndDate == false){
        //   //有結束日期
        //   // console.log('有結束日期');
        //   //先算精準興趣總預算

        //   if(!isNaN(day) && day > 0){
        //     // console.log('有日期間距');
        //     var _tmp_days = day;
        //     var _tmp_total = budgetKW;
        //     // var _tmp_budget_addition = (budget_addition == '' || budget_addition == 0)?0:budget_addition/100
        //     var _tmp_interval_week = 0;
        //     var interval_week = 0;
        //     var n = 0;
        //     var html = 0;
        //     var video_min_price = this.currencyData.currency_video_min_price;
        //     var _tmp_budget_addition = video_min_price;

        //     let _test_total = 0;

        //     if(_tmp_days > 0){
        //         if(_tmp_days > 3){
        //             n = Math.round(_tmp_days/7);
        //         }
        //     }

        //     //console.log(_tmp_total+'*7');
        //     var first_week = _tmp_total*7;

        //     for(var i = 1; i < n; i++){
        //         var days_pow = i + 1;
        //         // console.log('days_pow:'+days_pow);
        //         // console.log(_tmp_total+' * Math.pow((1 + '+_tmp_budget_addition+'), '+days_pow+') * 7');

        //         //console.log('('+_tmp_total +'+ ('+days_pow+' - 1) * '+_tmp_budget_addition+') * 7');
        //         _tmp_interval_week = (parseInt(_tmp_total) + (parseInt(days_pow) - 1) * parseInt(_tmp_budget_addition)) * 7;

        //         // console.log(interval_week +'='+ interval_week +'+'+ _tmp_interval_week);
        //         interval_week = interval_week + _tmp_interval_week;
        //     }

        //     // console.log(_tmp_total + ' * Math.pow((1 + '+_tmp_budget_addition+'), '+n+') * ('+_tmp_days+' - 7 * '+n+')');

        //     //console.log('('+_tmp_total +'+'+ n +'*'+ _tmp_budget_addition+') * ('+_tmp_days +' - 7 * '+ n+')');
        //     var finish_week = (parseInt(_tmp_total) + parseInt(n) * parseInt(_tmp_budget_addition)) * (parseInt(_tmp_days) - 7 * parseInt(n));

        //     if(_tmp_days > 0 && _tmp_total > 0){
        //         // console.log('Math.round('+first_week +'+'+ interval_week +'+'+ finish_week+')');
        //         html = Math.round(parseInt(first_week) + parseInt(interval_week) + parseInt(finish_week));
        //     }

        //     _test_total = html;

        //     this.Budget_KW_result = html;

        //     //計算最低預算比率
        //     let _ratio = ((Math.ceil(((parseInt(_test_total) / (parseInt(_tmp_total) * parseInt(_tmp_days))))*100)/100 - 1)*100).toFixed(0);

        //     this.updateMinAddition = _ratio;

        //     if(parseInt(budgetAddition) < parseInt(_ratio)){
        //       // console.log('有結束日期之下，不允許小於:'+_ratio);
        //       this.goalsData.form_addition = _ratio;
        //     } else {
        //       // console.log(budgetAddition +" > "+ _ratio);
        //     }
        //   } else {
        //     // console.log('沒結束日期也沒日期間距');
        //     var _tmp_keyword_split_budget = budgetKW;
        //     var video_min_price = this.currencyData.currency_video_min_price;
        //     var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        //     if(_tmp_keyword_split_budget == 0){
        //         single_ratio = 0;
        //     }

        //     this.updateMinAddition = single_ratio;

        //     if(parseInt(budgetAddition) < parseInt(single_ratio)){
        //       // console.log('沒結束日期之下，不允許小於:'+single_ratio);
        //       this.goalsData.form_addition = single_ratio;
        //     } else {
        //       // console.log(budgetAddition +" > "+ single_ratio);
        //     }
        //   }

        // } else {
        //   //沒結束日期
        //   // console.log('沒結束日期');
        //   var _tmp_keyword_split_budget = budgetKW;
        //   var video_min_price = this.currencyData.currency_video_min_price;
        //   var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        //   if(_tmp_keyword_split_budget == 0){
        //       single_ratio = 0;
        //   }

        //   this.updateMinAddition = single_ratio;

        //   if(budgetAddition < single_ratio){
        //     // console.log('沒結束日期之下，不允許小於:'+single_ratio);
        //     this.goalsData.form_addition = single_ratio;
        //   } else {
        //     // console.log(budgetAddition +" > "+ single_ratio);
        //   }
        // }

        // console.log('update this.updateMinAddition:'+this.updateMinAddition);

        // return 'string form test_call';
      },
      methodTargetKW(value){
      //  console.log('methods childTargetKW')
      //  console.log(value);
      //  console.log(this.menu[0]);
        this.showTargetKW = value
        if(this.menu[0].submenu[3] != null && this.menu[0].submenu[3] != '' && typeof this.menu[0].submenu[3] != 'undefined'){
          this.menu[0].submenu[3].show = value;
        }

        if(value == true){
          this.minAddition(this.goalsData.form_addition, this.returnGapTime, this.budgetKW, this.returnUseEndDate);
        } else {
          this.updateMinAddition = 0;
        }

        // if(!this.menu[1].submenu[0].show && !this.menu[1].submenu[1].show){
        //   this.menu[1].show = false
        // } else {
        //   this.menu[1].show = true
        // }
      },
      methodTargetDM(value){
        // console.log('methods childTargetDM')
        // console.log(value);
        this.showTargetDM = value

        if(value == true){
          // if(this.getGoalsObjective == 'CONVERSIONS'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 65;
          // }
          // if(this.getGoalsObjective == 'LINK_CLICKS'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }
          // if(this.getGoalsObjective == 'POST_ENGAGEMENT'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }
          // if(this.getGoalsObjective == 'VIDEO_VIEWS'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }
          // if(this.getGoalsObjective == 'LEAD_GENERATION'){
          //   this.regionsData.age_min = 18;
          //   this.regionsData.age_max = 65;
          // }
          // if(this.getGoalsObjective == 'MESSAGES'){
          //   this.regionsData.age_min = 13;
          //   this.regionsData.age_max = 64;
          // }

          this.regionsData.age_min = 18;
          this.regionsData.age_max = 65;
        }

        // console.log(this.regionsData);
      },
      methodTargetLA(value){
      //  console.log('methods childTargetLA')
      //  console.log(value);
      //  console.log(this.lookData);
        this.showTargetLA = value
        if(this.menu[0].submenu[4] != '' && this.menu[0].submenu[4] != null && typeof this.menu[0].submenu[4] != 'undefined'){
          this.menu[0].submenu[4].show = value
        }

        let customLookalikesListLength = 0;
        if(this.lookData.custom_lookalikes_list != null && this.lookData.custom_lookalikes_list != null != '' && typeof this.lookData.custom_lookalikes_list != 'undefined'){
          customLookalikesListLength = this.lookData.custom_lookalikes_list.length;
        }

        if(value == true && customLookalikesListLength <= 0){
        //  console.log('in');
          var todayForm = new Date();
          var yearForm = todayForm.getFullYear();
          var dateForm = String(todayForm.getDate()).padStart(2, '0');
          var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
          var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

          let get_value = 'true_'+yearForm + monthForm + dateForm + timeForm;

          this.showAdvertisingMix = get_value;
        //  console.log('axios showAdvertisingMix');
        //  console.log(this.showAdvertisingMix);

          axios
            .post('https://www.autoturn.net/api/customize/campaign/campaign_lookalikes.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
              pixel_id: this.goalsData.pixel_id,
              product_url: this.productUrl,
            }))
            .then((response) => {
              if(response.data.status == 'success'){

                this.lookData = {
                                  default_lookalikes : response.data.return_data.default_lookalikes,
                                  custom_lookalikes : response.data.return_data.custom_lookalikes,
                                  custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
                                  default_lookalikes_list : response.data.return_data.default_lookalikes_list,
                                  custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
                                }

                var todayForm = new Date();
                var yearForm = todayForm.getFullYear();
                var dateForm = String(todayForm.getDate()).padStart(2, '0');
                var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                let get_value = 'false_'+yearForm + monthForm + dateForm + timeForm;

                this.showAdvertisingMix = get_value;
              }
            });
        }

        if(value != true && this.lookData.custom_lookalikes != null) {
          this.lookData = {
                            default_lookalikes : null,
                            custom_lookalikes : null,
                            custom_lookalikes_selected : null,
                            default_lookalikes_list : null,
                            custom_lookalikes_list : null
                          }
        }

      //  console.log(this.lookData);
      //  console.log('end showAdvertisingMix');
      //  console.log(this.showAdvertisingMix);

        // if(!this.menu[1].submenu[0].show && !this.menu[1].submenu[1].show){
        //   this.menu[1].show = false
        // } else {
        //   this.menu[1].show = true
        // }
      },
      methodTargetRT(value){
      //  console.log('methods childTargetRT')
      //  console.log(value);
      //  console.log('this.audiencesData');
      //  console.log(this.audiencesData);
        this.showTargetRT = value

        if(this.menu[0].submenu[5] != '' && this.menu[0].submenu[5] != null && typeof this.menu[0].submenu[5] != 'undefined'){
          this.menu[0].submenu[5].show = value
        }

        if(value == true && this.audiencesData.custom_audiences_list.length <= 0){
        //  console.log('in');

          var todayForm = new Date();
          var yearForm = todayForm.getFullYear();
          var dateForm = String(todayForm.getDate()).padStart(2, '0');
          var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
          var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

          let get_value = 'ture_'+yearForm + monthForm + dateForm + timeForm;

          this.showRemarketingMix = get_value;

          axios
            .post('https://www.autoturn.net/api/customize/campaign/campaign_audiences.php', Qs.stringify({
              s_code: this.$route.params.id,
              adaccount_id: this.$route.params.adaccount_id,
            }))
            .then((response) => {
              if(response.data.status == 'success'){

                this.audiencesData = {
                                  default_audiences : response.data.return_data.default_audiences,
                                  custom_audiences : response.data.return_data.custom_audiences,
                                  custom_audiences_selected : response.data.return_data.custom_audiences_selected,
                                  default_audiences_list : response.data.return_data.default_audiences_list,
                                  custom_audiences_list : response.data.return_data.custom_audiences_list
                                }

                var todayForm = new Date();
                var yearForm = todayForm.getFullYear();
                var dateForm = String(todayForm.getDate()).padStart(2, '0');
                var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                let get_value = 'false_'+yearForm + monthForm + dateForm + timeForm;

                this.showRemarketingMix = get_value;
              }
            });
        }

        if(value != true && this.audiencesData.custom_audiences != null) {
          this.audiencesData = {
                            default_audiences : null,
                            custom_audiences : null,
                            custom_audiences_selected : null,
                            default_audiences_list : null,
                            custom_audiences_list : null
                          }
        }

      //  console.log('this.audiencesData');
      //  console.log(this.audiencesData);
      //  console.log('end showRemarketingMix');
      //  console.log(this.showRemarketingMix);
      },
      methodTargetCF(value){
        this.showTargetCF = value
        if(this.menu[0].submenu[5] != '' && this.menu[0].submenu[5] != null && typeof this.menu[0].submenu[5] != 'undefined'){
          this.menu[0].submenu[5].show = value
        }
      },
      methodTargetAD(value){
      //  console.log('methodTargetAD');
      //  console.log(value);

        this.showTargetAD = value;
        this.efficientAi = value;

        if(value == true){
          this.dateData.end_date = '0000-00-00';
        }
      //  console.log('this.dateData.end_date');
      //  console.log(this.dateData.end_date);
      },
      methodTargetCR(value){
      //  console.log('methodTargetCR');
      //  console.log(value)
        this.showTargetCR = value

        // if(value == true && this.lookData.custom_lookalikes.length <= 0){
        // //  console.log('in');
        //   var todayForm = new Date();
        //   var yearForm = todayForm.getFullYear();
        //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //   let get_value = 'true_'+yearForm + monthForm + dateForm + timeForm;

        //   this.showAdvertisingMix = get_value;
        // //  console.log('axios showAdvertisingMix');
        // //  console.log(this.showAdvertisingMix);

        //   axios
        //     .post('https://www.autoturn.net/api/customize/campaign/campaign_lookalikes.php', Qs.stringify({
        //       s_code: this.$route.params.id,
        //       adaccount_id: this.$route.params.adaccount_id,
        //       pixel_id: this.goalsData.pixel_id,
        //       product_url: this.productUrl,
        //     }))
        //     .then((response) => {
        //       if(response.data.status == 'success'){

        //         this.lookData = {
        //                           default_lookalikes : response.data.return_data.default_lookalikes,
        //                           custom_lookalikes : response.data.return_data.custom_lookalikes,
        //                           custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
        //                           default_lookalikes_list : response.data.return_data.default_lookalikes_list,
        //                           custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
        //                         }

        //         var todayForm = new Date();
        //         var yearForm = todayForm.getFullYear();
        //         var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //         var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //         var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //         let get_value = 'false_'+yearForm + monthForm + dateForm + timeForm;

        //         this.showAdvertisingMix = get_value;
        //       }
        //     });
        // }

        // if(value != true && this.lookData.custom_lookalikes != null) {
        //   this.lookData = {
        //                     default_lookalikes : null,
        //                     custom_lookalikes : null,
        //                     custom_lookalikes_selected : null,
        //                     default_lookalikes_list : null,
        //                     custom_lookalikes_list : null
        //                   }
        // }

        // if(value == true && this.audiencesData.custom_audiences_list.length <= 0){
        // //  console.log('in');

        //   var todayForm = new Date();
        //   var yearForm = todayForm.getFullYear();
        //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //   let get_value = 'ture_'+yearForm + monthForm + dateForm + timeForm;

        //   this.showRemarketingMix = get_value;

        //   axios
        //     .post('https://www.autoturn.net/api/customize/campaign/campaign_audiences.php', Qs.stringify({
        //       s_code: this.$route.params.id,
        //       adaccount_id: this.$route.params.adaccount_id,
        //     }))
        //     .then((response) => {
        //       if(response.data.status == 'success'){

        //         this.audiencesData = {
        //                           default_audiences : response.data.return_data.default_audiences,
        //                           custom_audiences : response.data.return_data.custom_audiences,
        //                           custom_audiences_selected : response.data.return_data.custom_audiences_selected,
        //                           default_audiences_list : response.data.return_data.default_audiences_list,
        //                           custom_audiences_list : response.data.return_data.custom_audiences_list
        //                         }

        //         var todayForm = new Date();
        //         var yearForm = todayForm.getFullYear();
        //         var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //         var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //         var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //         let get_value = 'false_'+yearForm + monthForm + dateForm + timeForm;

        //         this.showRemarketingMix = get_value;
        //       }
        //     });
        // }

        // if(value != true && this.audiencesData.custom_audiences != null) {
        //   this.audiencesData = {
        //                     default_audiences : null,
        //                     custom_audiences : null,
        //                     custom_audiences_selected : null,
        //                     default_audiences_list : null,
        //                     custom_audiences_list : null
        //                   }
        // }

        // console.log('this.audiencesData');
        // console.log(this.audiencesData);

        if(value == true){
          if(this.subCampaignList.length <= 0){
            this.menu = [
              {
                title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_title'],
                submenu: [
                  {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_0_title'], show: true, checked: false},
                  {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_1_title'], show: true, checked: false},
                  {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_2_title'], show: true, checked: false},
                  {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_3_title'], show: false, checked: false},
                  {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_4_title'], show: false, checked: false},
                  {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_7_title'], show: false, checked: false},
                  {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_6_title'], show: true, checked: false},
                ],
                open: true,
                show: true,
                target: 1
              },
            ];

          //  console.log('0 this.stageMenu');
          //  console.log(this.stageMenu);

            let _tmpMenu = JSON.parse(JSON.stringify(this.menu));
            let _tmpMetaTest = JSON.parse(JSON.stringify(this.stageMenu['USE_TEST']['META_TEST']));
            let _tmpMetaKw = JSON.parse(JSON.stringify(this.stageMenu['USE_TEST']['META_KW']));
            let _tmpMetaLa = JSON.parse(JSON.stringify(this.stageMenu['USE_TEST']['META_LA']));
            let _tmpMetaAsc = JSON.parse(JSON.stringify(this.stageMenu['USE_TEST']['META_RT']));

            _tmpMenu.push(_tmpMetaTest);
            _tmpMenu.push(_tmpMetaKw);
            _tmpMenu.push(_tmpMetaLa);
            _tmpMenu.push(_tmpMetaAsc);

          //  console.log('1 this.stageMenu');
          //  console.log(this.stageMenu);

          //  console.log('b this.menu');
          //  console.log(this.menu);

          //  console.log('2 this.stageMenu');
          //  console.log(this.stageMenu);

            let stageIndex = 1;

          //  console.log('b _tmpMenu');
          //  console.log(_tmpMenu);
          //  console.log('b this.menu');
          //  console.log(this.menu);

            for(let i = 0; i < _tmpMenu.length; i++){
            //  console.log('_tmpMenu[1].title');
            //  console.log(_tmpMenu[1].title);
              if(_tmpMenu[1].title == '測試素材（Facebook）' && i > 1){
              //  console.log('#1');
                _tmpMenu[i].title = '第'+stageIndex+'階段：'+_tmpMenu[i].title;
                stageIndex++;
              } else if(_tmpMenu[1].title != '測試素材（Facebook）' && i > 0){
              //  console.log('#2');
                _tmpMenu[i].title = '第'+stageIndex+'階段：'+_tmpMenu[i].title;
                stageIndex++;
              }
            //  console.log('stageIndex');
            //  console.log(stageIndex);
            }

            this.menu = _tmpMenu;

          //  console.log('a _tmpMenu');
          //  console.log(_tmpMenu);

          //  console.log('3 this.stageMenu');
          //  console.log(this.stageMenu);

          //  console.log('a this.menu');
          //  console.log(this.menu);

            this.customRulesData = {
              editIndex: 0,
              haveTest: true,
              stageList: [
                {
                  marketingValue: 'META_KW',
                  source_platform: 'facebook',
                  marketingMethodList: [
                    { name: '精準興趣（Facebook）', code: 'META_KW'},
                    { name: '類似受眾（Facebook）', code: 'META_LA'},
                    { name: '再行銷（Facebook）', code: 'META_RT'},
                    { name: 'ASC（Facebook）', code: 'META_ASC'},
                  ]
                },
                {
                  marketingValue: 'META_LA',
                  source_platform: 'facebook',
                  marketingMethodList: [
                    { name: '精準興趣（Facebook）', code: 'META_KW'},
                    { name: '類似受眾（Facebook）', code: 'META_LA'},
                    { name: '再行銷（Facebook）', code: 'META_RT'},
                    { name: 'ASC（Facebook）', code: 'META_ASC'},
                  ]
                },
                {
                  marketingValue: 'META_RT',
                  source_platform: 'facebook',
                  marketingMethodList: [
                    { name: '精準興趣（Facebook）', code: 'META_KW'},
                    { name: '類似受眾（Facebook）', code: 'META_LA'},
                    { name: '再行銷（Facebook）', code: 'META_RT'},
                    { name: 'ASC（Facebook）', code: 'META_ASC'},
                  ]
                }
              ],
              subCampaignsContent: []
            };

          //  console.log('b this.customRulesData');
          //  console.log(this.customRulesData);

            let _tmpSubCampaignsContent = [];

            _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_TEST']);
            _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_KW']);
            _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_LA']);
            _tmpSubCampaignsContent.push(this.defaultStage['USE_TEST']['META_RT']);

            for(let i = 0; i < _tmpSubCampaignsContent.length; i++){
            //  console.log('開始檢查資料');
            //  console.log(_tmpSubCampaignsContent[i].method);
            //  console.log(_tmpSubCampaignsContent[i].pdData.publisher_platforms);
              if(typeof _tmpSubCampaignsContent[i].pdData.publisher_platforms === 'undefined'){
              //  console.log(_tmpSubCampaignsContent[i].pdData.publisher_platforms);
                _tmpSubCampaignsContent[i].pdData.publisher_platforms = ['facebook', 'instagram', 'audience_network', 'messenger'];
              }

              if(_tmpSubCampaignsContent[i].method == 'META_LA'){
                axios
                  .post('https://www.autoturn.net/api/customize/campaign/campaign_lookalikes.php', Qs.stringify({
                    s_code: this.$route.params.id,
                    adaccount_id: this.$route.params.adaccount_id,
                    pixel_id: this.goalsData.pixel_id,
                    product_url: this.productUrl,
                  }))
                  .then((response) => {
                    if(response.data.status == 'success'){

                      _tmpSubCampaignsContent[i].lookData.default_lookalikes = response.data.return_data.default_lookalikes;
                      _tmpSubCampaignsContent[i].lookData.custom_lookalikes = response.data.return_data.custom_lookalikes;
                      _tmpSubCampaignsContent[i].lookData.custom_lookalikes_selected = response.data.return_data.custom_lookalikes_selected;
                      _tmpSubCampaignsContent[i].lookData.default_lookalikes_list = response.data.return_data.default_lookalikes_list;
                      _tmpSubCampaignsContent[i].lookData.custom_lookalikes_list = response.data.return_data.custom_lookalikes_list;

                      // this.lookData = {
                      //                   default_lookalikes : response.data.return_data.default_lookalikes,
                      //                   custom_lookalikes : response.data.return_data.custom_lookalikes,
                      //                   custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
                      //                   default_lookalikes_list : response.data.return_data.default_lookalikes_list,
                      //                   custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
                      //                 }

                      var todayForm = new Date();
                      var yearForm = todayForm.getFullYear();
                      var dateForm = String(todayForm.getDate()).padStart(2, '0');
                      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                      let get_value_la = 'false_'+yearForm + monthForm + dateForm + timeForm;

                      this.showAdvertisingMix = get_value_la;
                    }
                  });
              }

              if(_tmpSubCampaignsContent[i].method == 'META_RT'){
                axios
                  .post('https://www.autoturn.net/api/customize/campaign/campaign_audiences.php', Qs.stringify({
                    s_code: this.$route.params.id,
                    adaccount_id: this.$route.params.adaccount_id,
                  }))
                  .then((response) => {
                    if(response.data.status == 'success'){

                      _tmpSubCampaignsContent[i].audiencesData.default_audiences = response.data.return_data.default_audiences;
                      _tmpSubCampaignsContent[i].audiencesData.custom_audiences = response.data.return_data.custom_audiences;
                      _tmpSubCampaignsContent[i].audiencesData.custom_audiences_selected = response.data.return_data.custom_audiences_selected;
                      _tmpSubCampaignsContent[i].audiencesData.default_audiences_list = response.data.return_data.default_audiences_list;
                      _tmpSubCampaignsContent[i].audiencesData.custom_audiences_list = response.data.return_data.custom_audiences_list;

                      var todayForm = new Date();
                      var yearForm = todayForm.getFullYear();
                      var dateForm = String(todayForm.getDate()).padStart(2, '0');
                      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                      let get_value_rt = 'false_'+yearForm + monthForm + dateForm + timeForm;

                      this.showRemarketingMix = get_value_rt;
                    }
                  });
              }
            }

            this.customRulesData.subCampaignsContent = _tmpSubCampaignsContent;

          //  console.log('a this.customRulesData');
          //  console.log(this.customRulesData);
          } else {
          //  console.log('b methodTargetCR this.menu');
          //  console.log(this.menu);
          //  console.log('b methodTargetCR this._tmpMenu');
          //  console.log(this._tmpMenu);
            if(this._tmpMenu != '' && this._tmpMenu != null){
              this.menu = this._tmpMenu;
            }
          //  console.log('a methodTargetCR this.menu');
          //  console.log(this.menu);
          //  console.log('a methodTargetCR this._tmpMenu');
          //  console.log(this._tmpMenu);
          }
        } else {
          this.menu = [
            {
              title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_0_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_1_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_2_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_3_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_4_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_7_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_6_title'], show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 1
            },
            // {
            //   title: '關鍵字與受眾',
            //   submenu: [
            //     {title: '精準興趣關鍵字', show: true, checked: false},
            //     {title: '類似受眾廣告組合', show: true, checked: false},
            //   ],
            //   open: true,
            //   show: true,
            //   target: 2
            // },
            {
              title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_1_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_2_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_3_title'], show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 2
            },
            {
              title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_title'],
              submenu: [
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_1_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_2_title'], show: true, checked: false},
                {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_3_title'], show: true, checked: false},
              ],
              open: true,
              show: true,
              target: 3
            },
          ];

        //  console.log('this.showTargetKW');
        //  console.log(this.showTargetKW);
        //  console.log('this.showTargetLA');
        //  console.log(this.showTargetLA);
        //  console.log('this.showTargetRT');
        //  console.log(this.showTargetRT);

          this.menu[0].submenu[3].show = this.showTargetKW
          this.menu[0].submenu[4].show = this.showTargetLA
          this.menu[0].submenu[5].show = this.showTargetRT
        }

      //  console.log('this.customRulesData');
      //  console.log(this.customRulesData);

        this.menu[0].submenu[2].show = value
      },
      methodBudgetKWTotal(value){
        // console.log('methodBudgetKWTotal:'+value);
        // console.log('b this.budgetKW:'+this.budgetKW);
        this.budgetKW = value;

        if(value > 0){
          this.minAddition(this.goalsData.form_addition, this.returnGapTime, value, this.returnUseEndDate);
        }

        // console.log('a this.budgetKW:'+this.budgetKW);
      },
      dateGapTime(value){
        // console.log('dateGapTime:'+value);
        // console.log('b this.returnGapTime:'+this.returnGapTime);
        this.returnGapTime = value;

        if(value > 0){
          this.minAddition(this.goalsData.form_addition, value, this.budgetKW, this.returnUseEndDate);
        }

        // console.log('a this.returnGapTime:'+this.returnGapTime);
      },
      dateEndTime(value){
        // console.log('dateEndTime:'+value);
        // console.log('b this.returnEndTime:'+this.returnEndTime);
        this.returnEndTime = value;

        let startTime = this.dateData.start_date;
        let diffType = 'day';
        let gapTime = 0;

        if(startTime != '' && startTime != '0000-00-00' && startTime != null && value != '' && value != '0000-00-00' && value != null){
          diffType = diffType.toLowerCase();
          var sTime =new Date(startTime); //開始時間
          var eTime =new Date(value); //結束時間
          //作為除數的數字
          var timeType = 1;
          switch (diffType) {
              case"second":
                  timeType =1000;
              break;
              case"minute":
                  timeType =1000*60;
              break;
              case"hour":
                  timeType =1000*3600;
              break;
              case"day":
                  timeType =1000*3600*24;
              break;
              default:
              break;
          }
          gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
        }

        this.returnGapTime = gapTime;

        this.minAddition(this.goalsData.form_addition, gapTime, this.budgetKW, this.returnUseEndDate);

        // console.log('a this.returnEndTime:'+this.returnEndTime);
      },
      dateUseEndDate(value){
        // console.log('dateUseEndDate:'+value);
        // console.log('b this.returnUseEndDate:'+this.returnUseEndDate);
        this.returnUseEndDate = value

        this.minAddition(this.goalsData.form_addition, this.returnGapTime, this.budgetKW, value);

        // console.log('a this.returnUseEndDate:'+this.returnUseEndDate);
      },
      goalsObjective(value){
      //  console.log('event goalsObjective')
      //  console.log(value);
      //  console.log('this.goalsData');
      //  console.log(this.goalsData);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = yearForm + monthForm + dateForm + timeForm;

        this.getGoalsObjective = value

        if(this.showTargetDM == true){
          if(value == 'CONVERSIONS'){
            this.regionsData.age_min = 18;
            this.regionsData.age_max = 65;
          }
          if(value == 'LINK_CLICKS'){
            this.regionsData.age_min = 18;
            this.regionsData.age_max = 64;
          }
          if(value == 'POST_ENGAGEMENT'){
            this.regionsData.age_min = 18;
            this.regionsData.age_max = 64;
          }
          if(value == 'VIDEO_VIEWS'){
            this.regionsData.age_min = 18;
            this.regionsData.age_max = 64;
          }
          if(value == 'LEAD_GENERATION'){
            this.regionsData.age_min = 18;
            this.regionsData.age_max = 65;
          }
          if(value == 'MESSAGES'){
            this.regionsData.age_min = 18;
            this.regionsData.age_max = 64;
          }
        }

        if(value == 'CONVERSIONS'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialData.creative_array = []
        }
        if(value == 'LINK_CLICKS'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialData.creative_array = []
        }
        if(value == 'POST_ENGAGEMENT'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialData.creative_array = []
        }
        if(value == 'VIDEO_VIEWS'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialData.creative_array = []
        }
        if(value == 'LEAD_GENERATION'){
          this.showMaterial = false;
          this.showAdvertisingMaterial = true;
          this.showForm = true;
          this.showMsg = false;

          this.showStageMaterial = 'false_'+get_value;
          this.showStageAdvertisingMaterial = 'true_'+get_value;
          this.showStageForm = 'true_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          // if(this.adMaterialData.creative_array == null){
          //   this.adMaterialData.creative_array = [
          //     {
          //       title: "xxxx",
          //       isEdit: false,
          //       type: 1,
          //       materials:[],
          //       materialSingle: [
          //         {
          //           src: null,
          //           title: null,
          //           size: null
          //         }
          //       ],
          //       callActive: 'SIGN_UP'
          //     }
          //   ]
          // }
        }
        if(value == 'MESSAGES'){
          this.showMaterial = true;
          // this.showAdvertisingMaterial = false;
          this.showForm = false;
          // this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'true_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'true_'+get_value;

          // if(this.adMaterialData.creative_array == null){
          //   this.adMaterialData.creative_array = [
          //     {
          //       title: "xxxx",
          //       isEdit: false,
          //       type: 1,
          //       materials:[],
          //       materialSingle: [
          //         {
          //           src: null,
          //           title: null,
          //           size: null
          //         }
          //       ],
          //       callActive: 'SIGN_UP'
          //     }
          //   ]
          // }
        }

        if(value == 'PRODUCT_CATALOG_SALES'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.postData.select_article = [];
          this.postData.select_creatives = [];

        //  console.log('is PRODUCT_CATALOG_SALES');
        } else {
          this.postData.select_creatives_adset_ads = [];

        //  console.log('not PRODUCT_CATALOG_SALES');
        }

      //  console.log(this.postData);

        this.adMaterialDataNew = this.tmpAdMaterialDataNew

        // console.log('this.showMaterial:'+this.showMaterial);
        // console.log('this.showAdvertisingMaterial:'+this.showAdvertisingMaterial);
        // console.log('this.showForm:'+this.showForm);
        // console.log('this.showMsg:'+this.showMsg);

        // console.log('this.adMaterialData');
        // console.log(this.adMaterialData);
      },
      objectiveOption(value){
        if(value != '' && value != null && typeof value != 'undefined'){
          let objectiveOptionValue = value.split("|");

          // console.log('objectiveOption');
          // console.log(objectiveOptionValue);
          // console.log(this.formPixelId);

          this.formPixelId = objectiveOptionValue[0]
          this.currentOptimizationAction = objectiveOptionValue[2] || ''

          // console.log(this.formPixelId);
        }
      },
      keywordUrl(value){
        // console.log('keywordUrl')
        // console.log(value);

        this.productUrl = value
      },
      getHere(target){
        this.changeYoutubeType();

      //  console.log('getHere target');
      //  console.log(target);
      //  console.log(this.customRulesData);

        this.target = target

        // if(this.menu[1].show == false){
        //   if (target > 1) {
        //     target -= 1
        //   }
        //   this.process = parseInt(33) * (parseInt(target) - parseInt(1))
        // } else {
        //   this.process = parseInt(25) * (parseInt(target) - parseInt(1))
        // }

        if(this.showTargetCR == true){
          this.process = parseInt(50)
        } else {
          this.process = parseInt(33) * (parseInt(target) - parseInt(1))
        }

        document.getElementById('edit_content').scrollTop = 0;
      },
      eventPageId(value) {
        // console.log('methods eventPageId')
        // console.log(value);
        this.formPageId = value
      },
      eventFormId(value) {
      //  console.log('methods eventFormId')
      //  console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
        if(value != '' && value != null && typeof value != 'undefined'){
          this.formId = get_value
        } else {
          this.formId = []
        }
      },
      eventMessageId(value) {
      //  console.log('methods eventMessageId')
      //  console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
        if(value != '' && value != null && typeof value != 'undefined'){
          this.messageId = get_value
        } else {
          this.messageId = []
        }
      },
      adMaterialContent(value){
        // console.log('adMaterialContent')
        // console.log(value);

        if(typeof value.creative_array != 'undefined'){
          this.adMaterialDataNew = value
        } else {
          this.adMaterialDataNew.creative_array = value
        }
      },
      formChangeFormId(value){
      //  console.log('b this.changeFormId')
      //  console.log(this.changeFormId);

      //  console.log('value')
      //  console.log(value);

        // this.changeFormId = null

        // console.log('c this.changeFormId')
        // console.log(this.changeFormId);

        this.changeFormId = value

      //  console.log('a this.changeFormId')
      //  console.log(this.changeFormId);
      },
      formChangeMessageId(value){
        // console.log('formChangeMessageId')
        // console.log(value);

        this.changeMessageId = value
      },
      activeScroll(value){
        let tmpDataType = value.split('_');

        if(tmpDataType[0] == 1){
          this.showAdvertisingMaterial = true;
          this.showMsg = true;

          this.AdvertisingMaterialStatus = this.showMsg;

          // this.$refs.scrollcontent.scrollTo({
          //   top: 1505,
          //   behavior: 'smooth'
          // });
        }
      },
      useASC(value){
      //  console.log('useASC');
      //  console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        todayForm = yearForm + monthForm + dateForm + timeForm;

        if(value == true){
          this.haveASC = 'true_'+todayForm;
        } else {
          this.haveASC = 'false_'+todayForm;
        }
      },
      processData(data) {
        let return_type = data.some(Array.isArray) ? 1 : 2;

        const flattenArray = (arr) => {
          return arr.reduce((acc, val) =>
            Array.isArray(val) ? acc.concat(flattenArray(val)) : acc.concat(val)
          , []);
        };

        let flattened_data = flattenArray(data);

        return {
          return_type: return_type,
          data: flattened_data
        };
      },
      getOtherCustom(data){
      //  console.log('getOtherCustom');
      //  console.log(data);

        let value = data.split('_');
      //  console.log('value');
      //  console.log(value);
        let processSubData = this.processData(this.otherCustomTitle[value[1]].sub);
        let otherCustomSub = processSubData.data;
        let otherCustomContentLength = this.otherCustomTitle[value[1]].content.length;
        this.otherCustomCampaignId = this.otherCustomTitle[value[1]].main_campaign_id;

        if(processSubData.return_type == 1){
          this.doForwardData.useDoForward = true;
        } else {
          this.doForwardData.useDoForward = false;
        }

      //  console.log('otherCustomSub');
      //  console.log(otherCustomSub);
      //  console.log('otherCustomContentLength');
      //  console.log(otherCustomContentLength);
      //  console.log('this.otherCustomTitle[value[1]]');
      //  console.log(this.otherCustomTitle[value[1]]);
      //  console.log('this.otherCustomTitle[value[1]].content');
      //  console.log(this.otherCustomTitle[value[1]].content);

      //  console.log('b showOtherTargetCR');
      //  console.log(this.showOtherTargetCR);

        this.showOtherTargetCR = (value[0] === "true");
        this.methodData.Other_Target_CR = (value[0] === "true");
        this.showCampaignData = false;

      //  console.log('a showOtherTargetCR');
      //  console.log(this.showOtherTargetCR);

        axios
          .post('https://www.autoturn.net/api/campaign_of_tree.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            campaign_id: this.otherCustomCampaignId
          }))
          .then((response) => {
            var todayForm = new Date();
            var yearForm = todayForm.getFullYear();
            var dateForm = String(todayForm.getDate()).padStart(2, '0');
            var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
            var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

            todayForm = yearForm + monthForm + dateForm + timeForm;

            let _tmpCampaignName = response.data.return_data.campaign_name+'_'+todayForm;
            this.campaign_name = _tmpCampaignName;

            if(otherCustomContentLength <= 0){
              // if(otherCustomSub != '' && otherCustomSub != null && typeof otherCustomSub != 'undefined'){
                if(otherCustomSub.length > 0){
                //  console.log('#01');

                  // this.customRulesData.stageList = [];
                  // this.customRulesData.subCampaignsContent = [];

                //  console.log('before db this.customRulesData');
                //  console.log(this.customRulesData);

                  this.customRulesData.haveTest = false;

                  // otherCustomSub.forEach((sub_value, sub_index) => {
                  // //  console.log(sub_index+':'+sub_value);
                  // //  console.log(sub_index+ ' before this.customRulesData');
                  // //  console.log(this.customRulesData);

                  //   let _toMenuIndex = sub_index + parseInt(1);
                  // //  console.log(_toMenuIndex);

                  //   axios
                  //     .post('https://www.autoturn.net/api/customize/campaign/campaign_subset.php', Qs.stringify({
                  //       s_code: this.$route.params.id,
                  //       adaccount_id: this.$route.params.adaccount_id,
                  //       haveTest: response.data.return_data.haveTest,
                  //       itemIndex: sub_index,
                  //       campaign_id: sub_value,
                  //       useOtherCustom: 'use'
                  //     }))
                  //     .then((subResponse) => {
                  //     //  console.log('getOtherCustom campaign_subset subResponse');
                  //     //  console.log(subResponse);
                  //       if(subResponse.data.status == 'success'){
                  //         this.menu[_toMenuIndex] = JSON.parse(JSON.stringify(subResponse.data.return_menu));
                  //         this.customRulesData.haveTest = response.data.return_data.haveTest;
                  //         this.otherCustomTitle[value[1]].statusTest = response.data.return_data.haveTest;

                  //         if(subResponse.data.subset_method != 'META_TEST'){
                  //           let _toStageListIndex = sub_index;
                  //           if(this.customRulesData.haveTest == true){
                  //             _toStageListIndex = sub_index - parseInt(1);
                  //           }
                  //         //  console.log(typeof subResponse.data.return_stage_list);
                  //         //  console.log(subResponse.data.return_stage_list);
                  //           this.customRulesData.stageList[_toStageListIndex] = JSON.parse(JSON.stringify(subResponse.data.return_stage_list));
                  //           this.otherCustomTitle[value[1]].stageList[_toStageListIndex] = JSON.parse(JSON.stringify(subResponse.data.return_stage_list));
                  //         }

                  //         if(subResponse.data.subset_method == 'META_ASC'){
                  //           var todayForm = new Date();
                  //           var yearForm = todayForm.getFullYear();
                  //           var dateForm = String(todayForm.getDate()).padStart(2, '0');
                  //           var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                  //           var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                  //           todayForm = yearForm + monthForm + dateForm + timeForm;

                  //           this.haveASC = 'true_'+todayForm;
                  //         }

                  //       //  console.log(typeof subResponse.data.return_data);
                  //       //  console.log(subResponse.data.return_data);
                  //         this.customRulesData.subCampaignsContent[sub_index] = JSON.parse(JSON.stringify(subResponse.data.return_data));
                  //         this.otherCustomTitle[value[1]].content[sub_index] = JSON.parse(JSON.stringify(subResponse.data.return_data));

                  //       //  console.log(sub_index+ ' db+ this.menu');
                  //       //  console.log(this.menu);
                  //       //  console.log(sub_index+ ' db+ this.customRulesData');
                  //       //  console.log(this.customRulesData);
                  //       }

                  //       if(_toMenuIndex == otherCustomSub.length){
                  //         this.otherCustomTitle[value[1]].menu = this.menu;
                  //         this.menu[0].submenu[2].show = true
                  //       //  console.log('change menu show');
                  //       //  console.log(this.menu);
                  //       //  console.log('db end this.showOtherTargetCR');
                  //       //  console.log(this.showOtherTargetCR);
                  //       //  console.log('db end this.otherCustomTitle');
                  //       //  console.log(this.otherCustomTitle);
                  //       //  console.log('campaign_subset done');
                  //         this.showCampaignData = true;
                  //       }
                  //     });

                  //   // console.log('all db this.customRulesData');
                  //   // console.log(this.customRulesData);
                  //   // console.log('all this.menu');
                  //   // console.log(this.menu);
                  // });

                  this.fetchData(otherCustomSub, response, 'use');
                }
              // }
            }
            else {
            //  console.log('有資料');
            //  console.log(this.menu);
            //  console.log(this.customRulesData);

              this.menu = this.otherCustomTitle[value[1]].menu;
              this.customRulesData.haveTest = this.otherCustomTitle[value[1]].statusTest;
              this.customRulesData.stageList = this.otherCustomTitle[value[1]].stageList;
              this.customRulesData.subCampaignsContent = this.otherCustomTitle[value[1]].content;

            //  console.log(this.menu);
            //  console.log(this.customRulesData);
              this.showCampaignData = true;
            }
          });

        // console.log('getOtherCustom this.customRulesData');
        // console.log(this.customRulesData);
      },
      setHideCustom(data){
        let value = data.split('|||');
      //  console.log('setHideCustom');
      //  console.log(this.otherCustomCampaignId);

        Swal.fire({
          title: '刪除其他自定義',
          html: '您要刪除「'+value[0]+'」其他自定義規則嗎？',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          width: 'auto', // 可選：根據內容自動調整寬度
          padding: '1em',
          confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['yes_button'],
          cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['no_button'],
        }).then((result) => {
          if (result.isConfirmed) {
          //  console.log(value);

            this.showCampaignData = false;

            axios
              .post('https://www.autoturn.net/api/data/campaign_subset_status_update.php', Qs.stringify({
                s_code: this.$route.params.id,
                campaign_id: value[1],
              }))
              .then((response) => {
                // console.log(response.data);
                this.showCampaignData = true;

                if(response.data.status == 'success'){
                  Swal.fire({
                    icon: response.data.status,
                    title: '刪除其他自定義',
                    text: response.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    this.showCampaignData = false;
                    /* Read more about isConfirmed, isDenied below */
                    // if (result.isConfirmed) {
                    //   // Swal.fire('Saved!', '', 'success')
                    //   this.allPageLoading = true
                    //   window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                    // } else if (result.isDenied) {
                    //   // Swal.fire('Changes are not saved', '', 'info')
                    //   this.allPageLoading = true
                    //   window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                    // }

                    // if (result.dismiss === Swal.DismissReason.timer) {
                    //   this.allPageLoading = true
                    //   window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                    // }

                    axios
                      .post('https://www.autoturn.net/api/campaign_of_tree.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        adaccount_id: this.$route.params.adaccount_id,
                        campaign_id: this.$route.params.campaign_id
                      }))
                      .then((response) => {
                        if(response.data.status == 'success'){
                          let otherSubsetDataLength = response.data.return_data.other_subset_data.length;
                          for(let i = 0; i < otherSubsetDataLength; i++){
                            if(response.data.return_data.other_subset_data[i].main_campaign_id == this.otherCustomCampaignId){
                              response.data.return_data.other_subset_data[i].selected = true;
                            }
                          }
                          this.otherCustomTitle = response.data.return_data.other_subset_data;

                          if(otherSubsetDataLength == 0){
                            this.showOtherTargetCR = false;
                            this.methodData.Other_Target_CR = false;
                          }
                        }

                        this.showCampaignData = true;
                      });
                  })
                }
              });
          }
        });
      },
      prev() {
      //  console.log('now target:'+this.target);
        let isTrue = 1;

        this.changeYoutubeType();

        if(this.target == 2){
          // console.log('risk_level:'+this.goalsData.risk_level.code);
          // console.log('effect:'+this.goalsData.effect);
          // if((this.goalsData.risk_level.code == 'auto' || this.goalsData.risk_level.code == 'low') && (this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null)){
          //   Swal.fire(
          //             this.showLang[this.selectLang]['views']['Event']['methods']['prev']['empty_effect_swal_title'],
          //             this.showLang[this.selectLang]['views']['Event']['methods']['prev']['empty_effect_swal_text'],
          //             "warning"
          //           )

          //   isTrue = 0;
          // }
        }

        if(isTrue == 1){
          // if(this.menu[1].show == false){
          if(this.showTargetCR == true){
            this.process -= 50
          } else {
            this.process -= 33
          }

          if (this.target > 1) {
            this.target -= 1

            // if(this.target == 2){
            //   this.target -= 1
            // }
          }
          // } else {
          //   this.process -= 25
          //   if (this.target > 1) {
          //     this.target -= 1
          //   }
          // }
          // console.log('prev target:'+this.target);

          document.getElementById('edit_content').scrollTop = 0;
        }
      },
      next() {
        if (!validateRegulatedCountries(this.benefitsAndInvestmentData, this.selectLang)) return
        // console.log('now target:'+this.target);
        let isTrue = 1;

      //  console.log('next');
      //  console.log(this.customRulesData);

        this.changeYoutubeType();

        if(this.target == 1){
          // const isValid = this.stageTreeList.every(group =>
          //   group.some(item => item.isGoAhead === true)
          // );

          const isValid = this.stageTreeList
            .slice(0, -1)
            .every(group => group.some(item => item.isGoAhead === true));

          if (!isValid) {
            isTrue = 0;

            Swal.fire(
                      "廣告策略",
                      "每個階段至少需要一筆行銷活動設置為 '設為前進條件'",
                      "warning"
                    )

            return;
          }
        }

        if(this.target == 2){
          // console.log('risk_level:'+this.goalsData.risk_level.code);
          // console.log('effect:'+this.goalsData.effect);
          // if((this.goalsData.risk_level.code == 'auto' || this.goalsData.risk_level.code == 'low') && (this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null)){
          //   Swal.fire(
          //             this.showLang[this.selectLang]['views']['Event']['methods']['next']['empty_effect_swal_title'],
          //             this.showLang[this.selectLang]['views']['Event']['methods']['next']['empty_effect_swal_text'],
          //             "warning"
          //           )

          //   isTrue = 0;
          // }

          // let event_text = this.showLang[this.selectLang]['views']['Event']['methods']['next']['product_datalog_sales_default_event_text'];
          // if(this.goalsData.campaign_objective == 'PRODUCT_CATALOG_SALES'){
          //   event_text = this.showLang[this.selectLang]['views']['Event']['methods']['next']['is_product_datalog_sales_default_event_text'];
          // }

          // if(this.goalsData.objective_option == '' || this.goalsData.objective_option == null || typeof this.goalsData.objective_option == 'undefined'){
          //   Swal.fire(
          //             this.showLang[this.selectLang]['views']['Event']['methods']['next']['empty_product_catalog_sales_swal_title'],
          //             event_text,
          //             "warning"
          //           )

          //   isTrue = 0;
          // }

          // if(this.goalsData.campaign_objective == 'PRODUCT_CATALOG_SALES'){
          //   if(this.goalsData.product_set_id == '' || this.goalsData.product_set_id == null || typeof this.goalsData.product_set_id == 'undefined'){
          //     Swal.fire(
          //               this.showLang[this.selectLang]['views']['Event']['methods']['next']['empty_product_catalog_sales_swal_title'],
          //               this.showLang[this.selectLang]['views']['Event']['methods']['next']['is_product_datalog_sales_set_id_event_text'],
          //               "warning"
          //             )

          //     isTrue = 0;
          //   }

          //   if(this.goalsData.product_catalog_id == '' || this.goalsData.product_catalog_id == null || typeof this.goalsData.product_catalog_id == 'undefined'){
          //     Swal.fire(
          //               this.showLang[this.selectLang]['views']['Event']['methods']['next']['empty_product_catalog_sales_swal_title'],
          //               this.showLang[this.selectLang]['views']['Event']['methods']['next']['is_product_datalog_sales_catalog_id_event_text'],
          //               "warning"
          //             )

          //     isTrue = 0;
          //   }
          // }
        }

        if(isTrue == 1){
          // console.log('next target:'+this.target);
          if(this.target == 2){
            // console.log('儲存並發佈');
            if(this.methodData.Target_CR == true || this.methodData.Other_Target_CR == true){
              this.customize();
            }
          } else if(this.target >= 3){
            // console.log('儲存並發佈');
            this.release();
          }

          // if(this.menu[1].show == false){
          if(this.methodData.Target_CR == true || this.methodData.Other_Target_CR == true){
            // console.log('now target:'+this.target);
            if (this.target <= 1) {
              this.process += 50
              this.target += 1
              // this.menu[this.target-1].open = true
            }
          } else {
            if(this.process < 66){
              this.process += 33
              // console.log('now target:'+this.target);
              if (this.target <= 3) {
                this.target += 1
                // this.menu[this.target-1].open = true
              }
              // if(this.target == 2){
              //   this.target += 1
              // }
            }
          }
          // } else {
          //   if(this.process < 75){
          //     this.process += 25
          //     // console.log('now target:'+this.target);
          //     if (this.target <= 4) {
          //       this.target += 1
          //       this.menu[this.target-1].open = true
          //     }
          //     // console.log('next target:'+this.target);
          //   }
          //   // console.log('next target:'+this.target);
          // }
          // console.log('next target:'+this.target);

          document.getElementById('edit_content').scrollTop = 0;
        }
      },
      async form_update() {
        if (!validateRegulatedCountries(this.benefitsAndInvestmentData, this.selectLang)) return
        // 暫存結果用

        if(this.nextLoading == false){
          this.nextLoading = true;
          this.showCampaignData = false;

          const resultData = [];
          const resultStrategyData = [];

          try {
            // 遍歷 stageTreeContent，每個 group 處理

            let _tmpStageTreeContentLength = this.stageTreeContent.length;

            for (const group of this.stageTreeContent) {
              const groupResult = [];
              const groupStrategyResult = [];

            //  console.log("處理新的一組資料開始");

              // 遍歷每個 group 的 item
              for (const [index, item] of group.entries()) {
              //  console.log(`開始處理第 ${index + 1} 個項目:`, item);

                const response = await this.treeSendDataToPHP(item, index, _tmpStageTreeContentLength);
                if (response && response.data && response.data.campaign_id) {
                  if (item.release && typeof item.release.sr_i !== 'undefined') {
                    item.release.sr_i = response.data.campaign_id;
                    item.release.strategy_id = response.data.strategy_sub_id;
                  //  console.log(`更新 release.sr_i 為: ${response.data.campaign_id}`);
                  //  console.log(`更新 release.strategy_id 為: ${response.data.strategy_sub_id}`);
                  }

                  groupResult.push(parseInt(response.data.campaign_id));
                  groupStrategyResult.push(parseInt(response.data.strategy_sub_id));

                }

              //  console.log(`第 ${index + 1} 個項目處理完成:`, item);
              }

            //  console.log("該組資料處理完成:", groupResult);
            //  console.log("該組資料處理完成:", groupStrategyResult);

              // 收集每個 group 的結果
              resultData.push(groupResult.length === 1 ? groupResult[0] : groupResult);
              resultStrategyData.push(groupStrategyResult.length === 1 ? groupStrategyResult[0] : groupStrategyResult);
            }

            // 更新最終資料
            this.toSaveTreeData = resultData;
            this.toSaveTreeStrategyData = resultStrategyData;
          //  console.log("全部資料已成功傳送並更新:", this.toSaveTreeData);
          //  console.log("全部資料已成功傳送並更新:", this.toSaveTreeStrategyData);
          //  console.log("全部資料已成功後的this.stageTreeContent:", this.stageTreeContent);

            var daily_keyword_split_budget = this.methodData.Budget_KW;
            var daily_demo_budget = this.methodData.Budget_DM;
            var budget_addition = this.goalsData.form_addition;

            this.total_budget = 0;

            let _tmp_goalsData = this.goalsData;
            const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
            let _tmp_exAudiencesData = this.exAudiencesData;
            const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

            // console.log(_tmp_exAudiencesData);

            delete _view_goalsData['objective_list'];
            delete _view_exAudiencesData['custom_excluded_audiences'];

            let formData = {
              campaign_id: this.campaign_id,
              strategy_id: this.strategyId,
              campaign_name: this.campaign_name,
              adaccount_id: this.adaccount_id,
              Budget_KW_result: this.Budget_KW_result,
              total_budget: this.total_budget,
              dynBudgetData: this.dynBudgetData,
              doForwardData: this.doForwardData,
              methodData: this.methodData,
              benefitsAndInvestmentData: this.benefitsAndInvestmentData,
              dateData: this.dateData,
              keywordData: this.keywordData,
              lookData: this.lookData,
              audiencesData: this.audiencesData,
              goalsData: _view_goalsData,
              regionsData: this.regionsData,
              selectCountries: this.selectCountries,
              selectLangs: this.selectLangs,
              exAudiencesData: _view_exAudiencesData,
              pdData: this.pdData,
              idData: this.idData,
              postData: this.postData,
              adMaterialData: this.adMaterialDataNew,
              stageData: this.toSaveTreeData,
              stageStrategyData: this.toSaveTreeStrategyData,
              saveToStrategy: this.saveToStrategy,
            }

          //  console.log('warning formData');
          //  console.log(formData);

            let adaccount_id = this.adaccount_id

            axios
              .post('https://www.autoturn.net/api/customize/data/campaign_update_dev_01.php', Qs.stringify({
                s_code: this.$route.params.id,
                form_data: formData,
                type: 'release',
                target: 'edit_release_'+this.target,
              }))
              .then((response) => {
                this.strategyId = response.data.strategy_id;

                if(response.data.status == 'success'){
                  Swal.fire({
                    icon: 'success',
                    title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_swal_title'],
                    text: response.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_confirm_button'],
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')

                      window.location.href = "https://private.autoturn.net/customize-events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                    }
                  })
                } else {
                  let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_default_swal_text'];
                  if(response.data.info != '' && response.data.info != null){
                    text = response.data.info
                  }
                  Swal.fire(
                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_swal_title'],
                    text,
                    'error'
                  )
                }

                this.nextLoading = false;
                this.showCampaignData = true;
              });
          } catch (error) {
            console.error("傳送資料過程中發生錯誤:", error);
            this.nextLoading = false;
            this.showCampaignData = true;
          }
        }
      },
      release(){
        if (!validateRegulatedCountries(this.benefitsAndInvestmentData, this.selectLang)) return
        let isTrue = 1;

        this.changeYoutubeType();

        if(this.methodData.Target_CR == true || this.methodData.Other_Target_CR == true){
        //  console.log('自定義發布');
          this.customize();
        } else {
        //  console.log('原發布');
          // if(this.adaccount_id == null || this.adaccount_id == '' || typeof this.adaccount_id == 'undefined'){
          //   // console.log('#1');
          //   Swal.fire({
          //     icon: 'error',
          //     title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_adaccount_id_swal_title'],
          //     text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_adaccount_id_swal_text'],
          //     showDenyButton: false,
          //     showCancelButton: false,
          //     confirmButtonText:  this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_adaccount_id_swal_confirm_button']
          //   }).then((result) => {
          //     if (result.isConfirmed) {
          //       this.allPageLoading = true
          //       window.location.href = "https://private.autoturn.net/customize-events-list/f/"+this.$route.params.id;
          //     } else if (result.isDenied) {
          //       this.allPageLoading = true
          //       window.location.href = "https://private.autoturn.net/customize-events-list/f/"+this.$route.params.id;
          //     }
          //   })

          //   isTrue = 0;
          // }

          // // if(this.campaign_name == null || this.campaign_name == '' || typeof this.campaign_name == 'undefined'){
          // //   // console.log('#2');
          // //   Swal.fire(
          // //                 this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_campaign_name_swal_title'],
          // //                 this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_campaign_name_swal_text'],
          // //                 "error"
          // //               )
          // //   isTrue = 0;
          // // }

          // if(this.methodData.Target_KW == false && this.methodData.Target_DM == false && this.methodData.Target_LA == false && this.methodData.Target_RT == false && this.methodData.Target_AD == false){
          //   // console.log('#3');
          //   Swal.fire(
          //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_marketing_target_swal_title'],
          //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_marketing_target_swal_text'],
          //             "error"
          //           )
          //   isTrue = 0;
          // }

          // if((this.methodData.Target_KW == true && this.methodData.Budget_KW == '') || (this.methodData.Target_DM == true && this.methodData.Budget_DM == '') || (this.methodData.Target_LA == true && this.methodData.Budget_LA == '') || (this.methodData.Target_RT == true && this.methodData.Budget_RT == '')){
          //   // console.log('#4');
          //   Swal.fire(
          //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_marketing_budget_swal_title'],
          //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_marketing_budget_swal_text'],
          //             "error"
          //           )
          //   isTrue = 0;
          // }

          // if(this.methodData.Target_RT == true){
          //   let audiences_num = 0;
          //   if(this.audiencesData.default_audiences_list.length > 0){
          //     for (var i = 0; i < this.audiencesData.default_audiences_list.length; i++) {
          //       // console.log('i1:'+i);
          //       if(this.audiencesData.default_audiences_list[i].checked == true){
          //         audiences_num = parseInt(audiences_num) + parseInt(1);
          //       }
          //     }
          //   }

          //   if(this.audiencesData.custom_audiences_selected.length > 0){
          //     for (var i = 0; i < this.audiencesData.custom_audiences_selected.length; i++) {
          //       // console.log('i2:'+i);
          //       audiences_num = parseInt(audiences_num) + parseInt(1);
          //     }
          //   }

          //   if(audiences_num < 1){
          //     Swal.fire(
          //               '行銷方式-再行銷',
          //               '請至少選擇一個再行銷受眾. ',
          //               "error"
          //             )
          //     isTrue = 0;
          //   }
          // }

          // if(this.methodData.Target_AD == true){
          //   if(this.methodData.Budget_AD_min != '' && this.methodData.Budget_AD_min != null && typeof this.methodData.Budget_AD_min != 'undefined' && this.methodData.Budget_AD_max != '' && this.methodData.Budget_AD_max != null && typeof this.methodData.Budget_AD_max != 'undefined' && parseInt(this.methodData.Budget_AD_min) >= parseInt(this.methodData.Budget_AD_max)){

          //     Swal.fire(
          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_title'],
          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_text_1'],
          //               "error"
          //             )

          //     isTrue = 0;
          //   }

          //   if(parseInt(this.methodData.Budget_AD_min) == 0 || this.methodData.Budget_AD_min == '' || this.methodData.Budget_AD_min == null || typeof this.methodData.Budget_AD_min == 'undefined'){
          //     Swal.fire(
          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_title'],
          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_text_2'],
          //               "error"
          //             )

          //     isTrue = 0;
          //   }

          //   if(parseInt(this.methodData.Budget_AD_max) == 0 || this.methodData.Budget_AD_max == '' || this.methodData.Budget_AD_max == null || typeof this.methodData.Budget_AD_max == 'undefined'){
          //     Swal.fire(
          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_title'],
          //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_text_3'],
          //               "error"
          //             )

          //     isTrue = 0;
          //   }
          // }

          // if(this.dateData.start_date != '' && this.dateData.start_date != '0000-00-00' && this.dateData.end_date != '' && this.dateData.end_date != '0000-00-00'){
          //   // console.log('#5');
          //   let startTime = this.dateData.start_date;
          //   let endTime = this.dateData.end_date;

          //   var sTime = new Date(startTime); //開始時間
          //   var eTime = new Date(endTime); //結束時間

          //   if(sTime > eTime){
          //     Swal.fire(
          //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_start_date_swal_title'],
          //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_start_date_swal_text'],
          //               "error"
          //             )
          //     isTrue = 0;
          //   }
          // }

          // // console.log(this.dateData.end_date+':'+this.dateData.use_end_date);

          // if(this.dateData.end_date == '0000-00-00' && (this.dateData.use_end_date == false || typeof this.dateData.use_end_date == 'undefined')){
          //   // console.log('#6');
          //   Swal.fire(
          //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_end_date_swal_title'],
          //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_end_date_swal_text'],
          //             "error"
          //           )
          //   isTrue = 0;
          // }

          // if(this.methodData.Target_KW == true || this.methodData.Target_AD == true){
          //   let select_keywords_length = 0;
          //   if(this.keywordData.select_keywords != '' && this.keywordData.select_keywords != null && typeof this.keywordData.select_keywords != 'undefined'){
          //     select_keywords_length = this.keywordData.select_keywords.length;
          //   }

          // //  console.log('select_keywords_length');
          // //  console.log(select_keywords_length);

          // //  console.log('this.keywordData.select_keywords');
          // //  console.log(this.keywordData.select_keywords);

          //   if(select_keywords_length > 0 && (this.methodData.Target_KW == true || this.methodData.Target_AD == true)){
          //     let select_keywords_num = 0;

          //     for (var i = 0; i < select_keywords_length; i++) {
          //     //  console.log('this.keywordData.select_keywords['+i+'].checked');
          //     //  console.log(typeof this.keywordData.select_keywords[i].checked);
          //       if(this.keywordData.select_keywords[i].checked == true){
          //         select_keywords_num = parseInt(select_keywords_num) + parseInt(1);
          //       }
          //     }

          //   //  console.log('select_keywords_num');
          //   //  console.log(select_keywords_num);

          //     if(this.methodData.Target_AD == true){
          //       if(select_keywords_num != 4 && select_keywords_num > 0){
          //       //  console.log('Target_AD');
          //         Swal.fire(
          //                 this.showLang[this.selectLang]['views']['Event']['methods']['next']['not_select_keywords_swal_title'],
          //                 this.showLang[this.selectLang]['views']['Event']['methods']['next']['not_ad_select_keywords_swal_text'],
          //                 "error"
          //               )
          //         isTrue = 0;
          //       }
          //     }

          //     if(this.methodData.Target_KW == true){
          //       if(select_keywords_num > 5){
          //       //  console.log('Target_KW');
          //         Swal.fire(
          //                 this.showLang[this.selectLang]['views']['Event']['methods']['next']['not_select_keywords_swal_title'],
          //                 this.showLang[this.selectLang]['views']['Event']['methods']['next']['not_select_keywords_swal_text'],
          //                 "error"
          //               )
          //         isTrue = 0;
          //       }
          //     }
          //   }

          //   if(select_keywords_length == 0 && this.methodData.Target_KW == true){
          //     Swal.fire(
          //             this.showLang[this.selectLang]['views']['Event']['methods']['next']['not_select_keywords_swal_title'],
          //             this.showLang[this.selectLang]['views']['Event']['methods']['next']['not_select_keywords_swal_text'],
          //             "error"
          //           )
          //     isTrue = 0;
          //   }
          // }

          // if(this.methodData.Target_LA == true){
          //   // console.log('#8');
          //   // console.log('this.lookData.default_lookalikes_list');
          //   // console.log(this.lookData.default_lookalikes_list);
          //   // console.log('this.lookData.custom_lookalikes_selected');
          //   // console.log(this.lookData.custom_lookalikes_selected);
          //   // console.log('this.lookData.custom_lookalikes_selected.length');
          //   // console.log(this.lookData.custom_lookalikes_selected.length);
          //   if((this.lookData.default_lookalikes_list != '' && this.lookData.default_lookalikes_list != null && typeof this.lookData.default_lookalikes_list != 'undefined') || (this.lookData.custom_lookalikes_selected != '' && this.lookData.custom_lookalikes_selected != null && typeof this.lookData.custom_lookalikes_selected != 'undefined')){
          //     let lookalikes_num = 0;
          //     if(this.lookData.default_lookalikes_list.length > 0){
          //       for (var i = 0; i < this.lookData.default_lookalikes_list.length; i++) {
          //         // console.log('i1:'+i);
          //         if(this.lookData.default_lookalikes_list[i].checked == true){
          //           lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
          //         }
          //       }
          //     }

          //     if(this.lookData.custom_lookalikes_selected.length > 0){
          //       for (var i = 0; i < this.lookData.custom_lookalikes_selected.length; i++) {
          //         // console.log('i2:'+i);
          //         lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
          //       }
          //     }

          //     if(lookalikes_num != 5){
          //       // console.log('33');
          //       Swal.fire(
          //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_lookalikes_selected_swal_title'],
          //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_lookalikes_selected_swal_text'],
          //               "error"
          //             )
          //       isTrue = 0;
          //     }
          //   } else {
          //     // console.log('44');
          //     Swal.fire(
          //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_lookalikes_selected_swal_title'],
          //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_lookalikes_selected_swal_text'],
          //             "error"
          //           )
          //     isTrue = 0;
          //   }
          // }

          // // console.log('this.goalsData');
          // // console.log(this.goalsData);
          // // console.log('objective_option:'+this.goalsData.objective_option);
          // // console.log('conversion_domain:'+this.goalsData.conversion_domain);
          // // console.log('risk_level:'+this.goalsData.risk_level.code);
          // // console.log('excluded_audiences:'+this.exAudiencesData.excluded_audiences);
          // if(this.goalsData.objective_option == '' || this.goalsData.objective_option == null || typeof this.goalsData.objective_option == 'undefined'){
          //   // console.log('#9');
          //   Swal.fire(
          //           this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_objective_option_swal_title'],
          //           this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_objective_option_swal_text'],
          //           "error"
          //         )
          //   isTrue = 0;
          // }

          // if(this.goalsData.campaign_objective == 'CONVERSIONS' && (this.goalsData.conversion_domain == '' || this.goalsData.conversion_domain == null || typeof this.goalsData.conversion_domain == 'undefined')){
          //   // console.log('#10');
          //   Swal.fire(
          //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_conversion_domain_swal_title'],
          //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_conversion_domain_swal_text'],
          //             "error"
          //           )
          //   isTrue = 0;
          // }

          // ////////////////////////////////////////

          // if(this.methodData.Target_AD == true){
          //   if(this.goalsData.effect == '' || this.goalsData.effect == null || typeof this.goalsData.effect == 'undefined'){
          //     Swal.fire(
          //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_not_effect_swal_title'],
          //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_not_effect_swal_text'],
          //               "error"
          //             )

          //     isTrue = 0;
          //   }

          // //  console.log('this.methodData.Budget_AD_min');
          // //  console.log(this.methodData.Budget_AD_min);
          // //  console.log('typeof this.methodData.Budget_AD_min');
          // //  console.log(typeof this.methodData.Budget_AD_min);
          // //  console.log('this.methodData.Budget_AD_max');
          // //  console.log(this.methodData.Budget_AD_max);
          // //  console.log('typeof this.methodData.Budget_AD_max');
          // //  console.log(typeof this.methodData.Budget_AD_max);

          //   if(this.methodData.Budget_AD_min != '' && this.methodData.Budget_AD_min != null && typeof this.methodData.Budget_AD_min != 'undefined' && this.methodData.Budget_AD_max != '' && this.methodData.Budget_AD_max != null && typeof this.methodData.Budget_AD_max != 'undefined' && parseInt(this.methodData.Budget_AD_min) >= parseInt(this.methodData.Budget_AD_max)){

          //     Swal.fire(
          //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_swal_title'],
          //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_swal_text_1'],
          //               "error"
          //             )

          //     isTrue = 0;
          //   }

          //   if(parseInt(this.methodData.Budget_AD_min) == 0 || this.methodData.Budget_AD_min == '' || this.methodData.Budget_AD_min == null || typeof this.methodData.Budget_AD_min == 'undefined'){
          //     Swal.fire(
          //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_swal_title'],
          //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_swal_text_2'],
          //               "error"
          //             )

          //     isTrue = 0;
          //   }

          //   if(parseInt(this.methodData.Budget_AD_max) == 0 || this.methodData.Budget_AD_max == '' || this.methodData.Budget_AD_max == null || typeof this.methodData.Budget_AD_max == 'undefined'){
          //     Swal.fire(
          //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_swal_title'],
          //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['efficient_ai_swal_text_3'],
          //               "error"
          //             )

          //     isTrue = 0;
          //   }
          // }

          // if((this.goalsData.risk_level.code == 'auto' || this.goalsData.risk_level.code == 'low') && (this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null)){
          //   // console.log('#11');
          //   Swal.fire(
          //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_effect_swal_title'],
          //             this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_effect_swal_text'],
          //             "error"
          //           )

          //   isTrue = 0;
          // }

          // ////////////////////////////////////////

          // if(this.methodData.Target_AD == true){
          //   let _default_Budget_AD_max = Math.trunc(parseInt(this.goalsData.effect) * parseInt(10));
          // //  console.log('_default_Budget_AD_max');
          // //  console.log(_default_Budget_AD_max);
          // //  console.log('this.methodData.Budget_AD_max');
          // //  console.log(this.methodData.Budget_AD_max);
          //   if(_default_Budget_AD_max > this.methodData.Budget_AD_max){
          //     Swal.fire(
          //               '目標成本',
          //               '預算上限要大於目標成本 10 倍。',
          //               "error"
          //             )

          //     isTrue = 0;
          //   }
          // }

          // if(this.exAudiencesData.excluded_audiences != '' && this.exAudiencesData.excluded_audiences != null && typeof this.exAudiencesData.excluded_audiences != 'undefined' ){
          //   // console.log('#12');
          //   let excluded_audiences = this.exAudiencesData.excluded_audiences.length;
          //   // console.log(excluded_audiences);
          //   // console.log(this.exAudiencesData.custom_excluded_audiences_selected.length);
          //   let custom_excluded_audiences_selected_num = 0;
          //   if(this.exAudiencesData.custom_excluded_audiences_selected.length > 0){
          //     for (var i = 0; i >= this.exAudiencesData.custom_excluded_audiences_selected.length; i++) {
          //       if(this.exAudiencesData.custom_excluded_audiences_selected.checked == true){
          //         custom_excluded_audiences_selected_num = parseInt(custom_excluded_audiences_selected_num) + parseInt(1);
          //       }
          //     }
          //   }

          //   let excluded_audiences_num = parseInt(excluded_audiences) + parseInt(custom_excluded_audiences_selected_num);

          //   if(excluded_audiences_num > 10){
          //     Swal.fire(
          //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_excluded_audiences_swal_title'],
          //               this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_excluded_audiences_swal_text'],
          //               "error"
          //             )

          //     isTrue = 0;
          //   }
          // }

          // // let selectArticleLength = 0;
          // // if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
          // //   selectArticleLength = this.postData.select_article.length;
          // // }

          // // let selectCreativesLength = 0;
          // // if(this.postData.select_creatives != '' && this.postData.select_creatives != null && typeof this.postData.select_creatives != 'undefined'){
          // //   selectCreativesLength = this.postData.select_creatives.length;
          // // }

          // // let creativeArrayLength = 0;
          // // if(this.postData.select_creatives_adset_ads != '' && this.postData.select_creatives_adset_ads != null && typeof this.postData.select_creatives_adset_ads != 'undefined'){
          // //   creativeArrayLength = this.postData.select_creatives_adset_ads.length;
          // // }

          // // let numMaterial = parseInt(selectArticleLength) + parseInt(selectCreativesLength) + parseInt(creativeArrayLength);
          // // let _default_Budget_AD_mim = parseInt(numMaterial) * parseInt(this.goalsData.effect);
          // // if(parseInt(this.methodData.Budget_AD_min) < _default_Budget_AD_mim){
          // //   Swal.fire(
          // //             '素材設定',
          // //             '預算下限要大於 '+_default_Budget_AD_mim,
          // //             "error"
          // //           )

          // //   isTrue = 0;
          // // }

          // if(this.isClass == 'y'){
          //   Swal.fire(
          //     this.showLang[this.selectLang]['views']['Event']['methods']['release']['class_check_release_permissions']['swal_title'],
          //     this.showLang[this.selectLang]['views']['Event']['methods']['release']['class_check_release_permissions']['swal_text'],
          //     'warning'
          //   )

          //   isTrue = 0;
          // }

          // console.log('isTrue');
          // console.log(isTrue);

          // if(isTrue == 1){
          //   // console.log('#13');
          //   let member_hash = this.$route.params.id
          //   let adaccount_id = this.$route.params.adaccount_id

          //   axios
          //     .post('https://www.autoturn.net/api/customize/campaign/campaign_member_status.php', Qs.stringify({
          //       s_code: member_hash,
          //       route_type: this.$route.params.type,
          //       active: 'release',
          //     }))
          //     .then((caResponse) => {

          //       if(caResponse.data.status == 'error'){
          //         // console.log('#14');
          //         if(caResponse.data.type == 2){
          //           Swal.fire({
          //             icon: caResponse.data.status,
          //             title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['swal_title'],
          //             text: caResponse.data.info,
          //             showDenyButton: false,
          //             showCancelButton: false,
          //             confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['confirm_button']
          //             // denyButtonText: `Don't save`,
          //           }).then((result) => {
          //             if (result.isConfirmed) {
          //               // Swal.fire('Saved!', '', 'success')
          //               this.allPageLoading = true
          //               window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //             } else if (result.isDenied) {
          //               // Swal.fire('Changes are not saved', '', 'info')
          //               this.allPageLoading = true
          //               window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //             }
          //           })
          //         } else if(caResponse.data.type == 3){
          //           Swal.fire({
          //             icon: caResponse.data.status,
          //             title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['swal_title'],
          //             text: caResponse.data.info,
          //             showDenyButton: false,
          //             showCancelButton: false,
          //             confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['confirm_button']
          //             // denyButtonText: `Don't save`,
          //           }).then((result) => {
          //             if (result.isConfirmed) {
          //               // Swal.fire('Saved!', '', 'success')
          //               this.allPageLoading = true
          //               window.location.href = "https://private.autoturn.net/f/"+member_hash;
          //             } else if (result.isDenied) {
          //               // Swal.fire('Changes are not saved', '', 'info')
          //               this.allPageLoading = true
          //               window.location.href = "https://private.autoturn.net/f/"+member_hash;
          //             }
          //           })
          //         } else {
          //           Swal.fire(
          //                     this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['swal_title'],
          //                     caResponse.data.info,
          //                     caResponse.data.status
          //                   )
          //         }
          //       }

          //       if(caResponse.data.status == 'warning'){
          //         // console.log('#15');
          //         Swal.fire({
          //           icon: 'warning',
          //           title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['swal_title'],
          //           text: caResponse.data.info,
          //           showDenyButton: false,
          //           showCancelButton: false,
          //           confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['confirm_button']
          //           // denyButtonText: `Don't save`,
          //         }).then((result) => {
          //           var daily_keyword_split_budget = this.methodData.Budget_KW;
          //           var daily_demo_budget = this.methodData.Budget_DM;
          //           var budget_addition = this.goalsData.form_addition;

          //           if(this.dateData.start_date != "" && this.dateData.end_date != ""){
          //               var d1 = new Date(this.dateData.start_date);
          //               var d2 = new Date(this.dateData.end_date);
          //               var days = parseInt((d2-d1)/86400000) + parseInt(1);
          //           } else {
          //               var days = 0;
          //           }

          //           var keyword_split_budget = 0;
          //           if(this.methodData.Budget_KW != ''){
          //               keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
          //           }

          //           var demo_budget = 0;
          //           if(this.methodData.Budget_DM != ''){
          //               demo_budget = this.methodData.Budget_DM * days;
          //           }

          //           var _tmp_audience_budget = 0;
          //           var audience_budget = 0;
          //           // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
          //           _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
          //           // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
          //           audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

          //           var _tmp_marketing_again_budget = 0;
          //           var marketing_again_budget = 0;
          //           // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
          //           _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
          //           // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
          //           marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

          //           // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
          //           var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

          //           if(isNaN(html)){
          //               html = '0';
          //           }

          //           this.total_budget = html;

          //           let _tmp_goalsData = this.goalsData;
          //           const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
          //           let _tmp_exAudiencesData = this.exAudiencesData;
          //           const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

          //           // console.log(_tmp_exAudiencesData);

          //           delete _view_goalsData['objective_list'];
          //           delete _view_exAudiencesData['custom_excluded_audiences'];

          //           let formData = {
          //             campaign_id: this.campaign_id,
          //             campaign_name: this.campaign_name,
          //             adaccount_id: this.adaccount_id,
          //             Budget_KW_result: this.Budget_KW_result,
          //             total_budget: this.total_budget,
          //             methodData: this.methodData,
          //             benefitsAndInvestmentData: this.benefitsAndInvestmentData,
          //             dateData: this.dateData,
          //             keywordData: this.keywordData,
          //             lookData: this.lookData,
          //             audiencesData: this.audiencesData,
          //             goalsData: _view_goalsData,
          //             regionsData: this.regionsData,
          //             selectCountries: this.selectCountries,
          //             selectLangs: this.selectLangs,
          //             exAudiencesData: _view_exAudiencesData,
          //             pdData: this.pdData,
          //             idData: this.idData,
          //             postData: this.postData,
          //             adMaterialData: this.adMaterialDataNew
          //           }

          //           let adaccount_id = this.adaccount_id

          //           if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
          //             // console.log('#1');
          //             let materialType = 0;
          //             let selectArticleLength = 0;
          //             if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
          //               selectArticleLength = this.postData.select_article.length;
          //             }

          //             let selectCreativesMessageLength = 0;
          //             if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
          //               selectCreativesMessageLength = this.postData.select_creatives_message.length;
          //             }

          //             let selectCreativesAdsetAdsMessageLength = 0;
          //             if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
          //               selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
          //             }

          //             let creativeArrayLength = 0;
          //             if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
          //               creativeArrayLength = this.adMaterialDataNew.creative_array.length;
          //             }

          //             if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
          //               materialType = 1;
          //             } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
          //               materialType = 2;
          //             }

          //           //  console.log('#3 materialType:'+materialType);

          //             if(materialType == 0){
          //               // console.log('#2');
          //               let message_sr_i = 0;
          //               let form_sr_i = 0;
          //               let message = 0;
          //               let single_object_spec = 0;
          //               let single_title = 0;
          //               let materials_item = 0;
          //               let materials_object_spec = 0;
          //               let materials_title = 0;
          //               let ad_name = 0;

          //               for(let i = 0; i < this.adMaterialDataNew.creative_array.length; i++){
          //                 if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
          //                   ad_name = 1;
          //                 }

          //                 if(this.adMaterialDataNew.creative_array[i].type == 2){
          //                   let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

          //                   if(materials_length < 2){
          //                     materials_item = 1;
          //                   } else {
          //                     for(let j = 0; j < materials_length; j++){
          //                       if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
          //                         materials_object_spec = 1;
          //                       }

          //                       if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
          //                         materials_title = 1;
          //                       }
          //                     }
          //                   }
          //                 }

          //                 if(this.adMaterialDataNew.creative_array[i].type == 1){
          //                   if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
          //                     single_object_spec = 1;
          //                   }

          //                   if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
          //                     single_title = 1;
          //                   }
          //                 }

          //                 if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
          //                   message = 1;
          //                 }

          //                 if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
          //                   form_sr_i = 1;
          //                 }

          //                 if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
          //                   message_sr_i = 1;
          //                 }
          //               }

          //               if(ad_name == 1){
          //                 Swal.fire(
          //                             this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
          //                             this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_ad_name_swal_text'],
          //                             "error"
          //                           )
          //               } else if(single_object_spec == 1){
          //                 Swal.fire(
          //                             this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
          //                             this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_single_object_spec_swal_text'],
          //                             "error"
          //                           )
          //               } else if(single_title == 1){
          //                 Swal.fire(
          //                             this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
          //                             this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_single_title_swal_text'],
          //                             "error"
          //                           )
          //               } else if(materials_item == 1){
          //                 Swal.fire(
          //                             this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
          //                             this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_item_swal_text'],
          //                             "error"
          //                           )
          //               } else if(materials_object_spec == 1){
          //                 Swal.fire(
          //                             this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
          //                             this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_object_spec_swal_text'],
          //                             "error"
          //                           )
          //               } else if(materials_title == 1){
          //                 Swal.fire(
          //                             this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
          //                             this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_title_swal_text'],
          //                             "error"
          //                           )
          //               } else if(message == 1){
          //                 Swal.fire(
          //                             this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
          //                             this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_message_swal_text'],
          //                             "error"
          //                           )
          //               } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
          //                 Swal.fire(
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_form_sr_i_swal_text'],
          //                           "error"
          //                         )
          //               } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
          //                 Swal.fire(
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_message_sr_i_swal_text'],
          //                           "error"
          //                         )
          //               } else {
          //                 // console.log('#5');
          //                 axios
          //                   .post('https://www.autoturn.net/api/customize/data/campaign_update.php', Qs.stringify({
          //                     s_code: this.$route.params.id,
          //                     form_data: formData,
          //                     type: 'release',
          //                     target: 'edit_release_'+this.target,
          //                   }))
          //                   .then((response) => {
          //                     // console.log(response.data);
          //                     if(response.data.status == 'success'){
          //                       // console.log('#16');
          //                       // this.immediateList = response.data.return_data
          //                       // this.formData = response.data.return_data.form

          //                       if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
          //                         let name = this.campaign_name;
          //                         let currency = this.currencyData.currency;
          //                         let addition = this.goalsData.form_addition;
          //                         let daily_budget = this.methodData.daily_budget;
          //                         // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
          //                         // if(addition == '' || addition == 0){
          //                         //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
          //                         // }

          //                         let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
          //                         if(this.methodData.Target_AD == true){
          //                           addition_text = '';
          //                         }
          //                         let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
          //                         let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
          //                         if(this.dateData.end_date != '0000-00-00'){
          //                           two_week_budget = this.total_budget;
          //                           campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
          //                         }

          //                         Swal.fire({
          //                           // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
          //                           title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_title'],
          //                           html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_c'],
          //                           icon: 'warning',
          //                           showCancelButton: true,
          //                           confirmButtonColor: '#3085d6',
          //                           cancelButtonColor: '#d33',
          //                           confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['yes_button'],
          //                           cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['no_button'],
          //                         }).then((result) => {
          //                           if (result.isConfirmed) {
          //                             // console.log(this.$route.params.id);

          //                             this.releaseType = true
          //                             this.style = 'z-index:100;';
          //                             this.releasePercent = 5;
          //                             let status = 1;
          //                             let num = 0;
          //                             let member_hash = this.$route.params.id;
          //                             var bar5 = new ldBar("#myItem5");
          //                             bar5.set(this.releasePercent);

          //                             axios
          //                               .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
          //                                 s_code: member_hash,
          //                                 campaign_id: this.campaign_id,
          //                               }))
          //                               .then((caResponse) => {
          //                                 // console.log('caResponse:'+caResponse.data.return_data);
          //                                 if(caResponse.data.status == 'success'){
          //                                   // console.log('#17');
          //                                   //進行進度條
          //                                   // console.log('發佈莞成，開始跑進度條');
          //                                   setInterval( () => {
          //                                     num++;
          //                                     if(num < 1200){
          //                                       // console.log('num:'+num);
          //                                       // console.log(this.releaseType);

          //                                       if(this.releaseType == true){
          //                                         axios
          //                                           .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
          //                                             s_code: member_hash,
          //                                             adaccount_id: this.adaccount_id,
          //                                             campaign_id: this.campaign_id,
          //                                           }))
          //                                           .then((csResponse) => {
          //                                             // console.log('csResponse:'+csResponse.data.return_data);
          //                                             //進行進度條
          //                                             if(status == 1){
          //                                               if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
          //                                                 this.releaseType = false
          //                                                 this.style = 'z-index:-1;';
          //                                                 bar5.set(0);
          //                                                 status = 0;
          //                                                 // Swal.fire({
          //                                                 //   icon: 'error',
          //                                                 //   title: '正式發佈',
          //                                                 //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
          //                                                 //   showDenyButton: false,
          //                                                 //   showCancelButton: false,
          //                                                 //   confirmButtonText: '確定',
          //                                                 //   timer: 5000
          //                                                 //   // denyButtonText: `Don't save`,
          //                                                 // }).then((result) => {
          //                                                 //   /* Read more about isConfirmed, isDenied below */
          //                                                 //   if (result.isConfirmed) {
          //                                                 //     // Swal.fire('Saved!', '', 'success')
          //                                                 //     this.allPageLoading = true
          //                                                 //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                 //   } else if (result.isDenied) {
          //                                                 //     // Swal.fire('Changes are not saved', '', 'info')
          //                                                 //     this.allPageLoading = true
          //                                                 //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                 //   }

          //                                                 //   if (result.dismiss === Swal.DismissReason.timer) {
          //                                                 //     this.allPageLoading = true
          //                                                 //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                 //   }
          //                                                 // })
          //                                                 Swal.fire({
          //                                                   icon: 'error',
          //                                                   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
          //                                                   text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
          //                                                   showDenyButton: false,
          //                                                   showCancelButton: false,
          //                                                   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
          //                                                 }).then((result) => {

          //                                                 })
          //                                               } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
          //                                                 status = 0;

          //                                                 axios
          //                                                   .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
          //                                                     s_code: member_hash,
          //                                                     id: this.campaign_id,
          //                                                   }))
          //                                                   .then((response) => {
          //                                                     axios
          //                                                       .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
          //                                                       .then((csResponse) => {
          //                                                         this.releaseType = false

          //                                                         Swal.fire({
          //                                                           icon: 'success',
          //                                                           title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
          //                                                           text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
          //                                                           showDenyButton: false,
          //                                                           showCancelButton: false,
          //                                                           confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
          //                                                           timer: 5000
          //                                                           // denyButtonText: `Don't save`,
          //                                                         }).then((result) => {
          //                                                           /* Read more about isConfirmed, isDenied below */
          //                                                           if (result.isConfirmed) {
          //                                                             // Swal.fire('Saved!', '', 'success')
          //                                                             this.allPageLoading = true
          //                                                             window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                           } else if (result.isDenied) {
          //                                                             // Swal.fire('Changes are not saved', '', 'info')
          //                                                             this.allPageLoading = true
          //                                                             window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                           }

          //                                                           if (result.dismiss === Swal.DismissReason.timer) {
          //                                                             this.allPageLoading = true
          //                                                             window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                           }
          //                                                         })
          //                                                       });
          //                                                   });
          //                                               } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
          //                                                 this.releaseType = false
          //                                                 this.style = 'z-index:-1;';
          //                                                 bar5.set(0);
          //                                                 status = 0;
          //                                                 // Swal.fire({
          //                                                 //   icon: 'error',
          //                                                 //   title: '正式發佈',
          //                                                 //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
          //                                                 //   showDenyButton: false,
          //                                                 //   showCancelButton: false,
          //                                                 //   confirmButtonText: '確定',
          //                                                 //   timer: 5000
          //                                                 //   // denyButtonText: `Don't save`,
          //                                                 // }).then((result) => {
          //                                                 //   /* Read more about isConfirmed, isDenied below */
          //                                                 //   if (result.isConfirmed) {
          //                                                 //     // Swal.fire('Saved!', '', 'success')
          //                                                 //     this.allPageLoading = true
          //                                                 //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                 //   } else if (result.isDenied) {
          //                                                 //     // Swal.fire('Changes are not saved', '', 'info')
          //                                                 //     this.allPageLoading = true
          //                                                 //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                 //   }

          //                                                 //   if (result.dismiss === Swal.DismissReason.timer) {
          //                                                 //     this.allPageLoading = true
          //                                                 //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                 //   }
          //                                                 // })
          //                                                 Swal.fire({
          //                                                   icon: 'error',
          //                                                   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
          //                                                   text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
          //                                                   showDenyButton: false,
          //                                                   showCancelButton: false,
          //                                                   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
          //                                                 }).then((result) => {

          //                                                 })
          //                                               } else {
          //                                                 this.releaseText = csResponse.data.return_data.info_text
          //                                                 this.releasePercent = csResponse.data.return_data.info_pct

          //                                                 bar5.set(this.releasePercent);
          //                                                 // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
          //                                                 // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
          //                                                 // console.log('this.releaseText:'+this.releaseText);
          //                                                 // console.log('this.releasePercent:'+this.releasePercent);

          //                                                 if(csResponse.data.return_data.info_pct == 100){
          //                                                   this.releaseType = false
          //                                                   this.style = 'z-index:-1;';
          //                                                   bar5.set(0);
          //                                                   status = 0;
          //                                                 }
          //                                               }
          //                                             }
          //                                           });
          //                                       }
          //                                     } else {
          //                                       Swal.fire({
          //                                         icon: 'warning',
          //                                         title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['else']['swal_title'],
          //                                         text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['else']['swal_html'],
          //                                         showDenyButton: false,
          //                                         showCancelButton: false,
          //                                         confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
          //                                         timer: 1000
          //                                         // denyButtonText: `Don't save`,
          //                                       }).then((result) => {
          //                                         /* Read more about isConfirmed, isDenied below */
          //                                         if (result.isConfirmed) {
          //                                           // Swal.fire('Saved!', '', 'success')
          //                                           this.allPageLoading = true
          //                                           window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                         } else if (result.isDenied) {
          //                                           // Swal.fire('Changes are not saved', '', 'info')
          //                                           this.allPageLoading = true
          //                                           window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                         }

          //                                         if (result.dismiss === Swal.DismissReason.timer) {
          //                                           this.allPageLoading = true
          //                                           window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                         }
          //                                       })
          //                                     }
          //                                   }, 3000);
          //                                 }
          //                               });
          //                           }
          //                         })
          //                       } else {
          //                         Swal.fire(
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['not_success']['swal_title'],
          //                           response.data.info,
          //                           'error'
          //                         )
          //                       }

          //                       // if(type == 1){
          //                       //   var todayForm = new Date();
          //                       //   var yearForm = todayForm.getFullYear();
          //                       //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
          //                       //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
          //                       //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

          //                       //   todayForm = yearForm + monthForm + dateForm + timeForm;

          //                       //   this.formTitle = 'title_'+todayForm;
          //                       // } else {
          //                       //   this.formTitle = response.data.return_data.name;
          //                       // }

          //                       // this.showModal = true
          //                     } else {
          //                       let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_default_swal_text'];
          //                       if(response.data.info != '' && response.data.info != null){
          //                         text = response.data.info
          //                       }
          //                       Swal.fire(
          //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_swal_title'],
          //                         text,
          //                         'error'
          //                       )
          //                     }
          //                   });
          //               }
          //             } else {
          //             //  console.log('#33');
          //               Swal.fire(
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_creative_array_swal_title'],
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_creative_array_swal_text'],
          //                           "error"
          //                         )
          //             }
          //           } else {
          //             axios
          //               .post('https://www.autoturn.net/api/customize/data/campaign_update.php', Qs.stringify({
          //                 s_code: this.$route.params.id,
          //                 form_data: formData,
          //                 type: 'release',
          //                 target: 'edit_release_'+this.target,
          //               }))
          //               .then((response) => {
          //                 // console.log(response.data);
          //                 if(response.data.status == 'success'){
          //                   // console.log('#16');
          //                   // this.immediateList = response.data.return_data
          //                   // this.formData = response.data.return_data.form

          //                   if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
          //                     let name = this.campaign_name;
          //                     let currency = this.currencyData.currency;
          //                     let addition = this.goalsData.form_addition;
          //                     let daily_budget = this.methodData.daily_budget;
          //                     // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
          //                     // if(addition == '' || addition == 0){
          //                     //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
          //                     // }

          //                     let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
          //                     if(this.methodData.Target_AD == true){
          //                       addition_text = '';
          //                     }
          //                     let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
          //                     let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
          //                     if(this.dateData.end_date != '0000-00-00'){
          //                       two_week_budget = this.total_budget;
          //                       campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
          //                     }

          //                     Swal.fire({
          //                       // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
          //                       title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_title'],
          //                       html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
          //                       icon: 'warning',
          //                       showCancelButton: true,
          //                       confirmButtonColor: '#3085d6',
          //                       cancelButtonColor: '#d33',
          //                       confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['yes_button'],
          //                       cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['no_button'],
          //                     }).then((result) => {
          //                       if (result.isConfirmed) {
          //                         // console.log(this.$route.params.id);

          //                         this.releaseType = true
          //                         this.style = 'z-index:100;';
          //                         this.releasePercent = 5;
          //                         let status = 1;
          //                         let num = 0;
          //                         let member_hash = this.$route.params.id;
          //                         var bar5 = new ldBar("#myItem5");
          //                         bar5.set(this.releasePercent);

          //                         axios
          //                           .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
          //                             s_code: member_hash,
          //                             campaign_id: this.campaign_id,
          //                           }))
          //                           .then((caResponse) => {
          //                             // console.log('caResponse:'+caResponse.data.return_data);
          //                             if(caResponse.data.status == 'success'){
          //                               // console.log('#17');
          //                               //進行進度條
          //                               // console.log('發佈莞成，開始跑進度條');
          //                               setInterval( () => {
          //                                 num++;
          //                                 if(num < 1200){
          //                                   // console.log('num:'+num);
          //                                   // console.log(this.releaseType);

          //                                   if(this.releaseType == true){
          //                                     axios
          //                                       .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
          //                                         s_code: member_hash,
          //                                         adaccount_id: this.adaccount_id,
          //                                         campaign_id: this.campaign_id,
          //                                       }))
          //                                       .then((csResponse) => {
          //                                         // console.log('csResponse:'+csResponse.data.return_data);
          //                                         //進行進度條
          //                                         if(status == 1){
          //                                           if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
          //                                             this.releaseType = false
          //                                             this.style = 'z-index:-1;';
          //                                             bar5.set(0);
          //                                             status = 0;
          //                                             // Swal.fire({
          //                                             //   icon: 'error',
          //                                             //   title: '正式發佈',
          //                                             //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
          //                                             //   showDenyButton: false,
          //                                             //   showCancelButton: false,
          //                                             //   confirmButtonText: '確定',
          //                                             //   timer: 5000
          //                                             //   // denyButtonText: `Don't save`,
          //                                             // }).then((result) => {
          //                                             //   /* Read more about isConfirmed, isDenied below */
          //                                             //   if (result.isConfirmed) {
          //                                             //     // Swal.fire('Saved!', '', 'success')
          //                                             //     this.allPageLoading = true
          //                                             //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                             //   } else if (result.isDenied) {
          //                                             //     // Swal.fire('Changes are not saved', '', 'info')
          //                                             //     this.allPageLoading = true
          //                                             //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                             //   }

          //                                             //   if (result.dismiss === Swal.DismissReason.timer) {
          //                                             //     this.allPageLoading = true
          //                                             //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                             //   }
          //                                             // })
          //                                             Swal.fire({
          //                                               icon: 'error',
          //                                               title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
          //                                               text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
          //                                               showDenyButton: false,
          //                                               showCancelButton: false,
          //                                               confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
          //                                             }).then((result) => {

          //                                             })
          //                                           } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
          //                                             status = 0;

          //                                             axios
          //                                               .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
          //                                                 s_code: member_hash,
          //                                                 id: this.campaign_id,
          //                                               }))
          //                                               .then((response) => {
          //                                                 axios
          //                                                   .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
          //                                                   .then((csResponse) => {
          //                                                     this.releaseType = false

          //                                                     Swal.fire({
          //                                                       icon: 'success',
          //                                                       title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
          //                                                       text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
          //                                                       showDenyButton: false,
          //                                                       showCancelButton: false,
          //                                                       confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
          //                                                       timer: 5000
          //                                                       // denyButtonText: `Don't save`,
          //                                                     }).then((result) => {
          //                                                       /* Read more about isConfirmed, isDenied below */
          //                                                       if (result.isConfirmed) {
          //                                                         // Swal.fire('Saved!', '', 'success')
          //                                                         this.allPageLoading = true
          //                                                         window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                       } else if (result.isDenied) {
          //                                                         // Swal.fire('Changes are not saved', '', 'info')
          //                                                         this.allPageLoading = true
          //                                                         window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                       }

          //                                                       if (result.dismiss === Swal.DismissReason.timer) {
          //                                                         this.allPageLoading = true
          //                                                         window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                       }
          //                                                     })
          //                                                   });
          //                                               });
          //                                           } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
          //                                             this.releaseType = false
          //                                             this.style = 'z-index:-1;';
          //                                             bar5.set(0);
          //                                             status = 0;
          //                                             // Swal.fire({
          //                                             //   icon: 'error',
          //                                             //   title: '正式發佈',
          //                                             //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
          //                                             //   showDenyButton: false,
          //                                             //   showCancelButton: false,
          //                                             //   confirmButtonText: '確定',
          //                                             //   timer: 5000
          //                                             //   // denyButtonText: `Don't save`,
          //                                             // }).then((result) => {
          //                                             //   /* Read more about isConfirmed, isDenied below */
          //                                             //   if (result.isConfirmed) {
          //                                             //     // Swal.fire('Saved!', '', 'success')
          //                                             //     this.allPageLoading = true
          //                                             //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                             //   } else if (result.isDenied) {
          //                                             //     // Swal.fire('Changes are not saved', '', 'info')
          //                                             //     this.allPageLoading = true
          //                                             //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                             //   }

          //                                             //   if (result.dismiss === Swal.DismissReason.timer) {
          //                                             //     this.allPageLoading = true
          //                                             //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                             //   }
          //                                             // })
          //                                             Swal.fire({
          //                                               icon: 'error',
          //                                               title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
          //                                               text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
          //                                               showDenyButton: false,
          //                                               showCancelButton: false,
          //                                               confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
          //                                             }).then((result) => {

          //                                             })
          //                                           } else {
          //                                             this.releaseText = csResponse.data.return_data.info_text
          //                                             this.releasePercent = csResponse.data.return_data.info_pct

          //                                             bar5.set(this.releasePercent);
          //                                             // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
          //                                             // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
          //                                             // console.log('this.releaseText:'+this.releaseText);
          //                                             // console.log('this.releasePercent:'+this.releasePercent);

          //                                             if(csResponse.data.return_data.info_pct == 100){
          //                                               this.releaseType = false
          //                                               this.style = 'z-index:-1;';
          //                                               bar5.set(0);
          //                                               status = 0;
          //                                             }
          //                                           }
          //                                         }
          //                                       });
          //                                   }
          //                                 } else {
          //                                   Swal.fire({
          //                                     icon: 'warning',
          //                                     title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
          //                                     text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
          //                                     showDenyButton: false,
          //                                     showCancelButton: false,
          //                                     confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
          //                                     timer: 1000
          //                                     // denyButtonText: `Don't save`,
          //                                   }).then((result) => {
          //                                     /* Read more about isConfirmed, isDenied below */
          //                                     if (result.isConfirmed) {
          //                                       // Swal.fire('Saved!', '', 'success')
          //                                       this.allPageLoading = true
          //                                       window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                     } else if (result.isDenied) {
          //                                       // Swal.fire('Changes are not saved', '', 'info')
          //                                       this.allPageLoading = true
          //                                       window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                     }

          //                                     if (result.dismiss === Swal.DismissReason.timer) {
          //                                       this.allPageLoading = true
          //                                       window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                     }
          //                                   })
          //                                 }
          //                               }, 3000);
          //                             }
          //                           });
          //                       }
          //                     })
          //                   } else {
          //                     Swal.fire(
          //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
          //                       response.data.info,
          //                       'error'
          //                     )
          //                   }

          //                   // if(type == 1){
          //                   //   var todayForm = new Date();
          //                   //   var yearForm = todayForm.getFullYear();
          //                   //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
          //                   //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
          //                   //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

          //                   //   todayForm = yearForm + monthForm + dateForm + timeForm;

          //                   //   this.formTitle = 'title_'+todayForm;
          //                   // } else {
          //                   //   this.formTitle = response.data.return_data.name;
          //                   // }

          //                   // this.showModal = true
          //                 } else {
          //                   let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['update_not_success_default_swal_text'];
          //                   if(response.data.info != '' && response.data.info != null){
          //                     text = response.data.info
          //                   }
          //                   Swal.fire(
          //                     this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['update_not_success_swal_title'],
          //                     text,
          //                     'error'
          //                   )
          //                 }
          //               });
          //           }
          //         });
          //       }

          //       if(caResponse.data.status == 'success'){
          //         // console.log('#18');
          //         var daily_keyword_split_budget = this.methodData.Budget_KW;
          //         var daily_demo_budget = this.methodData.Budget_DM;
          //         var budget_addition = this.goalsData.form_addition;

          //         if(this.dateData.start_date != "" && this.dateData.end_date != ""){
          //             var d1 = new Date(this.dateData.start_date);
          //             var d2 = new Date(this.dateData.end_date);
          //             var days = parseInt((d2-d1)/86400000) + parseInt(1);
          //         } else {
          //             var days = 0;
          //         }

          //         var keyword_split_budget = 0;
          //         if(this.methodData.Budget_KW != ''){
          //             keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
          //         }

          //         var demo_budget = 0;
          //         if(this.methodData.Budget_DM != ''){
          //             demo_budget = this.methodData.Budget_DM * days;
          //         }

          //         var _tmp_audience_budget = 0;
          //         var audience_budget = 0;
          //         // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
          //         _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
          //         // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
          //         audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

          //         var _tmp_marketing_again_budget = 0;
          //         var marketing_again_budget = 0;
          //         // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
          //         _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
          //         // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
          //         marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

          //         // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
          //         var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

          //         if(isNaN(html)){
          //             html = '0';
          //         }

          //         this.total_budget = html;

          //         let _tmp_goalsData = this.goalsData;
          //         const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
          //         let _tmp_exAudiencesData = this.exAudiencesData;
          //         const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

          //         // console.log(_tmp_exAudiencesData);

          //         delete _view_goalsData['objective_list'];
          //         delete _view_exAudiencesData['custom_excluded_audiences'];

          //         let formData = {
          //           campaign_id: this.campaign_id,
          //           campaign_name: this.campaign_name,
          //           adaccount_id: this.adaccount_id,
          //           Budget_KW_result: this.Budget_KW_result,
          //           total_budget: this.total_budget,
          //           methodData: this.methodData,
          //           benefitsAndInvestmentData: this.benefitsAndInvestmentData,
          //           dateData: this.dateData,
          //           keywordData: this.keywordData,
          //           lookData: this.lookData,
          //           audiencesData: this.audiencesData,
          //           goalsData: _view_goalsData,
          //           regionsData: this.regionsData,
          //           selectCountries: this.selectCountries,
          //           selectLangs: this.selectLangs,
          //           exAudiencesData: _view_exAudiencesData,
          //           pdData: this.pdData,
          //           idData: this.idData,
          //           postData: this.postData,
          //           adMaterialData: this.adMaterialDataNew
          //         }

          //         let adaccount_id = this.adaccount_id

          //         if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
          //           // console.log('#1');
          //           let materialType = 0;
          //           let selectArticleLength = 0;

          //         //  console.log('this.postData');
          //         //  console.log(this.postData);
          //         //  console.log('this.adMaterialDataNew');
          //         //  console.log(this.adMaterialDataNew);

          //         //  console.log('b this.postData.select_article');
          //         //  console.log(this.postData.select_article);
          //         //  console.log('b this.postData.select_creatives_message');
          //         //  console.log(this.postData.select_creatives_message);
          //         //  console.log('b this.postData.select_creatives_adset_ads_message');
          //         //  console.log(this.postData.select_creatives_adset_ads_message);
          //         //  console.log('b this.adMaterialDataNew.creative_array');
          //         //  console.log(this.adMaterialDataNew.creative_array);

          //           if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
          //             selectArticleLength = this.postData.select_article.length;
          //           }

          //           let selectCreativesMessageLength = 0;
          //           if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
          //             selectCreativesMessageLength = this.postData.select_creatives_message.length;
          //           }

          //           let selectCreativesAdsetAdsMessageLength = 0;
          //           if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
          //             selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
          //           }

          //           let creativeArrayLength = 0;
          //           if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
          //             creativeArrayLength = this.adMaterialDataNew.creative_array.length;
          //           }

          //         //  console.log('a selectArticleLength');
          //         //  console.log(selectArticleLength);
          //         //  console.log('a selectCreativesMessageLength');
          //         //  console.log(selectCreativesMessageLength);
          //         //  console.log('a selectCreativesAdsetAdsMessageLength');
          //         //  console.log(selectCreativesAdsetAdsMessageLength);
          //         //  console.log('a creativeArrayLength');
          //         //  console.log(creativeArrayLength);
          //         //  console.log('a this.goalsData.campaign_objective');
          //         //  console.log(this.goalsData.campaign_objective);

          //           if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
          //             materialType = 1;
          //           } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
          //             materialType = 2;
          //           }

          //         //  console.log('this.postData.select_article');
          //         //  console.log(this.postData.select_article);
          //         //  console.log('this.postData.select_creatives_message');
          //         //  console.log(this.postData.select_creatives_message);
          //         //  console.log('this.adMaterialDataNew.creative_array');
          //         //  console.log(this.adMaterialDataNew.creative_array);
          //         //  console.log('this.goalsData.campaign_objective');
          //         //  console.log(this.goalsData.campaign_objective);
          //         //  console.log(selectArticleLength +' == 0 && '+ selectCreativesMessageLength +' == 0 && '+ creativeArrayLength +' == 0');

          //         //  console.log('#4 materialType:'+materialType);

          //           if(materialType == 0){
          //             // console.log('#2');
          //             let message_sr_i = 0;
          //             let form_sr_i = 0;
          //             let message = 0;
          //             let single_object_spec = 0;
          //             let single_title = 0;
          //             let materials_item = 0;
          //             let materials_object_spec = 0;
          //             let materials_title = 0;
          //             let ad_name = 0;

          //             for(let i = 0; i < this.adMaterialDataNew.creative_array.length; i++){
          //               if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
          //                 ad_name = 1;
          //               }

          //               if(this.adMaterialDataNew.creative_array[i].type == 2){
          //                 let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

          //                 if(materials_length < 2){
          //                   materials_item = 1;
          //                 } else {
          //                   for(let j = 0; j < materials_length; j++){
          //                     if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
          //                       materials_object_spec = 1;
          //                     }

          //                     if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
          //                       materials_title = 1;
          //                     }
          //                   }
          //                 }
          //               }

          //               if(this.adMaterialDataNew.creative_array[i].type == 1){
          //                 if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
          //                   single_object_spec = 1;
          //                 }

          //                 if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
          //                   single_title = 1;
          //                 }
          //               }

          //               if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
          //                 message = 1;
          //               }

          //               if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
          //                 form_sr_i = 1;
          //               }

          //               if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
          //                 message_sr_i = 1;
          //               }
          //             }

          //             if(ad_name == 1){
          //               Swal.fire(
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_ad_name_swal_text'],
          //                           "error"
          //                         )
          //             } else if(single_object_spec == 1){
          //               Swal.fire(
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_single_object_spec_swal_text'],
          //                           "error"
          //                         )
          //             } else if(single_title == 1){
          //               Swal.fire(
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_single_title_swal_text'],
          //                           "error"
          //                         )
          //             } else if(materials_item == 1){
          //               Swal.fire(
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_item_swal_text'],
          //                           "error"
          //                         )
          //             } else if(materials_object_spec == 1){
          //               Swal.fire(
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_object_spec_swal_text'],
          //                           "error"
          //                         )
          //             } else if(materials_title == 1){
          //               Swal.fire(
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_title_swal_text'],
          //                           "error"
          //                         )
          //             } else if(message == 1){
          //               Swal.fire(
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
          //                           this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_message_swal_text'],
          //                           "error"
          //                         )
          //             } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
          //               Swal.fire(
          //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
          //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_form_sr_i_swal_text'],
          //                         "error"
          //                       )
          //             } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
          //               Swal.fire(
          //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
          //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_message_sr_i_swal_text'],
          //                         "error"
          //                       )
          //             } else {
          //               // console.log('#5');
          //               axios
          //                 .post('https://www.autoturn.net/api/customize/data/campaign_update.php', Qs.stringify({
          //                   s_code: this.$route.params.id,
          //                   form_data: formData,
          //                   type: 'release',
          //                   target: 'edit_release_'+this.target,
          //                 }))
          //                 .then((response) => {
          //                   // console.log(response.data);
          //                   if(response.data.status == 'success'){
          //                     // console.log('#19');
          //                     // this.immediateList = response.data.return_data
          //                     // this.formData = response.data.return_data.form

          //                     if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
          //                       let name = this.campaign_name;
          //                       let currency = this.currencyData.currency;
          //                       let addition = this.goalsData.form_addition;
          //                       let daily_budget = this.methodData.daily_budget;
          //                       // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
          //                       // if(addition == '' || addition == 0){
          //                       //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
          //                       // }

          //                       let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['addition_text']+'<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
          //                       if(this.methodData.Target_AD == true){
          //                         addition_text = '';
          //                       }
          //                       let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
          //                       let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
          //                       if(this.dateData.end_date != '0000-00-00'){
          //                         two_week_budget = this.total_budget;
          //                         campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
          //                       }

          //                       Swal.fire({
          //                         // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
          //                         title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_title'],
          //                         html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_c'],
          //                         icon: 'warning',
          //                         showCancelButton: true,
          //                         confirmButtonColor: '#3085d6',
          //                         cancelButtonColor: '#d33',
          //                         confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['yes_button'],
          //                         cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['no_button'],
          //                       }).then((result) => {
          //                         if (result.isConfirmed) {
          //                           // console.log(this.$route.params.id);

          //                           this.releaseType = true
          //                           this.style = 'z-index:100;';
          //                           this.releasePercent = 5;
          //                           let status = 1;
          //                           let num = 0;
          //                           let member_hash = this.$route.params.id;
          //                           var bar5 = new ldBar("#myItem5");
          //                           bar5.set(this.releasePercent);

          //                           axios
          //                             .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
          //                               s_code: member_hash,
          //                               campaign_id: this.campaign_id,
          //                             }))
          //                             .then((caResponse) => {
          //                               // console.log('caResponse:'+caResponse.data.return_data);
          //                               if(caResponse.data.status == 'success'){
          //                                 // console.log('#20');
          //                                 //進行進度條
          //                                 // console.log('發佈莞成，開始跑進度條');
          //                                 setInterval( () => {
          //                                   num++;
          //                                   if(num < 1200){
          //                                     // console.log('num:'+num);
          //                                     // console.log(this.releaseType);

          //                                     if(this.releaseType == true){
          //                                       axios
          //                                         .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
          //                                           s_code: member_hash,
          //                                           adaccount_id: this.adaccount_id,
          //                                           campaign_id: this.campaign_id,
          //                                         }))
          //                                         .then((csResponse) => {
          //                                           // console.log('csResponse:'+csResponse.data.return_data);
          //                                           //進行進度條
          //                                           if(status == 1){
          //                                             if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
          //                                               this.releaseType = false
          //                                               this.style = 'z-index:-1;';
          //                                               bar5.set(0);
          //                                               status = 0;
          //                                               // Swal.fire({
          //                                               //   icon: 'error',
          //                                               //   title: '正式發佈',
          //                                               //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
          //                                               //   showDenyButton: false,
          //                                               //   showCancelButton: false,
          //                                               //   confirmButtonText: '確定',
          //                                               //   timer: 5000
          //                                               //   // denyButtonText: `Don't save`,
          //                                               // }).then((result) => {
          //                                               //   /* Read more about isConfirmed, isDenied below */
          //                                               //   if (result.isConfirmed) {
          //                                               //     // Swal.fire('Saved!', '', 'success')
          //                                               //     this.allPageLoading = true
          //                                               //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                               //   } else if (result.isDenied) {
          //                                               //     // Swal.fire('Changes are not saved', '', 'info')
          //                                               //     this.allPageLoading = true
          //                                               //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                               //   }

          //                                               //   if (result.dismiss === Swal.DismissReason.timer) {
          //                                               //     this.allPageLoading = true
          //                                               //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                               //   }
          //                                               // })
          //                                               Swal.fire({
          //                                                 icon: 'error',
          //                                                 title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
          //                                                 text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
          //                                                 showDenyButton: false,
          //                                                 showCancelButton: false,
          //                                                 confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
          //                                               }).then((result) => {
          //                                               //  console.log('#1');
          //                                                 let info_text = csResponse.data.return_data.info_text;
          //                                                 let tosStatus = info_text.includes("/leadgen/tos");
          //                                                 if(tosStatus == true){
          //                                                   window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
          //                                                 }
          //                                               })
          //                                             } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
          //                                               status = 0;

          //                                               axios
          //                                                 .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
          //                                                   s_code: member_hash,
          //                                                   id: this.campaign_id,
          //                                                 }))
          //                                                 .then((response) => {
          //                                                   axios
          //                                                     .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
          //                                                     .then((csResponse) => {
          //                                                       this.releaseType = false

          //                                                       Swal.fire({
          //                                                         icon: 'success',
          //                                                         title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
          //                                                         text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
          //                                                         showDenyButton: false,
          //                                                         showCancelButton: false,
          //                                                         confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
          //                                                         timer: 5000
          //                                                         // denyButtonText: `Don't save`,
          //                                                       }).then((result) => {
          //                                                         /* Read more about isConfirmed, isDenied below */
          //                                                         if (result.isConfirmed) {
          //                                                           // Swal.fire('Saved!', '', 'success')
          //                                                           this.allPageLoading = true
          //                                                           window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                         } else if (result.isDenied) {
          //                                                           // Swal.fire('Changes are not saved', '', 'info')
          //                                                           this.allPageLoading = true
          //                                                           window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                         }

          //                                                         if (result.dismiss === Swal.DismissReason.timer) {
          //                                                           this.allPageLoading = true
          //                                                           window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                         }
          //                                                       })
          //                                                     });
          //                                                 });
          //                                             } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
          //                                               this.releaseType = false
          //                                               this.style = 'z-index:-1;';
          //                                               bar5.set(0);
          //                                               status = 0;
          //                                               // Swal.fire({
          //                                               //   icon: 'error',
          //                                               //   title: '正式發佈',
          //                                               //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
          //                                               //   showDenyButton: false,
          //                                               //   showCancelButton: false,
          //                                               //   confirmButtonText: '確定',
          //                                               //   timer: 5000
          //                                               //   // denyButtonText: `Don't save`,
          //                                               // }).then((result) => {
          //                                               //   /* Read more about isConfirmed, isDenied below */
          //                                               //   if (result.isConfirmed) {
          //                                               //     // Swal.fire('Saved!', '', 'success')
          //                                               //     this.allPageLoading = true
          //                                               //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                               //   } else if (result.isDenied) {
          //                                               //     // Swal.fire('Changes are not saved', '', 'info')
          //                                               //     this.allPageLoading = true
          //                                               //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                               //   }

          //                                               //   if (result.dismiss === Swal.DismissReason.timer) {
          //                                               //     this.allPageLoading = true
          //                                               //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                               //   }
          //                                               // })
          //                                               Swal.fire({
          //                                                 icon: 'error',
          //                                                 title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
          //                                                 text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
          //                                                 showDenyButton: false,
          //                                                 showCancelButton: false,
          //                                                 confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
          //                                               }).then((result) => {
          //                                               //  console.log('#2');
          //                                                 let info_text = csResponse.data.return_data.info_text;
          //                                                 let tosStatus = info_text.includes("/leadgen/tos");
          //                                                 if(tosStatus == true){
          //                                                   window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
          //                                                 }
          //                                               })
          //                                             } else {
          //                                               this.releaseText = csResponse.data.return_data.info_text
          //                                               this.releasePercent = csResponse.data.return_data.info_pct

          //                                               bar5.set(this.releasePercent);
          //                                               // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
          //                                               // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
          //                                               // console.log('this.releaseText:'+this.releaseText);
          //                                               // console.log('this.releasePercent:'+this.releasePercent);

          //                                               if(csResponse.data.return_data.info_pct == 100){
          //                                                 this.releaseType = false
          //                                                 this.style = 'z-index:-1;';
          //                                                 bar5.set(0);
          //                                                 status = 0;
          //                                               }
          //                                             }
          //                                           }
          //                                         });
          //                                     }
          //                                   } else {
          //                                     Swal.fire({
          //                                       icon: 'warning',
          //                                       title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_title'],
          //                                       text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_html'],
          //                                       showDenyButton: false,
          //                                       showCancelButton: false,
          //                                       confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
          //                                       timer: 1000
          //                                       // denyButtonText: `Don't save`,
          //                                     }).then((result) => {
          //                                       /* Read more about isConfirmed, isDenied below */
          //                                       if (result.isConfirmed) {
          //                                         // Swal.fire('Saved!', '', 'success')
          //                                         this.allPageLoading = true
          //                                         window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                       } else if (result.isDenied) {
          //                                         // Swal.fire('Changes are not saved', '', 'info')
          //                                         this.allPageLoading = true
          //                                         window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                       }

          //                                       if (result.dismiss === Swal.DismissReason.timer) {
          //                                         this.allPageLoading = true
          //                                         window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                       }
          //                                     })
          //                                   }
          //                                 }, 3000);
          //                               }
          //                             });
          //                         }
          //                       })
          //                     } else {
          //                       Swal.fire(
          //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['not_success']['swal_title'],
          //                         response.data.info,
          //                         'error'
          //                       )
          //                     }

          //                     // if(type == 1){
          //                     //   var todayForm = new Date();
          //                     //   var yearForm = todayForm.getFullYear();
          //                     //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
          //                     //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
          //                     //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

          //                     //   todayForm = yearForm + monthForm + dateForm + timeForm;

          //                     //   this.formTitle = 'title_'+todayForm;
          //                     // } else {
          //                     //   this.formTitle = response.data.return_data.name;
          //                     // }

          //                     // this.showModal = true
          //                   } else {
          //                     let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['update_not_success_default_swal_text'];
          //                     if(response.data.info != '' && response.data.info != null){
          //                       text = response.data.info
          //                     }
          //                     Swal.fire(
          //                       this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['update_not_success_swal_title'],
          //                       text,
          //                       'error'
          //                     )
          //                   }
          //                 });
          //             }
          //           } else {
          //           //  console.log('#34');
          //             Swal.fire(
          //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_creative_array_swal_title'],
          //                         this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_creative_array_swal_text'],
          //                         "error"
          //                       )
          //           }
          //         } else {
          //           axios
          //             .post('https://www.autoturn.net/api/customize/data/campaign_update.php', Qs.stringify({
          //               s_code: this.$route.params.id,
          //               form_data: formData,
          //               type: 'release',
          //               target: 'edit_release_'+this.target,
          //             }))
          //             .then((response) => {
          //               // console.log(response.data);
          //               if(response.data.status == 'success'){
          //                 // console.log('#19');
          //                 // this.immediateList = response.data.return_data
          //                 // this.formData = response.data.return_data.form

          //                 if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
          //                   let name = this.campaign_name;
          //                   let currency = this.currencyData.currency;
          //                   let addition = this.goalsData.form_addition;
          //                   let daily_budget = this.methodData.daily_budget;
          //                   // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
          //                   // if(addition == '' || addition == 0){
          //                   //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
          //                   // }

          //                   let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
          //                   if(this.methodData.Target_AD == true){
          //                     addition_text = '';
          //                   }
          //                   let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
          //                   let campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
          //                   if(this.dateData.end_date != '0000-00-00'){
          //                     two_week_budget = this.total_budget;
          //                     campaignInfo = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
          //                   }

          //                   Swal.fire({
          //                     // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
          //                     title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_title'],
          //                     html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
          //                     icon: 'warning',
          //                     showCancelButton: true,
          //                     confirmButtonColor: '#3085d6',
          //                     cancelButtonColor: '#d33',
          //                     confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['yes_button'],
          //                     cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['no_button'],
          //                   }).then((result) => {
          //                     if (result.isConfirmed) {
          //                       // console.log(this.$route.params.id);

          //                       this.releaseType = true
          //                       this.style = 'z-index:100;';
          //                       this.releasePercent = 5;
          //                       let status = 1;
          //                       let num = 0;
          //                       let member_hash = this.$route.params.id;
          //                       var bar5 = new ldBar("#myItem5");
          //                       bar5.set(this.releasePercent);

          //                       axios
          //                         .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
          //                           s_code: member_hash,
          //                           campaign_id: this.campaign_id,
          //                         }))
          //                         .then((caResponse) => {
          //                           // console.log('caResponse:'+caResponse.data.return_data);
          //                           if(caResponse.data.status == 'success'){
          //                             // console.log('#20');
          //                             //進行進度條
          //                             // console.log('發佈莞成，開始跑進度條');
          //                             setInterval( () => {
          //                               num++;
          //                               if(num < 1200){
          //                                 // console.log('num:'+num);
          //                                 // console.log(this.releaseType);

          //                                 if(this.releaseType == true){
          //                                   axios
          //                                     .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
          //                                       s_code: member_hash,
          //                                       adaccount_id: this.adaccount_id,
          //                                       campaign_id: this.campaign_id,
          //                                     }))
          //                                     .then((csResponse) => {
          //                                       // console.log('csResponse:'+csResponse.data.return_data);
          //                                       //進行進度條
          //                                       if(status == 1){
          //                                         if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
          //                                           this.releaseType = false
          //                                           this.style = 'z-index:-1;';
          //                                           bar5.set(0);
          //                                           status = 0;
          //                                           // Swal.fire({
          //                                           //   icon: 'error',
          //                                           //   title: '正式發佈',
          //                                           //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
          //                                           //   showDenyButton: false,
          //                                           //   showCancelButton: false,
          //                                           //   confirmButtonText: '確定',
          //                                           //   timer: 5000
          //                                           //   // denyButtonText: `Don't save`,
          //                                           // }).then((result) => {
          //                                           //   /* Read more about isConfirmed, isDenied below */
          //                                           //   if (result.isConfirmed) {
          //                                           //     // Swal.fire('Saved!', '', 'success')
          //                                           //     this.allPageLoading = true
          //                                           //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                           //   } else if (result.isDenied) {
          //                                           //     // Swal.fire('Changes are not saved', '', 'info')
          //                                           //     this.allPageLoading = true
          //                                           //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                           //   }

          //                                           //   if (result.dismiss === Swal.DismissReason.timer) {
          //                                           //     this.allPageLoading = true
          //                                           //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                           //   }
          //                                           // })
          //                                           Swal.fire({
          //                                             icon: 'error',
          //                                             title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
          //                                             text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
          //                                             showDenyButton: false,
          //                                             showCancelButton: false,
          //                                             confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
          //                                           }).then((result) => {
          //                                           //  console.log('#3');
          //                                             let info_text = csResponse.data.return_data.info_text;
          //                                             let tosStatus = info_text.includes("/leadgen/tos");
          //                                             if(tosStatus == true){
          //                                               window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
          //                                             }
          //                                           })
          //                                         } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
          //                                           status = 0;

          //                                           axios
          //                                             .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
          //                                               s_code: member_hash,
          //                                               id: this.campaign_id,
          //                                             }))
          //                                             .then((response) => {
          //                                               axios
          //                                                 .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
          //                                                 .then((csResponse) => {
          //                                                   this.releaseType = false

          //                                                   Swal.fire({
          //                                                     icon: 'success',
          //                                                     title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
          //                                                     text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
          //                                                     showDenyButton: false,
          //                                                     showCancelButton: false,
          //                                                     confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
          //                                                     timer: 5000
          //                                                     // denyButtonText: `Don't save`,
          //                                                   }).then((result) => {
          //                                                     /* Read more about isConfirmed, isDenied below */
          //                                                     if (result.isConfirmed) {
          //                                                       // Swal.fire('Saved!', '', 'success')
          //                                                       this.allPageLoading = true
          //                                                       window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                     } else if (result.isDenied) {
          //                                                       // Swal.fire('Changes are not saved', '', 'info')
          //                                                       this.allPageLoading = true
          //                                                       window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                     }

          //                                                     if (result.dismiss === Swal.DismissReason.timer) {
          //                                                       this.allPageLoading = true
          //                                                       window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                                     }
          //                                                   })
          //                                                 });
          //                                             });
          //                                         } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
          //                                           this.releaseType = false
          //                                           this.style = 'z-index:-1;';
          //                                           bar5.set(0);
          //                                           status = 0;
          //                                           // Swal.fire({
          //                                           //   icon: 'error',
          //                                           //   title: '正式發佈',
          //                                           //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
          //                                           //   showDenyButton: false,
          //                                           //   showCancelButton: false,
          //                                           //   confirmButtonText: '確定',
          //                                           //   timer: 5000
          //                                           //   // denyButtonText: `Don't save`,
          //                                           // }).then((result) => {
          //                                           //   /* Read more about isConfirmed, isDenied below */
          //                                           //   if (result.isConfirmed) {
          //                                           //     // Swal.fire('Saved!', '', 'success')
          //                                           //     this.allPageLoading = true
          //                                           //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                           //   } else if (result.isDenied) {
          //                                           //     // Swal.fire('Changes are not saved', '', 'info')
          //                                           //     this.allPageLoading = true
          //                                           //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                           //   }

          //                                           //   if (result.dismiss === Swal.DismissReason.timer) {
          //                                           //     this.allPageLoading = true
          //                                           //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                           //   }
          //                                           // })
          //                                           Swal.fire({
          //                                             icon: 'error',
          //                                             title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
          //                                             text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
          //                                             showDenyButton: false,
          //                                             showCancelButton: false,
          //                                             confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
          //                                           }).then((result) => {
          //                                           //  console.log('#4');
          //                                             let info_text = csResponse.data.return_data.info_text;
          //                                             let tosStatus = info_text.includes("/leadgen/tos");
          //                                             if(tosStatus == true){
          //                                               window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
          //                                             }
          //                                           })
          //                                         } else {
          //                                           this.releaseText = csResponse.data.return_data.info_text
          //                                           this.releasePercent = csResponse.data.return_data.info_pct

          //                                           bar5.set(this.releasePercent);
          //                                           // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
          //                                           // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
          //                                           // console.log('this.releaseText:'+this.releaseText);
          //                                           // console.log('this.releasePercent:'+this.releasePercent);

          //                                           if(csResponse.data.return_data.info_pct == 100){
          //                                             this.releaseType = false
          //                                             this.style = 'z-index:-1;';
          //                                             bar5.set(0);
          //                                             status = 0;
          //                                           }
          //                                         }
          //                                       }
          //                                     });
          //                                 }
          //                               } else {
          //                                 Swal.fire({
          //                                   icon: 'warning',
          //                                   title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
          //                                   text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
          //                                   showDenyButton: false,
          //                                   showCancelButton: false,
          //                                   confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
          //                                   timer: 1000
          //                                   // denyButtonText: `Don't save`,
          //                                 }).then((result) => {
          //                                   /* Read more about isConfirmed, isDenied below */
          //                                   if (result.isConfirmed) {
          //                                     // Swal.fire('Saved!', '', 'success')
          //                                     this.allPageLoading = true
          //                                     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                   } else if (result.isDenied) {
          //                                     // Swal.fire('Changes are not saved', '', 'info')
          //                                     this.allPageLoading = true
          //                                     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                   }

          //                                   if (result.dismiss === Swal.DismissReason.timer) {
          //                                     this.allPageLoading = true
          //                                     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
          //                                   }
          //                                 })
          //                               }
          //                             }, 3000);
          //                           }
          //                         });
          //                     }
          //                   })
          //                 } else {
          //                   Swal.fire(
          //                     this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
          //                     response.data.info,
          //                     'error'
          //                   )
          //                 }

          //                 // if(type == 1){
          //                 //   var todayForm = new Date();
          //                 //   var yearForm = todayForm.getFullYear();
          //                 //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
          //                 //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
          //                 //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

          //                 //   todayForm = yearForm + monthForm + dateForm + timeForm;

          //                 //   this.formTitle = 'title_'+todayForm;
          //                 // } else {
          //                 //   this.formTitle = response.data.return_data.name;
          //                 // }

          //                 // this.showModal = true
          //               } else {
          //                 let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['update_not_success_default_swal_text'];
          //                 if(response.data.info != '' && response.data.info != null){
          //                   text = response.data.info
          //                 }
          //                 Swal.fire(
          //                   this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['update_not_success_swal_title'],
          //                   text,
          //                   'error'
          //                 )
          //               }
          //             });
          //         }
          //       }

          //       if(caResponse.data.status == 'login'){
          //         Swal.fire({
          //           icon: 'error',
          //           title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['login']['swal_title'],
          //           text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['login']['swal_text'],
          //           showDenyButton: false,
          //           showCancelButton: false,
          //           confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['login']['confirm_button']
          //           // denyButtonText: `Don't save`,
          //         }).then((result) => {
          //           /* Read more about isConfirmed, isDenied below */
          //           if (result.isConfirmed) {
          //             // Swal.fire('Saved!', '', 'success')
          //             // this.allPageLoading = true
          //             window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
          //           } else if (result.isDenied) {
          //             // Swal.fire('Changes are not saved', '', 'info')
          //             // this.allPageLoading = true
          //             window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
          //           }
          //         })
          //       }
          //     });
          // }
        }
      },
      methodName(value){
        switch(value){
          case 'META_TEST':
            return '測試素材（Facebook）';
            break;
          case 'META_KW':
            return '精準興趣（Facebook）';
            break;
          case 'META_LA':
            return '類似受眾（Facebook）';
            break;
          case 'META_RT':
            return '再行銷（Facebook）';
            break;
          case 'META_ASC':
            return 'ASC（Facebook）';
            break;
          case 'TIKTOK_KW':
            return '精準興趣（Tiktok）';
            break;
          case 'TIKTOK_RT':
            return '再行銷（Tiktok）';
            break;
        }
      },
      objectiveName(value){
        switch(value){
          case 'CONVERSIONS':
            return '轉換次數';
            break;
          case 'LINK_CLICKS':
            return '流量';
            break;
          case 'POST_ENGAGEMENT':
            return '互動';
            break;
          case 'VIDEO_VIEWS':
            return '觀看影片';
            break;
          case 'LEAD_GENERATION':
            return '開發潛在顧客';
            break;
          case 'MESSAGES':
            return '發送訊息';
            break;
          case 'PRODUCT_CATALOG_SALES':
            return '目錄銷售';
            break;
          case 'WEB_CONVERSIONS':
            return '轉換次數';
            break;
        }
      },
      validateConditions(data) {
        if (!data) return false;

        if (data.filters && Array.isArray(data.filters)) {
          const allValid = data.filters.every((filter) => this.validateConditions(filter));
          return allValid; // 統一返回 true 或 false

          // if (data.operator === "AND") {
          // //  console.log('results.every((res) => res === true)', results.every((res) => res === true));
          //   return results.every((res) => res === true);
          // } else if (data.operator === "OR") {
          // //  console.log('results.some((res) => res === true)', results.some((res) => res === true));
          //   return results.some((res) => res === true);
          // }
        }

        // 檢查單一條件的 value
        if (data.value === null || data.value === undefined || data.value === "") {
          return false;
        }

      //  console.log('validateConditions end');
        return true;
      },
      async customizeTreeSave() {
        if (!validateRegulatedCountries(this.benefitsAndInvestmentData, this.selectLang)) return
        // 暫存結果用
        const resultData = [];
        const resultStrategyData = [];

        if(this.nextLoading == false){
          this.nextLoading = true;
          this.showCampaignData = false;

          try {
            // 遍歷 stageTreeContent，每個 group 處理

            let _tmpStageTreeContentLength = this.stageTreeContent.length;
            let _stageData = [];
            let _stageStrategyData = [];
            let _tableData = [];
            const promises = [];
            let isTrue = 0;

            for (const group of this.stageTreeContent) {
              const groupResult = [];
              const groupStrategyResult = [];

            //  console.log("處理新的一組資料開始");

              // 遍歷每個 group 的 item
              for (const [index, item] of group.entries()) {
                isTrue = 1;
                let _swalTitle = '';
                let _swalText = '';
                let stageName = this.methodName(item.method);

                let onCheck = 1;
                if(this.stageTreeHaveTest === true){
                  if(item.method == 'META_KW' || item.method == 'META_LA' || item.method == 'META_RT' || item.method == 'META_ASC'){
                    onCheck = 0;
                  }
                }

                if(onCheck == 1){
                  //有測試階段時，精準興趣、類似受眾、再行銷、ASC不用檢查目標、素材
                  let _tmpCampaignObjective = item.goalsData.campaign_objective;
                  if(_tmpCampaignObjective == '' || _tmpCampaignObjective == null || typeof _tmpCampaignObjective == 'undefined'){
                    isTrue = 0;

                    _swalTitle = '自定義規則-'+stageName+'-目標';
                    _swalText = '請勾選任一項目標。';
                  }

                  let _tmpDbSelectArticleLength = item.postData.db_select_article.length;
                  let _tmpDbSelectCreativesLength = item.postData.db_select_creatives.length;
                  let _tmpDbSelectCreativesAdsetAdsLength = item.postData.db_select_creatives_adset_ads.length;
                  let _tmpDbSelectCreativesAdsetAdsMessageLength = item.postData.db_select_creatives_adset_ads_message.length;
                  let _tmpDbSelectCreativesMessageLength = item.postData.db_select_creatives_message.length;
                  let dataDbLength = _tmpDbSelectArticleLength + _tmpDbSelectCreativesLength + _tmpDbSelectCreativesAdsetAdsLength + _tmpDbSelectCreativesAdsetAdsMessageLength + _tmpDbSelectCreativesMessageLength;

                  let _tmpSelectArticleLength = item.postData.select_article.length;
                  let _tmpSelectCreativesLength = item.postData.select_creatives.length;
                  let _tmpSelectCreativesAdsetAdsLength = item.postData.select_creatives_adset_ads.length;
                  let _tmpSelectCreativesAdsetAdsMessageLength = item.postData.select_creatives_adset_ads_message.length;
                  let _tmpSelectCreativesMessageLength = item.postData.select_creatives_message.length;
                  let dataLength = _tmpSelectArticleLength + _tmpSelectCreativesLength + _tmpSelectCreativesAdsetAdsLength + _tmpSelectCreativesAdsetAdsMessageLength + _tmpSelectCreativesMessageLength;

                  let _tmpCreativeArrayLength = item.adMaterialData.creative_array.length;

                  if(_tmpCampaignObjective == 'LEAD_GENERATION' || _tmpCampaignObjective == 'MESSAGES' || item.method == 'TIKTOK_KW' || item.method == 'TIKTOK_RT'){
                    dataDbLength = _tmpDbSelectArticleLength + _tmpDbSelectCreativesLength + _tmpDbSelectCreativesAdsetAdsLength + _tmpDbSelectCreativesAdsetAdsMessageLength + _tmpDbSelectCreativesMessageLength + _tmpCreativeArrayLength;

                    dataLength = _tmpSelectArticleLength + _tmpSelectCreativesLength + _tmpSelectCreativesAdsetAdsLength + _tmpSelectCreativesAdsetAdsMessageLength + _tmpSelectCreativesMessageLength + _tmpCreativeArrayLength;
                  }

                //  console.log('_tmpDbSelectArticleLength');
                //  console.log(_tmpDbSelectArticleLength);
                //  console.log('_tmpDbSelectCreativesLength');
                //  console.log(_tmpDbSelectCreativesLength);
                //  console.log('_tmpDbSelectCreativesAdsetAdsLength');
                //  console.log(_tmpDbSelectCreativesAdsetAdsLength);
                //  console.log('_tmpDbSelectCreativesAdsetAdsMessageLength');
                //  console.log(_tmpDbSelectCreativesAdsetAdsMessageLength);
                //  console.log('_tmpDbSelectCreativesMessageLength');
                //  console.log(_tmpDbSelectCreativesMessageLength);
                //  console.log('dataDbLength');
                //  console.log(dataDbLength);

                //  console.log('_tmpSelectArticleLength');
                //  console.log(_tmpSelectArticleLength);
                //  console.log('_tmpSelectCreativesLength');
                //  console.log(_tmpSelectCreativesLength);
                //  console.log('_tmpSelectCreativesAdsetAdsLength');
                //  console.log(_tmpSelectCreativesAdsetAdsLength);
                //  console.log('_tmpSelectCreativesAdsetAdsMessageLength');
                //  console.log(_tmpSelectCreativesAdsetAdsMessageLength);
                //  console.log('_tmpSelectCreativesMessageLength');
                //  console.log(_tmpSelectCreativesMessageLength);
                //  console.log('_tmpCreativeArrayLength');
                //  console.log(_tmpCreativeArrayLength);
                //  console.log('dataLength');
                //  console.log(dataLength);

                  if(dataLength <= 0 && dataDbLength <= 0){
                    isTrue = 0;

                    _swalTitle = '自定義規則-'+stageName+'-素材';
                    _swalText = '請至少設定一組素材。';
                  }

                  if(_tmpCampaignObjective == 'LEAD_GENERATION' || _tmpCampaignObjective == 'MESSAGES'){
                    for(let k = 0; k < _tmpCreativeArrayLength; k++){

                      let _tmpCreativeArrayTitle = item.adMaterialData.creative_array[k].title;
                      if(_tmpCreativeArrayTitle == '' || _tmpCreativeArrayTitle == null || typeof _tmpCreativeArrayTitle == 'undefined'){
                        isTrue = 0;

                        _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                        _swalText = '每組廣告組合，都要輸入廣告名稱。';
                      }

                      let _tmpCreativeArrayType = item.adMaterialData.creative_array[k].type;
                      if(_tmpCreativeArrayType == 2){
                        let materials_length = item.adMaterialData.creative_array[k].materials.length

                        if(materials_length < 2){
                          materials_item = 1;
                        } else {
                          for(let j = 0; j < materials_length; j++){
                            let _tmpCreativeArrayMaterialsObjectSpecId = item.adMaterialData.creative_array[k].materials[j].object_spec.id;
                            if(_tmpCreativeArrayMaterialsObjectSpecId == '' || _tmpCreativeArrayMaterialsObjectSpecId == null || typeof _tmpCreativeArrayMaterialsObjectSpecId == 'undefined'){
                              isTrue = 0;

                              _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                              _swalText = '每組輪播卡片，都要選取素材。';
                            }

                            let _tmpCreativeArrayMaterialsTitle = item.adMaterialData.creative_array[k].materials[j].title;
                            if(_tmpCreativeArrayMaterialsTitle == '' || _tmpCreativeArrayMaterialsTitle == null || typeof _tmpCreativeArrayMaterialsTitle == 'undefined'){
                              isTrue = 0;

                              _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                              _swalText = '每組輪播卡片，都要填寫標題。';
                            }
                          }
                        }
                      }

                      if(_tmpCreativeArrayType == 1){
                        let _tmpCreativeArrayMaterialSingleObjectSpecId = item.adMaterialData.creative_array[k].materialSingle[0].object_spec.id;
                        if(_tmpCreativeArrayMaterialSingleObjectSpecId == '' || _tmpCreativeArrayMaterialSingleObjectSpecId == null || typeof _tmpCreativeArrayMaterialSingleObjectSpecId == 'undefined'){
                          isTrue = 0;

                          _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                          _swalText = '每組廣告組合，都要選取素材。';
                        }

                        let _tmpCreativeArrayMaterialSingleTitle = item.adMaterialData.creative_array[k].materialSingle[0].title;
                        if(_tmpCreativeArrayMaterialSingleTitle == '' || _tmpCreativeArrayMaterialSingleTitle == null || typeof _tmpCreativeArrayMaterialSingleTitle == 'undefined'){
                          isTrue = 0;

                          _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                          _swalText = '每組廣告組合，都要填寫標題。';
                        }
                      }

                      let _tmpCreativeArrayMessage = item.adMaterialData.creative_array[k].message;
                      if(_tmpCreativeArrayMessage == '' || _tmpCreativeArrayMessage == null || typeof _tmpCreativeArrayMessage == 'undefined'){
                        isTrue = 0;

                        _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                        _swalText = '每組廣告組合，都要填寫主要文字。';
                      }

                      let _tmpCreativeArrayFormSrI = item.adMaterialData.creative_array[k].form_sr_i;
                      if(_tmpCampaignObjective == 'LEAD_GENERATION' && (_tmpCreativeArrayFormSrI == '' || _tmpCreativeArrayFormSrI == null || typeof _tmpCreativeArrayFormSrI == 'undefined')){
                        isTrue = 0;

                        _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                        _swalText = '每組廣告組合，都要選取相對應的即時表單。';
                      }

                      let _tmpCreativeArrayMessageSrI = item.adMaterialData.creative_array[k].message_sr_i;
                      if(_tmpCampaignObjective == 'MESSAGES' && (_tmpCreativeArrayMessageSrI == '' || _tmpCreativeArrayMessageSrI == null || typeof _tmpCreativeArrayMessageSrI == 'undefined')){
                        isTrue = 0;

                        _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                        _swalText = '每組廣告組合，都要選取相對應的訊息範本。';
                      }

                      if(isTrue == 0){
                        break;
                      }
                    }
                  }
                }

              //  console.log('item', item);
              //  console.log('item.budgetExtraData.budget_extra_list', item.budgetExtraData.budget_extra_list);
                let _tmpCampaignBudgetExtraListLength = item.budgetExtraData.budget_extra_list.length;
              //  console.log('_tmpCampaignBudgetExtraListLength', _tmpCampaignBudgetExtraListLength);

                for(let b = 0; b < _tmpCampaignBudgetExtraListLength; b++){
                  let _tmpAmount = item.budgetExtraData.budget_extra_list[b].amount;
                  let _tmpTimes = item.budgetExtraData.budget_extra_list[b].times;
                  let _tmpFiltersValueTimes = item.budgetExtraData.budget_extra_list[b].filters[0].value;

                //  console.log('_tmpAmount', _tmpAmount);
                //  console.log('_tmpTimes', _tmpTimes);
                //  console.log('_tmpFiltersValueTimes', _tmpFiltersValueTimes);

                  if ((_tmpAmount != 0 && _tmpAmount != '' && _tmpAmount != null) || (_tmpTimes != 0 && _tmpTimes != '' && _tmpTimes != null) || (_tmpFiltersValueTimes != 0 && _tmpFiltersValueTimes != '' && _tmpFiltersValueTimes != null)) {
                    // 如果至少一個有填寫，檢查另外兩個是否都有填寫
                    if ((_tmpAmount == 0 || _tmpAmount == '' || _tmpAmount == null) || (_tmpTimes == 0 || _tmpTimes == '' || _tmpTimes == null) || (_tmpFiltersValueTimes == 0 || _tmpFiltersValueTimes == '' || _tmpFiltersValueTimes == null)) {
                      isTrue = 0;
                      _swalTitle = '自定義規則-'+stageName+'-預算加碼';
                      _swalText = '若要設定，請同時設定好金額、次數、CPA特定數值';
                    }
                  }
                }

                // let _tmpCampaignAmount = item.budgetExtraData.amount;
                // let _tmpCampaignBudgetExtraList = item.budgetExtraData.budget_extra_list;
                // let _tmpCampaignFrequency = item.budgetExtraData.frequency;

                // console.log('_tmpCampaignAmount');
                // console.log(_tmpCampaignAmount);
                // console.log('_tmpCampaignBudgetExtraList');
                // console.log(_tmpCampaignBudgetExtraList);
                // console.log('_tmpCampaignFrequency');
                // console.log(_tmpCampaignFrequency);

                // if ((_tmpCampaignAmount != 0 && _tmpCampaignAmount != '' && _tmpCampaignAmount != null) || (_tmpCampaignBudgetExtraList[0].num != 0 && _tmpCampaignBudgetExtraList[0].num != '' && _tmpCampaignBudgetExtraList[0].num != null) || (_tmpCampaignFrequency != 0 && _tmpCampaignFrequency != '' && _tmpCampaignFrequency != null)) {
                //   // 如果至少一個有填寫，檢查另外兩個是否都有填寫
                //   if ((_tmpCampaignAmount == 0 || _tmpCampaignAmount == '' || _tmpCampaignAmount == null) || (_tmpCampaignBudgetExtraList[0].num == 0 || _tmpCampaignBudgetExtraList[0].num == '' || _tmpCampaignBudgetExtraList[0].num == null) || (_tmpCampaignFrequency == 0 || _tmpCampaignFrequency == '' || _tmpCampaignFrequency == null)) {
                //     isTrue = 0;
                //     _swalTitle = '自定義規則-'+stageName+'-預算加碼';
                //     _swalText = '若要設定，請同時設定好金額、次數、CPA特定數值';
                //   }
                // }

                let _tmpCampaignPageIdLength = item.pdData.page_id;

                if(_tmpCampaignPageIdLength == '' || _tmpCampaignPageIdLength == null || typeof _tmpCampaignPageIdLength == 'undefined'){
                  isTrue = 0;

                  _swalTitle = '自定義規則-'+stageName+'-Facebook';
                  _swalText = '請選擇Facebook。';
                }

                let _tmpCampaignPublisherPlatformsLength = item.pdData.publisher_platforms.length;

                if(_tmpCampaignPublisherPlatformsLength <= 0){
                  isTrue = 0;

                  _swalTitle = '自定義規則-'+stageName+'-版位與裝置';
                  _swalText = '請至少設定一個平台。';
                }

                let _tmpCampaignDevicePlatformsLength = item.pdData.device_platforms.length;

                if(_tmpCampaignDevicePlatformsLength <= 0){
                  isTrue = 0;

                  _swalTitle = '自定義規則-'+stageName+'-版位與裝置';
                  _swalText = '請至少設定一個裝置。';
                }

                let _tmpCampaignCustomExcludedAudiencesSelectedLength = item.exAudiencesData.custom_excluded_audiences_selected.length;
                let _tmpCampaignDefaultExcludedAudiencesLength = item.exAudiencesData.default_excluded_audiences.length;

                let default_excluded_audiences_num = 0;
                if(_tmpCampaignDefaultExcludedAudiencesLength > 0){
                  for (var e = 0; e < _tmpCampaignDefaultExcludedAudiencesLength; e++) {
                    if(item.exAudiencesData.default_excluded_audiences[e].checked == true){
                      default_excluded_audiences_num = parseInt(default_excluded_audiences_num) + parseInt(1);
                    }
                  }
                }

                let excluded_audiences_num = parseInt(_tmpCampaignCustomExcludedAudiencesSelectedLength) + parseInt(default_excluded_audiences_num);

                if(excluded_audiences_num > 10){
                  isTrue = 0;

                  _swalTitle = '自定義規則-'+stageName+'-關系鏈與受眾';
                  _swalText = '最多只能設定 10 個。';
                }

                let _tmpCampaignLocationsLength = item.localData.locations.length;
                let _tmpCampaignLocationRangeLength = item.localData.location_range.length;

                if((_tmpCampaignLocationsLength == 0 || _tmpCampaignLocationsLength == '' || _tmpCampaignLocationsLength == null || typeof _tmpCampaignLocationsLength == 'undefined') && (_tmpCampaignLocationRangeLength == 0 || _tmpCampaignLocationRangeLength == '' || _tmpCampaignLocationRangeLength == null || typeof _tmpCampaignLocationRangeLength == 'undefined')){
                  isTrue = 0;

                  _swalTitle = '自定義規則-'+stageName+'-地點';
                  _swalText = '請至少設定一個地點。';
                }

                let shopValue = item.stopData.rule_stop;
                // console.log('item', item);
                // console.log('shopValue', shopValue);
                // let shopCheckResult = this.validateConditions(shopValue);
                // console.log('shopCheckResult', shopCheckResult);
                // if (shopCheckResult === false) {
                //   isTrue = 0;
                //   _swalTitle = '自定義規則-'+stageName+'-暫停條件';
                //   _swalText = '請每個規則條件都必須填寫值。';
                // }

                let frequencyValue = item.forwardData.rule_frequency;
                // console.log('item', item);
                // console.log('frequencyValue', frequencyValue);
                // let frequencyCheckResult = this.validateConditions(frequencyValue);
                // console.log('frequencyCheckResult', frequencyCheckResult);
                // if (frequencyCheckResult === false && item.forwardData.showBlock === true) {
                //   isTrue = 0;
                //   _swalTitle = '自定義規則-'+stageName+'-前進規則';
                //   _swalText = '請每個規則條件都必須填寫值。';
                // }

                let _tmpCampaignEffect = item.budgetData.effect;
                if(_tmpCampaignEffect == 0 || _tmpCampaignEffect == '' || _tmpCampaignEffect == null || typeof _tmpCampaignEffect == 'undefined'){
                  isTrue = 0;

                  _swalTitle = '自定義規則-'+stageName+'-目標成本';
                  _swalText = '請填寫目標成本。';
                }

                let _tmpCampaignDailyBudget = item.budgetData.daily_budget;
              //  console.log('_tmpCampaignDailyBudget');
              //  console.log(_tmpCampaignDailyBudget);
                if(_tmpCampaignDailyBudget == 0 || _tmpCampaignDailyBudget == '' || _tmpCampaignDailyBudget == null || typeof _tmpCampaignDailyBudget == 'undefined'){
                  isTrue = 0;

                  _swalTitle = '自定義規則-'+stageName+'-預算';
                  _swalText = '請填寫預算。';
                }

                if(item.method == 'META_KW'){
                  let _tmpKeywordLength = item.keywordData.keywords.length;
                  let select_keywords_num = 0;

                  for (let g = 0; g < _tmpKeywordLength; g++) {
                    if(item.keywordData.keywords[g].checked == true){
                      select_keywords_num = parseInt(select_keywords_num) + parseInt(1);
                    }
                  }

                  if(select_keywords_num != 5){
                    isTrue = 0;

                    _swalTitle = '自定義規則-'+stageName+'-精準興趣廣告組合與關鍵字';
                    _swalText = '關鍵字需選擇 5 個。';
                  }
                }

                if(item.method == 'META_LA'){
                  let _tmpDefaultLookalikesListLength = item.lookData.default_lookalikes_list.length;
                  let lookalikes_num = 0;
                  if(_tmpDefaultLookalikesListLength > 0){
                    for (let l = 0; l < _tmpDefaultLookalikesListLength; l++) {
                      // console.log('i1:'+i);
                      if(item.lookData.default_lookalikes_list[l].checked == true){
                        lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
                      }
                    }
                  }

                  let _tmpCustomLookalikesSelectedLength = item.lookData.custom_lookalikes_selected.length;
                  if(_tmpCustomLookalikesSelectedLength > 0){
                    for (let l = 0; l < _tmpCustomLookalikesSelectedLength; l++) {
                      // console.log('i2:'+i);
                      lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
                    }
                  }

                  if(lookalikes_num != 5){
                    isTrue = 0;

                    _swalTitle = '自定義規則-'+stageName+'-類似受眾廣告組合網址';
                    _swalText = '類似受眾需選擇 5 個。';
                  }
                }

                if(item.method == 'META_RT'){
                  let _tmpDefaultAudiencesListLength = item.audiencesData.default_audiences_list.length;
                  let audiences_num = 0;
                  if(_tmpDefaultAudiencesListLength > 0){
                    for (let r = 0; r < _tmpDefaultAudiencesListLength; r++) {
                      // console.log('i1:'+i);
                      if(item.audiencesData.default_audiences_list[r].checked == true){
                        audiences_num = parseInt(audiences_num) + parseInt(1);
                      }
                    }
                  }

                  let _tmpCustomAudiencesSelectedLength = item.audiencesData.custom_audiences_selected.length;
                  if(_tmpCustomAudiencesSelectedLength > 0){
                    for (let r = 0; r < _tmpCustomAudiencesSelectedLength; r++) {
                      // console.log('i2:'+i);
                      audiences_num = parseInt(audiences_num) + parseInt(1);
                    }
                  }

                  if(audiences_num < 1){
                    isTrue = 0;

                    _swalTitle = '自定義規則-'+stageName+'-再行銷廣告組合';
                    _swalText = '請至少選擇 1 個再行銷受眾。';
                  }
                }

                if(isTrue == 1){
                //  console.log(`開始處理第 ${index + 1} 個項目:`, item);

                  const response = await this.treeSendDataToPHP(item, index, _tmpStageTreeContentLength);
                  if (response && response.data && response.data.campaign_id) {
                    if (item.release && typeof item.release.sr_i !== 'undefined') {
                      item.release.sr_i = response.data.campaign_id;
                      item.release.strategy_id = response.data.strategy_sub_id;
                    //  console.log(`更新 release.sr_i 為: ${response.data.campaign_id}`);
                    //  console.log(`更新 release.strategy_id 為: ${response.data.strategy_sub_id}`);
                    }

                    groupResult.push(parseInt(response.data.campaign_id));
                    groupStrategyResult.push(parseInt(response.data.strategy_sub_id));

                  }
                //  console.log(`第 ${index + 1} 個項目處理完成:`, item);
                } else {
                //  console.log('in error');
                  Swal.fire(
                    _swalTitle,
                    _swalText,
                    "error"
                  );

                  this.nextLoading = false;
                  this.showCampaignData = true;

                  return false;
                }
              }

            //  console.log("該組資料處理完成:", groupResult);
            //  console.log("該組資料處理完成:", groupStrategyResult);

              // 收集每個 group 的結果
              resultData.push(groupResult.length === 1 ? groupResult[0] : groupResult);
              resultStrategyData.push(groupStrategyResult.length === 1 ? groupStrategyResult[0] : groupStrategyResult);
            }

            if(isTrue == 1){
              // 更新最終資料
              this.toSaveTreeData = resultData;
              this.toSaveTreeStrategyData = resultStrategyData;
            //  console.log("全部資料已成功傳送並更新:", this.toSaveTreeData);
            //  console.log("全部資料已成功傳送並更新:", this.toSaveTreeStrategyData);
            //  console.log("全部資料已成功後的this.stageTreeContent:", this.stageTreeContent);

              var daily_keyword_split_budget = this.methodData.Budget_KW;
              var daily_demo_budget = this.methodData.Budget_DM;
              var budget_addition = this.goalsData.form_addition;

              this.total_budget = 0;

              let _tmp_goalsData = this.goalsData;
              const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
              let _tmp_exAudiencesData = this.exAudiencesData;
              const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

              // console.log(_tmp_exAudiencesData);

              delete _view_goalsData['objective_list'];
              delete _view_exAudiencesData['custom_excluded_audiences'];

              let formData = {
                campaign_id: this.campaign_id,
                strategy_id: this.strategyId,
                campaign_name: this.campaign_name,
                adaccount_id: this.adaccount_id,
                Budget_KW_result: this.Budget_KW_result,
                total_budget: this.total_budget,
                dynBudgetData: this.dynBudgetData,
                doForwardData: this.doForwardData,
                methodData: this.methodData,
                benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                dateData: this.dateData,
                keywordData: this.keywordData,
                lookData: this.lookData,
                audiencesData: this.audiencesData,
                goalsData: _view_goalsData,
                regionsData: this.regionsData,
                selectCountries: this.selectCountries,
                selectLangs: this.selectLangs,
                exAudiencesData: _view_exAudiencesData,
                pdData: this.pdData,
                idData: this.idData,
                postData: this.postData,
                adMaterialData: this.adMaterialDataNew,
                stageData: this.toSaveTreeData,
                stageStrategyData: this.toSaveTreeStrategyData,
                saveToStrategy: this.saveToStrategy,
              }

            //  console.log('warning formData');
            //  console.log(formData);

              let adaccount_id = this.adaccount_id

              axios
                .post('https://www.autoturn.net/api/customize/data/campaign_update_of_tree.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  form_data: formData,
                  type: 'release',
                  target: 'edit_release_'+this.target,
                }))
                .then((response) => {
                  this.strategyId = response.data.strategy_id;

                  if(response.data.status == 'success'){
                    if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                      let _tableContent = '<div class="table">\
                                      <div class="row">\
                                        <div class="cell header">階段</div>\
                                        <div class="cell header">目標</div>\
                                        <div class="cell header">預算</div>\
                                      </div>';

                      let _tmpReleaseStageTreeContentLength = this.stageTreeContent.length;
                      let _currency = this.currencyData.currency
                      for(let j = 0; j < _tmpReleaseStageTreeContentLength; j++){
                        let _tmpReleaseStageTreeItemLength = this.stageTreeContent[j].length;
                        if(_tmpReleaseStageTreeItemLength > 1){
                          _tableContent += '<div class="border p-2" style="width:100%;">';
                        } else {
                          _tableContent += '<div class="row border p-2">';
                        }
                        for(let k = 0; k < _tmpReleaseStageTreeItemLength; k++){
                          let _methodName = this.methodName(this.stageTreeContent[j][k].method);
                          let _objectiveName = this.objectiveName(this.stageTreeContent[j][k].goalsData.campaign_objective);
                          let _budget = '<b>'+this.stageTreeContent[j][k].budgetData.daily_budget+'</b><span style="font-size:14px; margin-left:4px; margin-top:4px;">'+_currency+'/day</span>';

                          _tableContent += '<div class="row">\
                                              <div class="cell">'+_methodName+'</div>\
                                              <div class="cell">'+_objectiveName+'</div>\
                                              <div class="cell">'+_budget+'</div>\
                                            </div>';
                        }
                        _tableContent += '</div>';
                      }

                      _tableContent += '</div>';
                      _tableContent += "<b style='color:red;'>請勿在Facebook廣告後台修改行銷活動設定、受眾資料(AutoTurn開頭)，<br/>若修改到系統便會暫停自動化</b><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_c'];

                      Swal.fire({
                        title: '自定義規則 - 發布',
                        html: _tableContent,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        width: 'auto', // 可選：根據內容自動調整寬度
                        padding: '1em',
                        confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['yes_button'],
                        cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['no_button'],
                      }).then((result) => {
                        if (result.isConfirmed) {
                          ////////campaign_release
                          this.releaseType = true
                          this.style = 'z-index:100;';
                          this.releasePercent = 5;
                          let status = 1;
                          let num = 0;
                          let member_hash = this.$route.params.id;
                          var bar5 = new ldBar("#myItem5");
                          bar5.set(this.releasePercent);

                          axios
                            .post('https://www.autoturn.net/api/customize/campaign/campaign_release.php', Qs.stringify({
                              s_code: member_hash,
                              campaign_id: this.campaign_id,
                            }))
                            .then((caResponse) => {
                              // console.log('caResponse:'+caResponse.data.return_data);
                              if(caResponse.data.status == 'success'){
                                // console.log('#20');
                                //進行進度條
                                // console.log('發佈莞成，開始跑進度條');
                                let taskId = caResponse.data.id;

                                setInterval( () => {
                                  num++;
                                  if(num < 1200){
                                    // console.log('num:'+num);
                                    // console.log(this.releaseType);

                                    if(this.releaseType == true){
                                      axios
                                        .post('https://www.autoturn.net/api/customize/campaign/campaign_task.php', Qs.stringify({
                                          s_code: member_hash,
                                          id: taskId,
                                        }))
                                        .then((csResponse) => {
                                          // console.log('csResponse:'+csResponse.data.return_data);
                                          //進行進度條
                                          if(status == 1){
                                            if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                              this.releaseType = false
                                              this.style = 'z-index:-1;';
                                              bar5.set(0);
                                              status = 0;
                                              // Swal.fire({
                                              //   icon: 'error',
                                              //   title: '正式發佈',
                                              //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                              //   showDenyButton: false,
                                              //   showCancelButton: false,
                                              //   confirmButtonText: '確定',
                                              //   timer: 5000
                                              //   // denyButtonText: `Don't save`,
                                              // }).then((result) => {
                                              //   /* Read more about isConfirmed, isDenied below */
                                              //   if (result.isConfirmed) {
                                              //     // Swal.fire('Saved!', '', 'success')
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   } else if (result.isDenied) {
                                              //     // Swal.fire('Changes are not saved', '', 'info')
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   }

                                              //   if (result.dismiss === Swal.DismissReason.timer) {
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   }
                                              // })

                                              let _tableContent = '<br/><div class="return_table">\
                                                              <div class="return_row">\
                                                                <div class="cell_stage return_header">階段名稱</div>\
                                                                <div class="cell_content return_header">發布結果</div>\
                                                              </div>';

                                              for(let j = 0; j < _tmpReleaseStageTreeContentLength; j++){
                                                let _tmpReleaseStageTreeItemLength = this.stageTreeContent[j].length;
                                                if(_tmpReleaseStageTreeItemLength > 1){
                                                  _tableContent += '<div class="border p-2" style="width:100%;">';
                                                } else {
                                                  _tableContent += '<div class="return_row border p-2">';
                                                }
                                                for(let k = 0; k < _tmpReleaseStageTreeItemLength; k++){
                                                  let _methodName = this.methodName(this.stageTreeContent[j][k].method);
                                                  let _releaseContent = csResponse.data.sub_campaigns[this.stageTreeContent[j][k].release.sr_i].current;
                                                  let stageIndex = j;
                                                  let stageTitle = _methodName;

                                                  _tableContent += '<div class="return_row">\
                                                                      <div class="cell_stage">'+stageTitle+'</div>\
                                                                      <div class="cell_content">'+_releaseContent+'</div>\
                                                                    </div>';
                                                }
                                                _tableContent += '</div>';
                                              }

                                              _tableContent += '</div>';

                                              Swal.fire({
                                                icon: 'error',
                                                title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                html: '發布失敗，請參考下列各階段的發布結果，來進行調整：<br/>'+_tableContent,
                                                showDenyButton: false,
                                                showCancelButton: false,
                                                width: 'auto',
                                                padding: '1em',
                                                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                              }).then((result) => {
                                              //  console.log('#1');
                                                let info_text = csResponse.data.return_data.info_text;
                                                let tosStatus = info_text.includes("/leadgen/tos");
                                                if(tosStatus == true){
                                                  window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                                }
                                              })
                                            } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                              status = 0;

                                              let postData = {adaccount_id: this.$route.params.adaccount_id};
                                              let codeHash = ['de', 'di']

                                              const data = new URLSearchParams();
                                              data.append('s_code', this.$route.params.id);
                                              data.append('post_data', JSON.stringify(postData));
                                              data.append('code_hash', JSON.stringify(codeHash));
                                              data.append('update_type', true);

                                              // 發送請求
                                              navigator.sendBeacon(
                                                'https://www.autoturn.net/api/customize/campaign/update_cache.php',
                                                data
                                              );

                                              axios
                                                .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                  s_code: member_hash,
                                                  id: this.campaign_id,
                                                }))
                                                .then((response) => {
                                                  axios
                                                    .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
                                                    .then((csResponse) => {
                                                      this.releaseType = false

                                                      Swal.fire({
                                                        icon: 'success',
                                                        title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                        text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                        showDenyButton: false,
                                                        showCancelButton: false,
                                                        confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                        timer: 5000
                                                        // denyButtonText: `Don't save`,
                                                      }).then((result) => {
                                                        /* Read more about isConfirmed, isDenied below */
                                                        if (result.isConfirmed) {
                                                          // Swal.fire('Saved!', '', 'success')
                                                          this.allPageLoading = true
                                                          window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                                        } else if (result.isDenied) {
                                                          // Swal.fire('Changes are not saved', '', 'info')
                                                          this.allPageLoading = true
                                                          window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                                        }

                                                        if (result.dismiss === Swal.DismissReason.timer) {
                                                          this.allPageLoading = true
                                                          window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                                        }
                                                      })
                                                    });
                                                });
                                            } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                              this.releaseType = false
                                              this.style = 'z-index:-1;';
                                              bar5.set(0);
                                              status = 0;
                                              // Swal.fire({
                                              //   icon: 'error',
                                              //   title: '正式發佈',
                                              //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                              //   showDenyButton: false,
                                              //   showCancelButton: false,
                                              //   confirmButtonText: '確定',
                                              //   timer: 5000
                                              //   // denyButtonText: `Don't save`,
                                              // }).then((result) => {
                                              //   /* Read more about isConfirmed, isDenied below */
                                              //   if (result.isConfirmed) {
                                              //     // Swal.fire('Saved!', '', 'success')
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   } else if (result.isDenied) {
                                              //     // Swal.fire('Changes are not saved', '', 'info')
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   }

                                              //   if (result.dismiss === Swal.DismissReason.timer) {
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   }
                                              // })

                                              let _tableContent = '<br/><div class="return_table">\
                                                              <div class="return_row">\
                                                                <div class="cell_stage return_header">階段名稱</div>\
                                                                <div class="cell_content return_header">發布結果</div>\
                                                              </div>';

                                              for(let j = 0; j < _tmpReleaseStageTreeContentLength; j++){
                                                let _tmpReleaseStageTreeItemLength = this.stageTreeContent[j].length;
                                                if(_tmpReleaseStageTreeItemLength > 1){
                                                  _tableContent += '<div class="border p-2" style="width:100%;">';
                                                } else {
                                                  _tableContent += '<div class="return_row border p-2">';
                                                }
                                                for(let k = 0; k < _tmpReleaseStageTreeItemLength; k++){
                                                  let _methodName = this.methodName(this.stageTreeContent[j][k].method);
                                                  let _releaseContent = csResponse.data.sub_campaigns[this.stageTreeContent[j][k].release.sr_i].current;
                                                  let stageIndex = j;
                                                  let stageTitle = _methodName;

                                                  _tableContent += '<div class="return_row">\
                                                                      <div class="cell_stage">'+stageTitle+'</div>\
                                                                      <div class="cell_content">'+_releaseContent+'</div>\
                                                                    </div>';
                                                }
                                                _tableContent += '</div>';
                                              }

                                              _tableContent += '</div>';

                                              Swal.fire({
                                                icon: 'error',
                                                title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                html: '發布失敗，請參考下列各階段的發布結果，來進行調整：<br/>'+_tableContent,
                                                showDenyButton: false,
                                                showCancelButton: false,
                                                width: 'auto',
                                                padding: '1em',
                                                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                              }).then((result) => {
                                              //  console.log('#2');
                                                let info_text = csResponse.data.return_data.info_text;
                                                let tosStatus = info_text.includes("/leadgen/tos");
                                                if(tosStatus == true){
                                                  window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                                }
                                              })
                                            } else {
                                              this.releaseText = csResponse.data.return_data.current
                                              this.releasePercent = csResponse.data.return_data.pct

                                              bar5.set(this.releasePercent);
                                              // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                              // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                              // console.log('this.releaseText:'+this.releaseText);
                                              // console.log('this.releasePercent:'+this.releasePercent);

                                              if(csResponse.data.return_data.pct == 100){
                                                this.releaseType = false
                                                this.style = 'z-index:-1;';
                                                bar5.set(0);
                                                status = 0;
                                              }
                                            }
                                          }
                                        });
                                    }
                                  } else {
                                    Swal.fire({
                                      icon: 'warning',
                                      title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_title'],
                                      text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_html'],
                                      showDenyButton: false,
                                      showCancelButton: false,
                                      confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                      timer: 1000
                                      // denyButtonText: `Don't save`,
                                    }).then((result) => {
                                      /* Read more about isConfirmed, isDenied below */
                                      if (result.isConfirmed) {
                                        // Swal.fire('Saved!', '', 'success')
                                        this.allPageLoading = true
                                        window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                      } else if (result.isDenied) {
                                        // Swal.fire('Changes are not saved', '', 'info')
                                        this.allPageLoading = true
                                        window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                      }

                                      if (result.dismiss === Swal.DismissReason.timer) {
                                        this.allPageLoading = true
                                        window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                      }
                                    })
                                  }
                                }, 3000);
                              }
                            });
                        }
                      });
                    } else {
                      Swal.fire(
                        this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['not_success']['swal_title'],
                        response.data.info,
                        'error'
                      )
                    }

                  } else {
                    let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_default_swal_text'];
                    if(response.data.info != '' && response.data.info != null){
                      text = response.data.info
                    }
                    Swal.fire(
                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_swal_title'],
                      text,
                      'error'
                    )
                  }

                  this.nextLoading = false;
                  this.showCampaignData = true;
                });
            }
          } catch (error) {
            console.error("傳送資料過程中發生錯誤:", error);
          }
        }
      },

      // 模擬傳送資料到 PHP
      async treeSendDataToPHP(item, index, _tmpStageTreeContentLength) {
        try {
          // 模擬 PHP API 的 URL
          const apiUrl = "https://www.autoturn.net/api/customize/data/campaign_subset_update_of_tree.php";

        //  console.log('treeSendDataToPHP item', item);

          // 將資料轉換為表單格式
          const formData = new URLSearchParams();
          Object.keys(item).forEach((key) => {
            formData.append(key, item[key]);
          });

          // 傳送資料
          // const response = await axios.post(apiUrl, formData, {
          //   headers: {
          //     'Content-Type': 'application/json',
          //   },
          // });

          const response = await axios.post(apiUrl, Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            date: this.dateData,
            stage: index,
            benefitsAndInvestmentData: this.benefitsAndInvestmentData,
            useDoForward: this.doForwardData.useDoForward,
            sub_length: _tmpStageTreeContentLength,
            haveTest: this.customRulesData.haveTest,
            saveToStrategy: this.saveToStrategy,
            campaign_id: this.campaign_id,
            form_data: item,
          }));

        //  console.log('treeSendDataToPHP response', response);

          // 回傳 PHP 的結果 (假設返回結構為 { id: 編號 })
          return response;
        } catch (error) {
          console.error("傳送資料失敗:", error);
          throw error; // 重新拋出錯誤
        }
      },
      async customizeSave(status){
        if (!validateRegulatedCountries(this.benefitsAndInvestmentData, this.selectLang)) return
      //  console.log('customizeSave');
      //  console.log(status);
      //  console.log('this.customRulesData');
      //  console.log(this.customRulesData);

        if(this.nextLoading == false){
          this.nextLoading = true;
          this.showCampaignData = false;

          let _tmpSubCampaignsContentLength = this.customRulesData.subCampaignsContent.length;
          let _stageData = [];
          let _stageStrategyData = [];
          let _tableData = [];
          const promises = [];
          let isTrue = 0;

          for(let i = 0; i < _tmpSubCampaignsContentLength; i++){
            isTrue = 1;
            let _swalTitle = '';
            let _swalText = '';
            let menuIndex = i + parseInt(1);
            let stageName = this.menu[menuIndex].title;

          //  console.log('customize stageName');
          //  console.log(stageName);

            let onCheck = 1;
            if(this.customRulesData.haveTest == true){
              if(this.customRulesData.subCampaignsContent[i].method == 'META_KW' || this.customRulesData.subCampaignsContent[i].method == 'META_LA' || this.customRulesData.subCampaignsContent[i].method == 'META_RT' || this.customRulesData.subCampaignsContent[i].method == 'META_ASC'){
                onCheck = 0;
              }
            }

            if(onCheck == 1){
              //有測試階段時，精準興趣、類似受眾、再行銷、ASC不用檢查目標、素材
              let _tmpCampaignObjective = this.customRulesData.subCampaignsContent[i].goalsData.campaign_objective;
              if(_tmpCampaignObjective == '' || _tmpCampaignObjective == null || typeof _tmpCampaignObjective == 'undefined'){
                isTrue = 0;

                _swalTitle = '自定義規則-'+stageName+'-目標';
                _swalText = '請勾選任一項目標。';
              }

              let _tmpDbSelectArticleLength = this.customRulesData.subCampaignsContent[i].postData.db_select_article.length;
              let _tmpDbSelectCreativesLength = this.customRulesData.subCampaignsContent[i].postData.db_select_creatives.length;
              let _tmpDbSelectCreativesAdsetAdsLength = this.customRulesData.subCampaignsContent[i].postData.db_select_creatives_adset_ads.length;
              let _tmpDbSelectCreativesAdsetAdsMessageLength = this.customRulesData.subCampaignsContent[i].postData.db_select_creatives_adset_ads_message.length;
              let _tmpDbSelectCreativesMessageLength = this.customRulesData.subCampaignsContent[i].postData.db_select_creatives_message.length;
              let dataDbLength = _tmpDbSelectArticleLength + _tmpDbSelectCreativesLength + _tmpDbSelectCreativesAdsetAdsLength + _tmpDbSelectCreativesAdsetAdsMessageLength + _tmpDbSelectCreativesMessageLength;

              let _tmpSelectArticleLength = this.customRulesData.subCampaignsContent[i].postData.select_article.length;
              let _tmpSelectCreativesLength = this.customRulesData.subCampaignsContent[i].postData.select_creatives.length;
              let _tmpSelectCreativesAdsetAdsLength = this.customRulesData.subCampaignsContent[i].postData.select_creatives_adset_ads.length;
              let _tmpSelectCreativesAdsetAdsMessageLength = this.customRulesData.subCampaignsContent[i].postData.select_creatives_adset_ads_message.length;
              let _tmpSelectCreativesMessageLength = this.customRulesData.subCampaignsContent[i].postData.select_creatives_message.length;
              let dataLength = _tmpSelectArticleLength + _tmpSelectCreativesLength + _tmpSelectCreativesAdsetAdsLength + _tmpSelectCreativesAdsetAdsMessageLength + _tmpSelectCreativesMessageLength;

              let _tmpCreativeArrayLength = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array.length;

              if(_tmpCampaignObjective == 'LEAD_GENERATION' || _tmpCampaignObjective == 'MESSAGES' || this.customRulesData.subCampaignsContent[i].method == 'TIKTOK_KW' || this.customRulesData.subCampaignsContent[i].method == 'TIKTOK_RT'){
                dataDbLength = _tmpDbSelectArticleLength + _tmpDbSelectCreativesLength + _tmpDbSelectCreativesAdsetAdsLength + _tmpDbSelectCreativesAdsetAdsMessageLength + _tmpDbSelectCreativesMessageLength + _tmpCreativeArrayLength;

                dataLength = _tmpSelectArticleLength + _tmpSelectCreativesLength + _tmpSelectCreativesAdsetAdsLength + _tmpSelectCreativesAdsetAdsMessageLength + _tmpSelectCreativesMessageLength + _tmpCreativeArrayLength;
              }

            //  console.log('_tmpDbSelectArticleLength');
            //  console.log(_tmpDbSelectArticleLength);
            //  console.log('_tmpDbSelectCreativesLength');
            //  console.log(_tmpDbSelectCreativesLength);
            //  console.log('_tmpDbSelectCreativesAdsetAdsLength');
            //  console.log(_tmpDbSelectCreativesAdsetAdsLength);
            //  console.log('_tmpDbSelectCreativesAdsetAdsMessageLength');
            //  console.log(_tmpDbSelectCreativesAdsetAdsMessageLength);
            //  console.log('_tmpDbSelectCreativesMessageLength');
            //  console.log(_tmpDbSelectCreativesMessageLength);
            //  console.log('dataDbLength');
            //  console.log(dataDbLength);

            //  console.log('_tmpSelectArticleLength');
            //  console.log(_tmpSelectArticleLength);
            //  console.log('_tmpSelectCreativesLength');
            //  console.log(_tmpSelectCreativesLength);
            //  console.log('_tmpSelectCreativesAdsetAdsLength');
            //  console.log(_tmpSelectCreativesAdsetAdsLength);
            //  console.log('_tmpSelectCreativesAdsetAdsMessageLength');
            //  console.log(_tmpSelectCreativesAdsetAdsMessageLength);
            //  console.log('_tmpSelectCreativesMessageLength');
            //  console.log(_tmpSelectCreativesMessageLength);
            //  console.log('_tmpCreativeArrayLength');
            //  console.log(_tmpCreativeArrayLength);
            //  console.log('dataLength');
            //  console.log(dataLength);

              if(dataLength <= 0 && dataDbLength <= 0){
                isTrue = 0;

                _swalTitle = '自定義規則-'+stageName+'-素材';
                _swalText = '請至少設定一組素材。';
              }

              if(_tmpCampaignObjective == 'LEAD_GENERATION' || _tmpCampaignObjective == 'MESSAGES'){
                for(let k = 0; k < _tmpCreativeArrayLength; k++){

                  let _tmpCreativeArrayTitle = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].title;
                  if(_tmpCreativeArrayTitle == '' || _tmpCreativeArrayTitle == null || typeof _tmpCreativeArrayTitle == 'undefined'){
                    isTrue = 0;

                    _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                    _swalText = '每組廣告組合，都要輸入廣告名稱。';
                  }

                  let _tmpCreativeArrayType = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].type;
                  if(_tmpCreativeArrayType == 2){
                    let materials_length = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].materials.length

                    if(materials_length < 2){
                      materials_item = 1;
                    } else {
                      for(let j = 0; j < materials_length; j++){
                        let _tmpCreativeArrayMaterialsObjectSpecId = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].materials[j].object_spec.id;
                        if(_tmpCreativeArrayMaterialsObjectSpecId == '' || _tmpCreativeArrayMaterialsObjectSpecId == null || typeof _tmpCreativeArrayMaterialsObjectSpecId == 'undefined'){
                          isTrue = 0;

                          _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                          _swalText = '每組輪播卡片，都要選取素材。';
                        }

                        let _tmpCreativeArrayMaterialsTitle = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].materials[j].title;
                        if(_tmpCreativeArrayMaterialsTitle == '' || _tmpCreativeArrayMaterialsTitle == null || typeof _tmpCreativeArrayMaterialsTitle == 'undefined'){
                          isTrue = 0;

                          _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                          _swalText = '每組輪播卡片，都要填寫標題。';
                        }
                      }
                    }
                  }

                  if(_tmpCreativeArrayType == 1){
                    let _tmpCreativeArrayMaterialSingleObjectSpecId = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].materialSingle[0].object_spec.id;
                    if(_tmpCreativeArrayMaterialSingleObjectSpecId == '' || _tmpCreativeArrayMaterialSingleObjectSpecId == null || typeof _tmpCreativeArrayMaterialSingleObjectSpecId == 'undefined'){
                      isTrue = 0;

                      _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                      _swalText = '每組廣告組合，都要選取素材。';
                    }

                    let _tmpCreativeArrayMaterialSingleTitle = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].materialSingle[0].title;
                    if(_tmpCreativeArrayMaterialSingleTitle == '' || _tmpCreativeArrayMaterialSingleTitle == null || typeof _tmpCreativeArrayMaterialSingleTitle == 'undefined'){
                      isTrue = 0;

                      _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                      _swalText = '每組廣告組合，都要填寫標題。';
                    }
                  }

                  let _tmpCreativeArrayMessage = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].message;
                  if(_tmpCreativeArrayMessage == '' || _tmpCreativeArrayMessage == null || typeof _tmpCreativeArrayMessage == 'undefined'){
                    isTrue = 0;

                    _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                    _swalText = '每組廣告組合，都要填寫主要文字。';
                  }

                  let _tmpCreativeArrayFormSrI = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].form_sr_i;
                  if(_tmpCampaignObjective == 'LEAD_GENERATION' && (_tmpCreativeArrayFormSrI == '' || _tmpCreativeArrayFormSrI == null || typeof _tmpCreativeArrayFormSrI == 'undefined')){
                    isTrue = 0;

                    _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                    _swalText = '每組廣告組合，都要選取相對應的即時表單。';
                  }

                  let _tmpCreativeArrayMessageSrI = this.customRulesData.subCampaignsContent[i].adMaterialData.creative_array[k].message_sr_i;
                  if(_tmpCampaignObjective == 'MESSAGES' && (_tmpCreativeArrayMessageSrI == '' || _tmpCreativeArrayMessageSrI == null || typeof _tmpCreativeArrayMessageSrI == 'undefined')){
                    isTrue = 0;

                    _swalTitle = '自定義規則-'+stageName+'-素材相關設定';
                    _swalText = '每組廣告組合，都要選取相對應的訊息範本。';
                  }

                  if(isTrue == 0){
                    break;
                  }
                }
              }
            }

            // let _tmpCampaignAmount = this.customRulesData.subCampaignsContent[i].budgetExtraData.amount;
            // let _tmpCampaignBudgetExtraList = this.customRulesData.subCampaignsContent[i].budgetExtraData.budget_extra_list;
            // let _tmpCampaignFrequency = this.customRulesData.subCampaignsContent[i].budgetExtraData.frequency;

            // console.log('_tmpCampaignAmount');
            // console.log(_tmpCampaignAmount);
            // console.log('_tmpCampaignBudgetExtraList');
            // console.log(_tmpCampaignBudgetExtraList);
            // console.log('_tmpCampaignFrequency');
            // console.log(_tmpCampaignFrequency);

            // if ((_tmpCampaignAmount != 0 && _tmpCampaignAmount != '' && _tmpCampaignAmount != null) || (_tmpCampaignBudgetExtraList[0].num != 0 && _tmpCampaignBudgetExtraList[0].num != '' && _tmpCampaignBudgetExtraList[0].num != null) || (_tmpCampaignFrequency != 0 && _tmpCampaignFrequency != '' && _tmpCampaignFrequency != null)) {
            //   // 如果至少一個有填寫，檢查另外兩個是否都有填寫
            //   if ((_tmpCampaignAmount == 0 || _tmpCampaignAmount == '' || _tmpCampaignAmount == null) || (_tmpCampaignBudgetExtraList[0].num == 0 || _tmpCampaignBudgetExtraList[0].num == '' || _tmpCampaignBudgetExtraList[0].num == null) || (_tmpCampaignFrequency == 0 || _tmpCampaignFrequency == '' || _tmpCampaignFrequency == null)) {
            //     isTrue = 0;
            //     _swalTitle = '自定義規則-'+stageName+'-預算加碼';
            //     _swalText = '若要設定，請同時設定好金額、次數、CPA特定數值';
            //   }
            // }

            // let _tmpCampaignBudgetExtraList = this.customRulesData.subCampaignsContent[i].budgetExtraData.budget_extra_list.length;

            // for(let b = 0; b < _tmpCampaignBudgetExtraList; b++){
            //   let _tmpAmount = this.customRulesData.subCampaignsContent[i].budgetExtraData.budget_extra_list[b].amount;
            //   let _tmpTimes = this.customRulesData.subCampaignsContent[i].budgetExtraData.budget_extra_list[b].times;
            //   let _tmpValue = this.customRulesData.subCampaignsContent[i].budgetExtraData.budget_extra_list[b].filters[0].value;

            //   if ((_tmpAmount != 0 && _tmpAmount != '' && _tmpAmount != null) || (_tmpTimes != 0 && _tmpTimes != '' && _tmpTimes != null) || (_tmpValue != 0 && _tmpValue != '' && _tmpValue != null)) {
            //     // 如果至少一個有填寫，檢查另外兩個是否都有填寫
            //     if ((_tmpAmount == 0 || _tmpAmount == '' || _tmpAmount == null) || (_tmpTimes == 0 || _tmpTimes == '' || _tmpTimes == null) || (_tmpValue == 0 || _tmpValue == '' || _tmpValue == null)) {
            //       isTrue = 0;
            //       _swalTitle = '自定義規則-'+stageName+'-預算加碼';
            //       _swalText = '每一組若要設定，請同時設定好金額、次數、CPA特定數值';
            //     }
            //   }
            // }

            let _tmpCampaignPageIdLength = this.customRulesData.subCampaignsContent[i].pdData.page_id;

            if(_tmpCampaignPageIdLength == '' || _tmpCampaignPageIdLength == null || typeof _tmpCampaignPageIdLength == 'undefined'){
              isTrue = 0;

              _swalTitle = '自定義規則-'+stageName+'-Facebook';
              _swalText = '請選擇Facebook。';
            }

            let _tmpCampaignPublisherPlatformsLength = this.customRulesData.subCampaignsContent[i].pdData.publisher_platforms.length;

            if(_tmpCampaignPublisherPlatformsLength <= 0){
              isTrue = 0;

              _swalTitle = '自定義規則-'+stageName+'-版位與裝置';
              _swalText = '請至少設定一個平台。';
            }

            let _tmpCampaignDevicePlatformsLength = this.customRulesData.subCampaignsContent[i].pdData.device_platforms.length;

            if(_tmpCampaignDevicePlatformsLength <= 0){
              isTrue = 0;

              _swalTitle = '自定義規則-'+stageName+'-版位與裝置';
              _swalText = '請至少設定一個裝置。';
            }

            let _tmpCampaignCustomExcludedAudiencesSelectedLength = this.customRulesData.subCampaignsContent[i].exAudiencesData.custom_excluded_audiences_selected.length;
            let _tmpCampaignDefaultExcludedAudiencesLength = this.customRulesData.subCampaignsContent[i].exAudiencesData.default_excluded_audiences.length;

            let default_excluded_audiences_num = 0;
            if(_tmpCampaignDefaultExcludedAudiencesLength > 0){
              for (var e = 0; e < _tmpCampaignDefaultExcludedAudiencesLength; e++) {
                if(this.customRulesData.subCampaignsContent[i].exAudiencesData.default_excluded_audiences[e].checked == true){
                  default_excluded_audiences_num = parseInt(default_excluded_audiences_num) + parseInt(1);
                }
              }
            }

            let excluded_audiences_num = parseInt(_tmpCampaignCustomExcludedAudiencesSelectedLength) + parseInt(default_excluded_audiences_num);

            if(excluded_audiences_num > 10){
              isTrue = 0;

              _swalTitle = '自定義規則-'+stageName+'-關系鏈與受眾';
              _swalText = '最多只能設定 10 個。';
            }

            let _tmpCampaignLocationsLength = this.customRulesData.subCampaignsContent[i].localData.locations.length;
            let _tmpCampaignLocationRangeLength = this.customRulesData.subCampaignsContent[i].localData.location_range.length;

            if((_tmpCampaignLocationsLength == 0 || _tmpCampaignLocationsLength == '' || _tmpCampaignLocationsLength == null || typeof _tmpCampaignLocationsLength == 'undefined') && (_tmpCampaignLocationRangeLength == 0 || _tmpCampaignLocationRangeLength == '' || _tmpCampaignLocationRangeLength == null || typeof _tmpCampaignLocationRangeLength == 'undefined')){
              isTrue = 0;

              _swalTitle = '自定義規則-'+stageName+'-地點';
              _swalText = '請至少設定一個地點。';
            }

            // let _tmpCampaignRuleStopLength = this.customRulesData.subCampaignsContent[i].stopData.rule_stop.length;
            // for(let f = 0; f < _tmpCampaignRuleStopLength; f++){
            //   let shopValue = this.customRulesData.subCampaignsContent[i].stopData.rule_stop[f].num;
            //   if(shopValue == 0 || shopValue == '' || shopValue == null || typeof shopValue == 'undefined'){
            //     isTrue = 0;

            //     _swalTitle = '自定義規則-'+stageName+'-暫停條件';
            //     _swalText = '請每個規則條件都必須填寫值。';
            //   }
            // }

            // let _tmpCampaignRuleFrequencyLength = this.customRulesData.subCampaignsContent[i].forwardData.rule_frequency.length;
            // for(let f = 0; f < _tmpCampaignRuleFrequencyLength; f++){
            //   let frequencyValue = this.customRulesData.subCampaignsContent[i].forwardData.rule_frequency[f].num;
            //   if(frequencyValue == 0 || frequencyValue == '' || frequencyValue == null || typeof frequencyValue == 'undefined'){
            //     isTrue = 0;

            //     _swalTitle = '自定義規則-'+stageName+'-前進規則';
            //     _swalText = '請每個規則條件都必須填寫值。';
            //   }
            // }

            let _tmpCampaignEffect = this.customRulesData.subCampaignsContent[i].budgetData.effect;
            if(_tmpCampaignEffect == 0 || _tmpCampaignEffect == '' || _tmpCampaignEffect == null || typeof _tmpCampaignEffect == 'undefined'){
              isTrue = 0;

              _swalTitle = '自定義規則-'+stageName+'-目標成本';
              _swalText = '請填寫目標成本。';
            }

            let _tmpCampaignDailyBudget = this.customRulesData.subCampaignsContent[i].budgetData.daily_budget;
          //  console.log('_tmpCampaignDailyBudget');
          //  console.log(_tmpCampaignDailyBudget);
            if(_tmpCampaignDailyBudget == 0 || _tmpCampaignDailyBudget == '' || _tmpCampaignDailyBudget == null || typeof _tmpCampaignDailyBudget == 'undefined'){
              isTrue = 0;

              _swalTitle = '自定義規則-'+stageName+'-預算';
              _swalText = '請填寫預算。';
            }

            if(this.customRulesData.subCampaignsContent[i].method == 'META_KW'){
              let _tmpKeywordLength = this.customRulesData.subCampaignsContent[i].keywordData.keywords.length;
              let select_keywords_num = 0;

              for (let g = 0; g < _tmpKeywordLength; g++) {
                if(this.customRulesData.subCampaignsContent[i].keywordData.keywords[g].checked == true){
                  select_keywords_num = parseInt(select_keywords_num) + parseInt(1);
                }
              }

              if(select_keywords_num != 5){
                isTrue = 0;

                _swalTitle = '自定義規則-'+stageName+'-精準興趣廣告組合與關鍵字';
                _swalText = '關鍵字需選擇 5 個。';
              }
            }

            if(this.customRulesData.subCampaignsContent[i].method == 'META_LA'){
              let _tmpDefaultLookalikesListLength = this.customRulesData.subCampaignsContent[i].lookData.default_lookalikes_list.length;
              let lookalikes_num = 0;
              if(_tmpDefaultLookalikesListLength > 0){
                for (let l = 0; l < _tmpDefaultLookalikesListLength; l++) {
                  // console.log('i1:'+i);
                  if(this.customRulesData.subCampaignsContent[i].lookData.default_lookalikes_list[l].checked == true){
                    lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
                  }
                }
              }

              let _tmpCustomLookalikesSelectedLength = this.customRulesData.subCampaignsContent[i].lookData.custom_lookalikes_selected.length;
              if(_tmpCustomLookalikesSelectedLength > 0){
                for (let l = 0; l < _tmpCustomLookalikesSelectedLength; l++) {
                  // console.log('i2:'+i);
                  lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
                }
              }

              if(lookalikes_num != 5){
                isTrue = 0;

                _swalTitle = '自定義規則-'+stageName+'-類似受眾廣告組合網址';
                _swalText = '類似受眾需選擇 5 個。';
              }
            }

            if(this.customRulesData.subCampaignsContent[i].method == 'META_RT'){
              let _tmpDefaultAudiencesListLength = this.customRulesData.subCampaignsContent[i].audiencesData.default_audiences_list.length;
              let audiences_num = 0;
              if(_tmpDefaultAudiencesListLength > 0){
                for (let r = 0; r < _tmpDefaultAudiencesListLength; r++) {
                  // console.log('i1:'+i);
                  if(this.customRulesData.subCampaignsContent[i].audiencesData.default_audiences_list[r].checked == true){
                    audiences_num = parseInt(audiences_num) + parseInt(1);
                  }
                }
              }

              let _tmpCustomAudiencesSelectedLength = this.customRulesData.subCampaignsContent[i].audiencesData.custom_audiences_selected.length;
              if(_tmpCustomAudiencesSelectedLength > 0){
                for (let r = 0; r < _tmpCustomAudiencesSelectedLength; r++) {
                  // console.log('i2:'+i);
                  audiences_num = parseInt(audiences_num) + parseInt(1);
                }
              }

              if(audiences_num < 1){
                isTrue = 0;

                _swalTitle = '自定義規則-'+stageName+'-再行銷廣告組合';
                _swalText = '請至少選擇 1 個再行銷受眾。';
              }
            }

          //  console.log('isTrue');
          //  console.log(isTrue);
          //  console.log('_swalTitle');
          //  console.log(_swalTitle);
          //  console.log('_swalText');
          //  console.log(_swalText);

            if(isTrue == 1){
              let _tmpFormData = [];

              if(this.customRulesData.subCampaignsContent[i].method == 'META_TEST' && this.customRulesData.haveTest == true){
                // _tmpFormData['PreStage'] = [];
                _tmpFormData['ThisStage'] = this.customRulesData.subCampaignsContent[i];
              } else {
                let PreIndex = i - parseInt(1);
                // _tmpFormData['PreStage'] = this.customRulesData.subCampaignsContent[PreIndex];
                _tmpFormData['ThisStage'] = this.customRulesData.subCampaignsContent[i];
              }

              const promise = axios.post('https://www.autoturn.net/api/customize/data/campaign_subset_update_of_tree.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                date: this.dateData,
                stage: i,
                benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                useDoForward: this.doForwardData.useDoForward,
                sub_length: _tmpSubCampaignsContentLength,
                haveTest: this.customRulesData.haveTest,
                saveToStrategy: this.saveToStrategy,
                campaign_id: this.campaign_id,
                form_data: _tmpFormData,
              }))
              .then((response) => {
                if (response.data.status === 'success') {
                //  console.log('campaign_subset_update response');
                //  console.log(response);

                  // 正确更新 stageData 和 _campaign_writing_status
                  // Vue.set(this.customRulesData.subCampaignsContent[i].release, 'sr_i', parseInt(response.data.campaign_id));
                  this.customRulesData.subCampaignsContent[i].release.sr_i = parseInt(response.data.campaign_id);
                  this.customRulesData.subCampaignsContent[i].release.strategy_id = parseInt(response.data.strategy_sub_id);

                  if (response.data.campaign_id) {
                    _stageData[i] = parseInt(response.data.campaign_id);
                  }

                  if (response.data.strategy_sub_id) {
                    _stageStrategyData[i] = parseInt(response.data.strategy_sub_id);
                  }
                }
              })
              .catch((error) => {
                console.error(`Error in form_update stage ${i}:`, error);
              });

              promises.push(promise); // 將 promise 加入數組
            } else {
            //  console.log('in error');
              Swal.fire(
                _swalTitle,
                _swalText,
                "error"
              );

              this.nextLoading = false;
              this.showCampaignData = true;

              break;
            }
          }

          if(this.benefitsAndInvestmentData.toTaiwan === true){
            if(this.benefitsAndInvestmentData.person_or_business.value == 2){
              if(this.benefitsAndInvestmentData.benefits == '' || this.benefitsAndInvestmentData.benefits == null || typeof this.benefitsAndInvestmentData.benefits == 'undefined'){
                Swal.fire(
                          this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
                          '受益者不能為空。',
                          "error"
                        )
                isTrue = 0;
              }

              if(this.benefitsAndInvestmentData.investment == '' || this.benefitsAndInvestmentData.investment == null || typeof this.benefitsAndInvestmentData.investment == 'undefined'){
                Swal.fire(
                          this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
                          '出資者不能為空。',
                          "error"
                        )
                isTrue = 0;
              }
            } else {
              if((this.benefitsAndInvestmentData.beneficiary_id == '' || this.benefitsAndInvestmentData.beneficiary_id == null || typeof this.benefitsAndInvestmentData.beneficiary_id == 'undefined') && (this.benefitsAndInvestmentData.selectedBeneficiary == null || this.benefitsAndInvestmentData.selectedBeneficiary == '' || typeof this.benefitsAndInvestmentData.selectedBeneficiary == 'undefined')){
                Swal.fire(
                          this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
                          '請填寫受益者 ID',
                          "error"
                        )
                isTrue = 0;
              }

              if((this.benefitsAndInvestmentData.beneficiary_name == '' || this.benefitsAndInvestmentData.beneficiary_name == null || typeof this.benefitsAndInvestmentData.beneficiary_name == 'undefined') && (this.benefitsAndInvestmentData.selectedBeneficiary == null || this.benefitsAndInvestmentData.selectedBeneficiary == '' || typeof this.benefitsAndInvestmentData.selectedBeneficiary == 'undefined')){
                Swal.fire(
                          this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
                          '請填寫受益者 名稱',
                          "error"
                        )
                isTrue = 0;
              }

              if((this.benefitsAndInvestmentData.payer_id == '' || this.benefitsAndInvestmentData.payer_id == null || typeof this.benefitsAndInvestmentData.payer_id == 'undefined') && (this.benefitsAndInvestmentData.selectedPayer == null || this.benefitsAndInvestmentData.selectedPayer == '' || typeof this.benefitsAndInvestmentData.selectedPayer == 'undefined')){
                Swal.fire(
                          this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
                          '請填寫出資者 ID',
                          "error"
                        )
                isTrue = 0;
              }

              if((this.benefitsAndInvestmentData.payer_name == '' || this.benefitsAndInvestmentData.payer_name == null || typeof this.benefitsAndInvestmentData.payer_name == 'undefined') && (this.benefitsAndInvestmentData.selectedPayer == null || this.benefitsAndInvestmentData.selectedPayer == '' || typeof this.benefitsAndInvestmentData.selectedPayer == 'undefined')){
                Swal.fire(
                          this.showLang[this.selectLang]['components']['Event']['BenefitsAndInvestment']['title'],
                          '請填寫出資者 名稱',
                          "error"
                        )
                isTrue = 0;
              }
            }
          }

          if(isTrue == 1){
            await Promise.all(promises);

          //  console.log('All axios requests finished');
          //  console.log(_stageData);
          //  console.log(_stageData.length + '==' + _tmpSubCampaignsContentLength);

            // 在所有 axios 完成后，再执行以下逻辑
            if(_stageData.length == _tmpSubCampaignsContentLength){
              var daily_keyword_split_budget = this.methodData.Budget_KW;
              var daily_demo_budget = this.methodData.Budget_DM;
              var budget_addition = this.goalsData.form_addition;

              this.total_budget = 0;

              let _tmp_goalsData = this.goalsData;
              const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
              let _tmp_exAudiencesData = this.exAudiencesData;
              const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

              // console.log(_tmp_exAudiencesData);

              delete _view_goalsData['objective_list'];
              delete _view_exAudiencesData['custom_excluded_audiences'];

              let formData = {
                campaign_id: this.campaign_id,
                strategy_id: this.strategyId,
                campaign_name: this.campaign_name,
                adaccount_id: this.adaccount_id,
                Budget_KW_result: this.Budget_KW_result,
                total_budget: this.total_budget,
                dynBudgetData: this.dynBudgetData,
                doForwardData: this.doForwardData,
                methodData: this.methodData,
                benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                dateData: this.dateData,
                keywordData: this.keywordData,
                lookData: this.lookData,
                audiencesData: this.audiencesData,
                goalsData: _view_goalsData,
                regionsData: this.regionsData,
                selectCountries: this.selectCountries,
                selectLangs: this.selectLangs,
                exAudiencesData: _view_exAudiencesData,
                pdData: this.pdData,
                idData: this.idData,
                postData: this.postData,
                adMaterialData: this.adMaterialDataNew,
                stageData: _stageData,
                stageStrategyData: _stageStrategyData,
                saveToStrategy: this.saveToStrategy,
              }

            //  console.log('warning formData');
            //  console.log(formData);

              let adaccount_id = this.adaccount_id

              axios
                .post('https://www.autoturn.net/api/customize/data/campaign_update_of_tree.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  form_data: formData,
                  type: 'release',
                  target: 'edit_release_'+this.target,
                }))
                .then((response) => {
                  this.strategyId = response.data.strategy_id;

                  if(response.data.status == 'success'){
                    if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                      let _tableContent = '<div class="table">\
                                      <div class="row">\
                                        <div class="cell header">階段</div>\
                                        <div class="cell header">目標</div>\
                                        <div class="cell header">預算</div>\
                                      </div>';

                      let _currency = this.currencyData.currency
                      for(let j = 0; j < _tmpSubCampaignsContentLength; j++){
                        let _methodName = this.methodName(this.customRulesData.subCampaignsContent[j].method);
                        let _objectiveName = this.objectiveName(this.customRulesData.subCampaignsContent[j].goalsData.campaign_objective);
                        let _budget = '<b>'+this.customRulesData.subCampaignsContent[j].budgetData.daily_budget+'</b><span style="font-size:14px; margin-left:4px; margin-top:4px;">'+_currency+'/day</span>';

                        _tableContent += '<div class="row">\
                                            <div class="cell">'+_methodName+'</div>\
                                            <div class="cell">'+_objectiveName+'</div>\
                                            <div class="cell">'+_budget+'</div>\
                                          </div>';
                      }

                      _tableContent += '</div>';
                      _tableContent += "<b style='color:red;'>請勿在Facebook廣告後台修改行銷活動設定、受眾資料(AutoTurn開頭)，<br/>若修改到系統便會暫停自動化</b><br/>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_c'];

                      Swal.fire({
                        title: '自定義規則 - 發布',
                        html: _tableContent,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        width: 'auto', // 可選：根據內容自動調整寬度
                        padding: '1em',
                        confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['yes_button'],
                        cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['no_button'],
                      }).then((result) => {
                        if (result.isConfirmed) {
                          ////////campaign_release
                          this.releaseType = true
                          this.style = 'z-index:100;';
                          this.releasePercent = 5;
                          let status = 1;
                          let num = 0;
                          let member_hash = this.$route.params.id;
                          var bar5 = new ldBar("#myItem5");
                          bar5.set(this.releasePercent);

                          axios
                            .post('https://www.autoturn.net/api/customize/campaign/campaign_release.php', Qs.stringify({
                              s_code: member_hash,
                              campaign_id: this.campaign_id,
                            }))
                            .then((caResponse) => {
                              // console.log('caResponse:'+caResponse.data.return_data);
                              if(caResponse.data.status == 'success'){
                                // console.log('#20');
                                //進行進度條
                                // console.log('發佈莞成，開始跑進度條');
                                let taskId = caResponse.data.id;

                                setInterval( () => {
                                  num++;
                                  if(num < 1200){
                                    // console.log('num:'+num);
                                    // console.log(this.releaseType);

                                    if(this.releaseType == true){
                                      axios
                                        .post('https://www.autoturn.net/api/customize/campaign/campaign_task.php', Qs.stringify({
                                          s_code: member_hash,
                                          id: taskId,
                                        }))
                                        .then((csResponse) => {
                                          // console.log('csResponse:'+csResponse.data.return_data);
                                          //進行進度條
                                          if(status == 1){
                                            if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                              this.releaseType = false
                                              this.style = 'z-index:-1;';
                                              bar5.set(0);
                                              status = 0;
                                              // Swal.fire({
                                              //   icon: 'error',
                                              //   title: '正式發佈',
                                              //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                              //   showDenyButton: false,
                                              //   showCancelButton: false,
                                              //   confirmButtonText: '確定',
                                              //   timer: 5000
                                              //   // denyButtonText: `Don't save`,
                                              // }).then((result) => {
                                              //   /* Read more about isConfirmed, isDenied below */
                                              //   if (result.isConfirmed) {
                                              //     // Swal.fire('Saved!', '', 'success')
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   } else if (result.isDenied) {
                                              //     // Swal.fire('Changes are not saved', '', 'info')
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   }

                                              //   if (result.dismiss === Swal.DismissReason.timer) {
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   }
                                              // })

                                              let _tableContent = '<br/><div class="return_table">\
                                                              <div class="return_row">\
                                                                <div class="cell_stage return_header">階段名稱</div>\
                                                                <div class="cell_content return_header">發布結果</div>\
                                                              </div>';

                                              for(let j = 0; j < _tmpSubCampaignsContentLength; j++){
                                                let _methodName = this.methodName(this.customRulesData.subCampaignsContent[j].method);
                                                let _releaseContent = csResponse.data.sub_campaigns[this.customRulesData.subCampaignsContent[j].release.sr_i].current;
                                                let stageIndex = j;
                                                let stageTitle = _methodName;
                                                if(this.customRulesData.subCampaignsContent[0].method != 'META_TEST'){
                                                  stageIndex = j + parseInt(1);
                                                  stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                                } else {
                                                  if(j != 0){
                                                    stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                                  }
                                                }

                                                _tableContent += '<div class="return_row">\
                                                                    <div class="cell_stage">'+stageTitle+'</div>\
                                                                    <div class="cell_content">'+_releaseContent+'</div>\
                                                                  </div>';
                                              }

                                              _tableContent += '</div>';

                                              Swal.fire({
                                                icon: 'error',
                                                title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                html: '發布失敗，請參考下列各階段的發布結果，來進行調整：<br/>'+_tableContent,
                                                showDenyButton: false,
                                                showCancelButton: false,
                                                width: 'auto',
                                                padding: '1em',
                                                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                              }).then((result) => {
                                              //  console.log('#1');
                                                let info_text = csResponse.data.return_data.info_text;
                                                let tosStatus = info_text.includes("/leadgen/tos");
                                                if(tosStatus == true){
                                                  window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                                }
                                              })
                                            } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                              status = 0;

                                              let postData = {adaccount_id: this.$route.params.adaccount_id};
                                              let codeHash = ['de', 'di']

                                              const data = new URLSearchParams();
                                              data.append('s_code', this.$route.params.id);
                                              data.append('post_data', JSON.stringify(postData));
                                              data.append('code_hash', JSON.stringify(codeHash));
                                              data.append('update_type', true);

                                              // 發送請求
                                              navigator.sendBeacon(
                                                'https://www.autoturn.net/api/customize/campaign/update_cache.php',
                                                data
                                              );

                                              axios
                                                .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                  s_code: member_hash,
                                                  id: this.campaign_id,
                                                }))
                                                .then((response) => {
                                                  axios
                                                    .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
                                                    .then((csResponse) => {
                                                      this.releaseType = false

                                                      Swal.fire({
                                                        icon: 'success',
                                                        title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                        text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                        showDenyButton: false,
                                                        showCancelButton: false,
                                                        confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                        timer: 5000
                                                        // denyButtonText: `Don't save`,
                                                      }).then((result) => {
                                                        /* Read more about isConfirmed, isDenied below */
                                                        if (result.isConfirmed) {
                                                          // Swal.fire('Saved!', '', 'success')
                                                          this.allPageLoading = true
                                                          window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                                        } else if (result.isDenied) {
                                                          // Swal.fire('Changes are not saved', '', 'info')
                                                          this.allPageLoading = true
                                                          window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                                        }

                                                        if (result.dismiss === Swal.DismissReason.timer) {
                                                          this.allPageLoading = true
                                                          window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                                        }
                                                      })
                                                    });
                                                });
                                            } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                              this.releaseType = false
                                              this.style = 'z-index:-1;';
                                              bar5.set(0);
                                              status = 0;
                                              // Swal.fire({
                                              //   icon: 'error',
                                              //   title: '正式發佈',
                                              //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                              //   showDenyButton: false,
                                              //   showCancelButton: false,
                                              //   confirmButtonText: '確定',
                                              //   timer: 5000
                                              //   // denyButtonText: `Don't save`,
                                              // }).then((result) => {
                                              //   /* Read more about isConfirmed, isDenied below */
                                              //   if (result.isConfirmed) {
                                              //     // Swal.fire('Saved!', '', 'success')
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   } else if (result.isDenied) {
                                              //     // Swal.fire('Changes are not saved', '', 'info')
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   }

                                              //   if (result.dismiss === Swal.DismissReason.timer) {
                                              //     this.allPageLoading = true
                                              //     window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                              //   }
                                              // })

                                              let _tableContent = '<br/><div class="return_table">\
                                                              <div class="return_row">\
                                                                <div class="cell_stage return_header">階段名稱</div>\
                                                                <div class="cell_content return_header">發布結果</div>\
                                                              </div>';

                                              for(let j = 0; j < _tmpSubCampaignsContentLength; j++){
                                                let _methodName = this.methodName(this.customRulesData.subCampaignsContent[j].method);
                                                let _releaseContent = csResponse.data.sub_campaigns[this.customRulesData.subCampaignsContent[j].release.sr_i].current;
                                                let stageIndex = j;
                                                let stageTitle = _methodName;
                                                if(this.customRulesData.subCampaignsContent[0].method != 'META_TEST'){
                                                  stageIndex = j + parseInt(1);
                                                  stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                                } else {
                                                  if(j != 0){
                                                    stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                                  }
                                                }

                                                _tableContent += '<div class="return_row">\
                                                                    <div class="cell_stage">'+stageTitle+'</div>\
                                                                    <div class="cell_content">'+_releaseContent+'</div>\
                                                                  </div>';
                                              }

                                              _tableContent += '</div>';

                                              Swal.fire({
                                                icon: 'error',
                                                title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                html: '發布失敗，請參考下列各階段的發布結果，來進行調整：<br/>'+_tableContent,
                                                showDenyButton: false,
                                                showCancelButton: false,
                                                width: 'auto',
                                                padding: '1em',
                                                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                              }).then((result) => {
                                              //  console.log('#2');
                                                let info_text = csResponse.data.return_data.info_text;
                                                let tosStatus = info_text.includes("/leadgen/tos");
                                                if(tosStatus == true){
                                                  window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                                }
                                              })
                                            } else {
                                              this.releaseText = csResponse.data.return_data.current
                                              this.releasePercent = csResponse.data.return_data.pct

                                              bar5.set(this.releasePercent);
                                              // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                              // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                              // console.log('this.releaseText:'+this.releaseText);
                                              // console.log('this.releasePercent:'+this.releasePercent);

                                              if(csResponse.data.return_data.pct == 100){
                                                this.releaseType = false
                                                this.style = 'z-index:-1;';
                                                bar5.set(0);
                                                status = 0;
                                              }
                                            }
                                          }
                                        });
                                    }
                                  } else {
                                    Swal.fire({
                                      icon: 'warning',
                                      title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_title'],
                                      text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_html'],
                                      showDenyButton: false,
                                      showCancelButton: false,
                                      confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                      timer: 1000
                                      // denyButtonText: `Don't save`,
                                    }).then((result) => {
                                      /* Read more about isConfirmed, isDenied below */
                                      if (result.isConfirmed) {
                                        // Swal.fire('Saved!', '', 'success')
                                        this.allPageLoading = true
                                        window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                      } else if (result.isDenied) {
                                        // Swal.fire('Changes are not saved', '', 'info')
                                        this.allPageLoading = true
                                        window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                      }

                                      if (result.dismiss === Swal.DismissReason.timer) {
                                        this.allPageLoading = true
                                        window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                                      }
                                    })
                                  }
                                }, 3000);
                              }
                            });
                        }
                      });
                    } else {
                      Swal.fire(
                        this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['not_success']['swal_title'],
                        response.data.info,
                        'error'
                      )
                    }

                  } else {
                    let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_default_swal_text'];
                    if(response.data.info != '' && response.data.info != null){
                      text = response.data.info
                    }
                    Swal.fire(
                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_swal_title'],
                      text,
                      'error'
                    )
                  }

                  this.nextLoading = false;
                  this.showCampaignData = true;
                });
            } else {
              Swal.fire({
                          icon: 'error',
                          title: '自定義規則-發布',
                          html: '資料更新失敗，請稍候再嘗試。',
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: 'OK',
                        });

              this.nextLoading = false;
              this.showCampaignData = true;

            //  console.log('customizeSave customize error end');
            //  console.log(this.customRulesData);
            }
          }
        }
      },
      customize(){
      //  console.log('customize');
        let member_hash = this.$route.params.id
        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_member_status.php', Qs.stringify({
            s_code: member_hash,
            route_type: this.$route.params.type,
            active: 'release',
            use_exp_cust: this.useExperienceCustomize,
          }))
          .then((caResponse) => {
            let _swal = [];

            if(caResponse.data.status == 'error'){
              // console.log('#14');
              if(caResponse.data.type == 2){
                Swal.fire({
                  icon: caResponse.data.status,
                  title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    this.allPageLoading = true
                    window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    this.allPageLoading = true
                    window.location.href = "https://private.autoturn.net/customize-events-list/f/"+member_hash+"/"+adaccount_id;
                  }
                })
              } else if(caResponse.data.type == 3){
                Swal.fire({
                  icon: caResponse.data.status,
                  title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    this.allPageLoading = true
                    window.location.href = "https://private.autoturn.net/f/"+member_hash;
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    this.allPageLoading = true
                    window.location.href = "https://private.autoturn.net/f/"+member_hash;
                  }
                })
              } else {
                Swal.fire(
                          this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['swal_title'],
                          caResponse.data.info,
                          caResponse.data.status
                        )
              }
            }

            if(caResponse.data.status == 'warning' || caResponse.data.status == 'success'){
              // this.customizeSave(caResponse.data.status);
              this.customizeTreeSave(caResponse.data.status);
            }

            if(caResponse.data.status == 'login'){
              Swal.fire({
                icon: 'error',
                title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['login']['swal_title'],
                text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['login']['swal_text'],
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['login']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                }
              })
            }
          });
      },
    },
    mounted () {
      // document.title = '行銷活動修改頁 - AutoTurn';
    },
    computed: {
      viewAdMaterialDatalist: {
        get() {
          if (
            this.stageTreeContent[this.activeStageTreeNodeIndex] &&
            this.stageTreeContent[this.activeStageTreeNodeIndex][this.activeStageTreeItemIndex]
          ) {
            return this.stageTreeContent[this.activeStageTreeNodeIndex][this.activeStageTreeItemIndex].adMaterialData;
          }
          return [];
        },
        set(value) {
          if (
            this.stageTreeContent[this.activeStageTreeNodeIndex] &&
            this.stageTreeContent[this.activeStageTreeNodeIndex][this.activeStageTreeItemIndex]
          ) {
            this.stageTreeContent[this.activeStageTreeNodeIndex][this.activeStageTreeItemIndex].adMaterialData = value;
          }
        },
      },
    },
  }
</script>

<style lang="scss" scope>
  .progressbar {
    background: linear-gradient(270.01deg, #1D619F 0%, #7FDCFA 51.04%, #7AD5C0 76.56%);
    border-radius: 6px;
  }

  .table {
    display: flex;
    flex-wrap: wrap;
    width: 800px; /* 表格的寬度 */
    border: 1px solid #ccc; /* 表格邊框 */
  }
  .return_table {
    display: flex;
    flex-wrap: wrap;
    width: 800px; /* 表格的寬度 */
  }
  .row, .return_row {
    display: flex;
    width: 100%;
  }
  .cell, .cell_stage {
    width: 33.33%;
    height: auto; /* 單元格的高度 */
    border: 1px solid #ccc; /* 單元格邊框 */
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 18px 4px;
  }
  .cell_content {
    width: 66.67%;
    height: auto; /* 單元格的高度 */
    border: 1px solid #ccc; /* 單元格邊框 */
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 18px 4px;
  }
  .header, .return_header {
    background-color: #CBD5E1;
  }
</style>
